// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   InstallationPlanning.css  –  Professional calendar styles
═══════════════════════════════════════════════════════════════ */

/* ─── Breadcrumb Navigation ────────────────────────────────── */
.installation-planning .breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #64748b;
}

.installation-planning .breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #3b82f6;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.installation-planning .breadcrumb-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.installation-planning .breadcrumb-separator {
  color: #94a3b8;
  -webkit-user-select: none;
          user-select: none;
}

.installation-planning .breadcrumb-current {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #0f172a;
  font-weight: 500;
}

.installation-planning .breadcrumb-icon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  stroke-width: 1.9;
}

/* ─── Full-height page layout ──────────────────────────────── */
/*
  Overhead offsets:
    60px  – top navbar
    48px  – main-content padding (24px × 2)
    58px  – .page-header (h2 + margin-bottom)
    69px  – .tab-bar (height + margin-bottom)
    66px  – .calendar-toolbar (height + margin-bottom)
    44px  – .calendar-legend (height + margin)
    40px  – .calendar-week-header (row with day names)
  ≈ 385px total before calendar cells
*/

.installation-planning.page-container {
  max-width: none;         /* use full page width */
}

/* Month view: cells fill available viewport height */
.calendar-cell {
  min-height: max(90px, calc((100vh - 385px) / 6));
}

/* Week view: columns fill viewport height */
.week-day-col {
  min-height: max(300px, calc(100vh - 310px));
}

/* Day view: fill viewport height */
.calendar-day {
  min-height: max(300px, calc(100vh - 310px));
}

/* ─── Tab bar ──────────────────────────────────────────────── */
.tab-bar {
  display: flex;
  gap: 2px;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 24px;
}
.tab-btn {
  padding: 11px 22px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  border-radius: 6px 6px 0 0;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.tab-btn:hover { color: #2563eb; background: #f0f7ff; }
.tab-btn.active { color: #2563eb; border-bottom-color: #2563eb; font-weight: 700; }

/* ─── Calendar toolbar ─────────────────────────────────────── */
.installation-days-picker {
  grid-column: 1 / -1;
  min-width: 0;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px;
}
.installation-days-picker p { margin: 0 0 10px; font-size: 13px; color: #475569; }
.installation-days-options { display: flex; gap: 10px; flex-wrap: wrap; max-height: 240px; overflow-y: auto; }
.form-grid .installation-days-options label {
  display: inline-flex; flex-direction: row; align-items: center; gap: 8px;
  padding: 8px; background: #f8fafc; border-radius: 6px; cursor: pointer;
}
.form-grid .installation-days-options input[type="checkbox"] {
  width: 18px; height: 18px; flex: 0 0 18px; margin: 0; padding: 0; accent-color: #2563eb;
}

.calendar-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.view-switcher {
  display: flex;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.btn-view {
  padding: 7px 16px;
  border: none;
  border-right: 1.5px solid #cbd5e1;
  background: #f8fafc;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  transition: all 0.15s;
}
.btn-view:last-child { border-right: none; }
.btn-view:hover { background: #e2e8f0; }
.btn-view.active { background: #2563eb; color: #fff; font-weight: 700; }

.nav-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  padding: 4px 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.btn-nav {
  background: none;
  border: none;
  border-radius: 6px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  color: #475569;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.1s;
}
.btn-nav:hover { background: #e2e8f0; }
.current-label {
  font-weight: 700;
  font-size: 15px;
  min-width: 220px;
  text-align: center;
  color: #1e293b;
  letter-spacing: -0.01em;
}

.calendar-order-search {
  position: relative;
  min-width: 260px;
}

.calendar-order-search-controls {
  display: flex;
  gap: 6px;
}

.calendar-order-search-controls input {
  width: 210px;
  padding: 7px 10px;
  border: 1.5px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
}

.calendar-order-search-controls input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.calendar-order-search-status {
  position: absolute;
  z-index: 45;
  top: calc(100% + 5px);
  left: 0;
  width: max-content;
  max-width: 360px;
  padding: 7px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  background: #eff6ff;
  color: #1d4ed8;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
  font-size: 12px;
}

.calendar-order-search-status.success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.calendar-order-search-status.error {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.order-number-suggestions {
  position: absolute;
  z-index: 50;
  top: calc(100% + 5px);
  left: 0;
  width: min(430px, 90vw);
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);
}

.calendar-order-search-status + .order-number-suggestions {
  top: calc(100% + 36px);
}

.order-number-suggestion-row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e2e8f0;
}

.order-number-suggestion-row:last-child {
  border-bottom: 0;
}

.order-number-suggestion-main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
  padding: 9px 12px;
  border: 0;
  background: #fff;
  color: #1e293b;
  text-align: left;
  cursor: pointer;
}

.order-number-suggestion-main:hover {
  background: #eff6ff;
}

.order-number-suggestions span {
  color: #64748b;
  font-size: 12px;
}

.order-number-suggestions .order-number-suggestion-note {
  display: block;
  max-width: 100%;
  overflow: hidden;
  color: #475569;
  font-style: italic;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-number-suggestion-add {
  width: 42px;
  border: 0;
  border-left: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #2563eb;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
}

.order-number-suggestion-add:hover {
  background: #dbeafe;
}

.daily-print-menu {
  position: relative;
  display: flex;
  align-items: center;
}

.quick-add-menu {
  position: relative;
  display: flex;
  align-items: center;
}

.calendar-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-wrap: wrap;
}

.calendar-toolbar-actions > .btn-sm,
.calendar-toolbar-actions > .daily-print-menu > .btn-sm,
.calendar-toolbar-actions > .quick-add-menu > .btn-sm,
.calendar-toolbar-checkbox {
  min-height: 36px;
  box-sizing: border-box;
  font-size: 14px;
}

.calendar-toolbar-actions > .btn-sm,
.calendar-toolbar-actions > .daily-print-menu > .btn-sm,
.calendar-toolbar-actions > .quick-add-menu > .btn-sm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 12px;
  white-space: nowrap;
}

.calendar-toolbar-actions .calendar-toolbar-action-button {
  width: 160px;
  height: 36px;
  min-height: 36px;
  padding: 7px 12px !important;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 1.2;
}

.calendar-toolbar-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  line-height: 1;
}

.calendar-toolbar-checkbox input[type="checkbox"] {
  width: 19px;
  height: 19px;
  margin: 0;
  flex: 0 0 19px;
  cursor: pointer;
  accent-color: #2563eb;
}

.daily-print-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 40;
  min-width: 270px;
  padding: 12px;
  background: #fff;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
}

.daily-print-dropdown label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
}

.daily-print-dropdown input[type="date"] {
  height: 32px;
  width: 100%;
  padding: 5px 8px;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
}

.daily-print-dropdown .btn-sm {
  width: 100%;
  margin-top: 10px;
}

.daily-print-count {
  margin-top: 8px;
  font-size: 12px;
  color: #64748b;
}

.daily-print-dropdown .daily-print-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 10px;
}

.daily-print-dropdown .daily-print-options .btn-sm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  margin-top: 0;
  gap: 2px;
}

.daily-print-options small {
  font-size: 9px;
  font-weight: 400;
  opacity: 0.85;
}

.daily-print-dropdown .daily-print-options .daily-print-amounts {
  grid-column: 1 / -1;
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
}

.daily-print-error {
  margin-top: 9px;
  color: #b91c1c;
  font-size: 12px;
  line-height: 1.35;
}

/* ─── Legend ───────────────────────────────────────────────── */
.calendar-legend {
  display: flex;
  gap: 20px;
  margin-bottom: 14px;
  font-size: 12px;
  color: #475569;
  flex-wrap: wrap;
  align-items: center;
}
.legend-item { display: flex; align-items: center; gap: 7px; font-weight: 500; }
.legend-dot {
  width: 14px; height: 14px;
  border-radius: 4px;
  display: inline-block;
  flex-shrink: 0;
}

/* ─── MONTH VIEW ───────────────────────────────────────────── */
.calendar-month {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1.5px solid #d1d5db;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);
}
.calendar-week-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #f9fafb;
  border-bottom: 2px solid #d1d5db;
}
.calendar-day-name {
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  padding: 12px 6px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #ffffff;
  gap: 0;
  border-left: 1.5px solid #d1d5db;
  border-top: 1.5px solid #d1d5db;
}
.calendar-cell {
  background: #ffffff;
  padding: 8px;
  position: relative;
  transition: background 0.12s;
  cursor: default;
  border-right: 1.5px solid #d1d5db;
  border-bottom: 1.5px solid #d1d5db;
}
.calendar-cell:hover { background: #f3f4f6; }
.calendar-cell.other-month { background: #fafafa; }
.calendar-cell.other-month .cell-day-number { color: #d1d5db; }
.calendar-cell.today { background: #eff6ff; }
.calendar-cell.drag-over {
  background: #dbeafe !important;
  outline: 2px dashed #3b82f6;
  outline-offset: -2px;
  box-shadow: inset 0 0 12px rgba(59, 130, 246, 0.15);
  transition: all 0.2s ease;
}
.cell-day-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  width: 28px; height: 28px;
  border-radius: 50%;
  margin-bottom: 4px;
}
.calendar-cell.today .cell-day-number {
  background: #2563eb;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(37,99,235,0.40);
}
.cell-installations { display: flex; flex-direction: column; gap: 3px; }
.team-group-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 3px;
  background: #f8fafc;
  border-radius: 4px;
  border-left: 3px solid #3b82f6;
}
.team-group-section.unassigned-section {
  background: #fef3c7;
  border-left-color: #f59e0b;
}
.team-group-label {
  font-size: 9px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
  padding: 0 2px;
}
.unassigned-section .team-group-label {
  color: #92400e;
}
.more-badge {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
  padding: 1px 6px;
  background: #f1f5f9;
  border-radius: 4px;
  width: fit-content;
  margin-top: 1px;
}

/* ─── WEEK VIEW ────────────────────────────────────────────── */
.calendar-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border: 1.5px solid #d1d5db;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);
  background: #d1d5db;
  gap: 1px;
}
.week-day-col {
  background: #ffffff;
  display: flex;
  flex-direction: column;
}
.week-day-col.today { background: #f0f7ff; }
.week-day-col.drag-over {
  background: #dbeafe !important;
  outline: 2px dashed #3b82f6;
  outline-offset: -2px;
  transition: all 0.2s ease;
}
.week-day-header {
  padding: 12px 8px 10px;
  text-align: center;
  border-bottom: 2px solid #d1d5db;
  background: #f9fafb;
}
.week-day-col.today .week-day-header {
  background: #eff6ff;
  border-bottom-color: #bfdbfe;
}
.week-day-name {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.week-day-col.today .week-day-name { color: #2563eb; }
.week-day-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  width: 40px; height: 40px;
  border-radius: 50%;
}
.week-day-num.today-num {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(37,99,235,0.40);
}
.week-day-body {
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}

/* ─── DAY VIEW ─────────────────────────────────────────────── */
.calendar-day {
  border: 1.5px solid #d1d5db;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}
.calendar-day.drag-over {
  background: #dbeafe;
  outline: 2px dashed #3b82f6;
  outline-offset: -2px;
  transition: all 0.2s ease;
}
.day-header {
  background: #f9fafb;
  padding: 18px 24px;
  border-bottom: 2px solid #d1d5db;
}
.day-date-label { font-size: 20px; font-weight: 700; color: #111827; }
.day-body { padding: 16px; display: flex; flex-direction: column; gap: 8px; }
.day-empty { color: #9ca3af; font-style: italic; padding: 20px 0; }

/* ─── Installation card – compact (on calendar grid) ───────── */
.installation-card {
  padding: 3px 7px 4px 9px;
  border-radius: 5px;
  background: #fff;
  border: 1.5px solid #94a3b8;
  border-left: 6px solid #94a3b8;
  cursor: grab;
  overflow: visible;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: box-shadow 0.12s, transform 0.08s;
  display: flex;
  flex-direction: column;
  gap: 1px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.09);
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.installation-card:hover {
  box-shadow: 0 3px 10px rgba(0,0,0,0.16);
  transform: translateY(-1px);
}
.installation-card:active { cursor: grabbing; transform: scale(0.97); opacity: 0.85; }

.installation-card--note {
  cursor: pointer;
  white-space: normal;
}

.installation-card--note:active {
  cursor: pointer;
}

.installation-card--note .card-order {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 1.3;
}

.installation-card--note .card-note-description {
  display: -webkit-box;
  overflow: hidden;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  color: #475569;
  font-size: 10px;
  line-height: 1.3;
}

.calendar-note-icon {
  margin-right: 4px;
}

.team-installation-order-item {
  display: flex;
  align-items: stretch;
  gap: 3px;
  min-width: 0;
}

.team-installation-order-item .installation-card {
  flex: 1 1;
  min-width: 0;
}

.team-installation-order-controls {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 0 0 22px;
}

.team-installation-order-controls button {
  flex: 1 1;
  min-height: 18px;
  padding: 0;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.team-installation-order-controls button:hover:not(:disabled) {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

.team-installation-order-controls button:disabled {
  opacity: 0.35;
  cursor: default;
}

.team-order-error {
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #fecaca;
  border-radius: 6px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 12px;
}

.team-day-comment {
  display: -webkit-box;
  margin-bottom: 3px;
  padding: 4px 6px;
  overflow: hidden;
  border: 1px solid #fbbf24;
  border-radius: 5px;
  background: #fffbeb;
  color: #78350f;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  white-space: normal;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.team-day-comment span {
  margin-right: 3px;
}

.team-vacation-comment {
  margin-bottom: 3px;
  padding: 4px 6px;
  overflow-wrap: anywhere;
  border: 1px solid;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.3;
}

.team-vacation-comment.planned {
  border-color: #f59e0b;
  background: #fef3c7;
  color: #92400e;
}

.team-vacation-comment.approved {
  border-color: #ef4444;
  background: #fee2e2;
  color: #991b1b;
}

.team-comment-modal {
  width: min(520px, 94vw);
}

.team-comment-label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #475569;
  font-size: 13px;
}

.team-comment-label textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  resize: vertical;
  border: 1.5px solid #cbd5e1;
  border-radius: 7px;
  color: #1e293b;
  font: inherit;
  line-height: 1.45;
}

.team-comment-label textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.team-comment-copy-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
}

.team-comment-copy-controls span {
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
}

.team-comment-calendar-toggle {
  padding: 7px 10px;
}

.team-comment-date-picker {
  margin-top: 10px;
}

.team-comment-date-picker .source-date {
  box-shadow: inset 0 0 0 2px #1d4ed8;
}

.team-comment-team-picker {
  margin: 14px 0 0;
  padding: 10px 12px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
}

.team-comment-team-picker legend {
  padding: 0 5px;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.team-comment-team-picker > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
  max-height: 150px;
  overflow-y: auto;
}

.team-comment-team-picker label {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  color: #334155;
  font-size: 13px;
}

.team-comment-team-picker label span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-comment-settlement-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 14px;
  padding: 10px 12px;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  background: #eff6ff;
  color: #1e3a8a;
  cursor: pointer;
}

.team-comment-settlement-option input {
  margin-top: 3px;
}

.team-comment-settlement-option span {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.team-comment-settlement-option small {
  color: #475569;
  line-height: 1.35;
}

.team-comment-conversion-prompt {
  margin-top: 12px;
  padding: 16px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #f8fbff;
  color: #1e3a8a;
  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.08);
}

.team-comment-conversion-prompt__copy {
  display: flex;
  align-items: flex-start;
  gap: 11px;
}

.team-comment-conversion-prompt__copy > div {
  min-width: 0;
}

.team-comment-conversion-prompt__copy strong {
  display: block;
  color: #1e3a8a;
  font-size: 15px;
}

.team-comment-conversion-prompt__icon {
  display: grid;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 50%;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 14px;
  font-weight: 800;
}

.team-comment-conversion-prompt p {
  margin: 4px 0 0;
  color: #475569;
  font-size: 13px;
  line-height: 1.4;
}

.team-comment-conversion-prompt__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.team-comment-conversion-prompt__actions button {
  width: auto;
  min-width: 0;
  margin-top: 0;
  padding: 8px 13px;
  line-height: 1.25;
  white-space: nowrap;
}

.team-comment-conversion-prompt__cancel {
  margin-right: auto !important;
  border-color: transparent !important;
  background: transparent !important;
}

.team-comment-conversion-prompt__single {
  border-color: #93c5fd !important;
  background: #fff !important;
  color: #1d4ed8 !important;
}

.team-comment-conversion-prompt__all {
  background: #2563eb !important;
  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.25) !important;
}

.team-comment-deletion-prompt {
  border-color: #fecaca;
  background: #fffafa;
  box-shadow: 0 4px 14px rgba(185, 28, 28, 0.08);
}

.team-comment-deletion-prompt .team-comment-conversion-prompt__copy strong {
  color: #991b1b;
}

.team-comment-deletion-prompt .team-comment-conversion-prompt__icon {
  background: #fee2e2;
  color: #b91c1c;
}

.team-comment-deletion-prompt__all {
  background: #dc2626 !important;
  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.25) !important;
}

@media (max-width: 560px) {
  .team-comment-team-picker > div {
    grid-template-columns: 1fr;
  }

  .team-comment-conversion-prompt__actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .team-comment-conversion-prompt__actions button {
    width: 100%;
  }

  .team-comment-conversion-prompt__cancel {
    margin-right: 0 !important;
  }
}

.installation-card.installation-search-highlight,
.unscheduled-row.installation-search-highlight {
  animation: installation-search-pulse 1s ease-in-out 3;
  outline: 3px solid #2563eb;
  outline-offset: 2px;
  background: #dbeafe !important;
}

@keyframes installation-search-pulse {
  0%, 100% { box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25); }
  50% { box-shadow: 0 0 0 8px rgba(37, 99, 235, 0.08); }
}
.card-order {
  font-weight: 700; display: block;
  overflow: hidden; text-overflow: ellipsis;
  color: #1e293b; font-size: 11px;
}
.card-contractor {
  font-size: 10px; color: #475569;
  display: block; overflow: hidden; text-overflow: ellipsis;
}
.card-address {
  font-size: 10px; color: #64748b;
  display: block; overflow: hidden; text-overflow: ellipsis;
}
.card-wh {
  font-size: 10px; color: #334155; font-weight: 600;
  display: block; overflow: hidden; text-overflow: ellipsis;
}
.card-date { font-size: 10px; color: #94a3b8; display: block; }

/* ─── Installation card – full (unscheduled panel) ─────────── */
.installation-card--full {
  padding: 10px 14px 10px 13px;
  border-left-width: 5px;
  border-width: 1.5px;
  border-left-width: 5px;
  font-size: 13px;
  white-space: normal;
  min-width: 180px;
  max-width: 220px;
  flex-shrink: 0;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.installation-card--full .card-order { font-size: 13px; }
.installation-card--full .card-contractor { font-size: 12px; }
.installation-card--full .card-address { font-size: 11px; }
.installation-card--full .card-date { font-size: 11px; }

/* ─── High perimeter warning (suma obwodów > 80) ───────────── */
.installation-card.high-perimeter {
  border-top: 2px solid #f59e0b;
  background: #fffbeb;
}
.card-perimeter-warning {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  color: #b45309;
  background: #fef3c7;
  padding: 2px 6px;
  border-radius: 4px;
  margin-top: 2px;
  border: 1px solid #fbbf24;
}

/* ─── Equipment badges on cards ────────────────────────────── */
.card-equipment {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 3px;
  font-size: 9px;
}
.card-equipment-badge {
  display: inline-block;
  background: #e0e7ff;
  color: #3730a3;
  padding: 1px 4px;
  border-radius: 3px;
  font-weight: 600;
  border: 1px solid #c7d2fe;
  white-space: nowrap;
}

/* ─── Note indicator on cards ─────────────────────────────── */
.card-note-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  pointer-events: none;
}

.note-icon {
  font-size: 18px;
  display: inline-block;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
}

/* ─── Unscheduled orders panel ──────────────────────────────── */
.unscheduled-panel {
  margin-top: 24px;
  background: #fff;
  border: 1.5px solid #fde68a;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  overflow: visible;
}
.unscheduled-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 20px;
  background: #fefce8;
  border-bottom: 1.5px solid #fde68a;
  border-radius: 10px 10px 0 0;
}
.unscheduled-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #78350f;
}
.unscheduled-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f59e0b;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 22px; height: 22px;
  border-radius: 11px;
  padding: 0 6px;
  flex-shrink: 0;
}
.unscheduled-hint {
  font-size: 12px;
  color: #92400e;
  font-style: italic;
  margin-left: auto;
}

.selected-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #3b82f6;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 22px;
  height: 22px;
  border-radius: 11px;
  padding: 0 8px;
  margin-left: 8px;
}

.btn-clear-selection {
  padding: 6px 12px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-clear-selection:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.unscheduled-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding: 10px 14px;
  border-top: 1px solid #fde68a;
  border-bottom: 1px solid #fde68a;
  background: #fff7ed;
}

.unscheduled-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.unscheduled-filter-chip input {
  margin: 0;
}

.unscheduled-filter-chip.active {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}

.unscheduled-state-filter {
  position: relative;
}

.unscheduled-state-filter-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  height: 32px;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.unscheduled-state-filter-trigger.active {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}

.unscheduled-state-filter-menu {
  position: absolute;
  z-index: 60;
  top: calc(100% + 5px);
  left: 0;
  width: 230px;
  padding: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);
}

.unscheduled-state-filter-actions {
  display: flex;
  gap: 6px;
  padding-bottom: 7px;
  border-bottom: 1px solid #e2e8f0;
}

.unscheduled-state-filter-actions button {
  flex: 1 1;
  padding: 5px 6px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  cursor: pointer;
}

.unscheduled-state-filter-actions button:hover {
  border-color: #94a3b8;
  background: #f1f5f9;
}

.unscheduled-state-filter-options {
  display: flex;
  flex-direction: column;
  max-height: 260px;
  overflow-y: auto;
  padding-top: 6px;
}

.unscheduled-state-filter-options label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 5px;
  border-radius: 5px;
  color: #334155;
  font-size: 13px;
  cursor: pointer;
}

.unscheduled-state-filter-options label:hover {
  background: #eff6ff;
}

.unscheduled-state-filter-options input {
  margin: 0;
}

.unscheduled-filter-search {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.unscheduled-filter-search input {
  width: 190px;
  border: 0;
  outline: none;
  font: inherit;
  color: #0f172a;
}

.unscheduled-filter-search .order-number-suggestions {
  top: calc(100% + 5px);
  width: min(430px, 85vw);
}

.unscheduled-filter-clear {
  height: 32px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.unscheduled-filter-clear:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.order-checkbox {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.selected-row {
  background: #dbeafe !important;
}

.selected-row:hover {
  background: #bfdbfe !important;
}

.unscheduled-table-wrapper {
  overflow-x: auto;
  max-height: 400px;
  overflow-y: auto;
}

.unscheduled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.unscheduled-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fefce8;
}

.unscheduled-table th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 700;
  color: #78350f;
  border-bottom: 2px solid #fde68a;
  white-space: nowrap;
}

.unscheduled-table tbody tr {
  border-bottom: 1px solid #fef3c7;
  transition: background 0.15s;
}

.unscheduled-row {
  cursor: grab;
}

.unscheduled-row:hover {
  background: #fef9e7;
}

.unscheduled-row:active {
  cursor: grabbing;
}

.installation-context-menu {
  position: fixed;
  z-index: 10000;
  width: 260px;
  padding: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);
}

.installation-context-menu-title {
  padding: 6px 8px;
  color: #64748b;
  font-size: 12px;
}

.installation-context-menu .btn-secondary {
  width: 100%;
}

.installation-context-menu .btn-secondary + .btn-secondary {
  margin-top: 6px;
}

.assignment-context-menu {
  position: fixed;
  z-index: 10000;
  width: 165px;
  padding: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);
}

.assignment-context-menu-title {
  padding: 4px 6px 7px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
}

.assignment-context-menu-actions,
.assignment-status-submenu {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.assignment-context-menu .assignment-context-menu-button {
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
  font-size: 12px;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: anywhere;
}

.assignment-status-menu-trigger {
  position: relative;
}

.assignment-status-menu-button {
  position: relative;
}

.assignment-status-menu-button > span:first-child {
  flex: 1 1;
  text-align: center;
  padding: 0 14px;
}

.assignment-status-menu-button > span:last-child {
  position: absolute;
  right: 10px;
}

.assignment-status-submenu {
  position: absolute;
  top: 0;
  z-index: 10001;
  width: 165px;
  padding: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
}

.schedule-order-modal {
  max-width: 460px;
}

.schedule-order-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.schedule-order-fields label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.schedule-order-fields input,
.schedule-order-fields select {
  width: 100%;
  padding: 9px 10px;
  border: 1.5px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #0f172a;
  font: inherit;
}

.schedule-order-fields input:focus,
.schedule-order-fields select:focus {
  border-color: #2563eb;
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.schedule-order-hint {
  padding: 9px 10px;
  border-radius: 7px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
}

.unscheduled-table td {
  padding: 10px 12px;
  color: #1e293b;
  vertical-align: middle;
}

.drag-handle {
  text-align: center;
  cursor: grab;
  color: #94a3b8;
  -webkit-user-select: none;
          user-select: none;
}

.drag-icon {
  font-size: 16px;
  line-height: 1;
}

.note-cell {
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  min-height: 20px;
  transition: background 0.15s;
}

.note-cell:hover {
  background: #f1f5f9;
}

.note-empty {
  color: #94a3b8;
  font-style: italic;
  font-size: 12px;
}

.note-input {
  flex: 1 1;
  padding: 6px 8px;
  border: 1.5px solid #cbd5e1;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
}

.note-input:focus {
  outline: none;
  border-color: #2563eb;
}

.btn-save-note,
.btn-cancel-note {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-save-note {
  background: #dcfce7;
  color: #16a34a;
  border: 1px solid #86efac;
}

.btn-save-note:hover {
  background: #bbf7d0;
}

.btn-save-note:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-cancel-note {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fca5a5;
}

.btn-cancel-note:hover {
  background: #fecaca;
}

.btn-cancel-note:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.unscheduled-cards {
  display: flex;
  gap: 10px;
  padding: 16px 20px;
  overflow-x: auto;
  align-items: flex-start;
  min-height: 90px;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}
.unscheduled-cards::-webkit-scrollbar { height: 5px; }
.unscheduled-cards::-webkit-scrollbar-track { background: transparent; }
.unscheduled-cards::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

/* ─── List tab ─────────────────────────────────────────────── */
.list-tab {
  min-width: 0;
  max-width: 100%;
}

.list-tab > .table-wrapper {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.list-tab > .table-wrapper > .data-table {
  table-layout: fixed;
  min-width: 980px;
}

.list-tab > .table-wrapper > .data-table th {
  padding: 8px 6px;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.25;
}

.list-tab > .table-wrapper > .data-table .inst-row > td {
  padding: 7px 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-tab > .table-wrapper > .data-table .inst-row > .order-cell {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
}

.list-tab > .table-wrapper > .data-table .inst-row--expanded > td {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
  vertical-align: top;
}

.list-tab > .table-wrapper > .data-table .inst-row--expanded > .address-cell {
  max-width: none;
}

.list-tab > .table-wrapper > .data-table .inst-items-row .items-subtable th,
.list-tab > .table-wrapper > .data-table .inst-items-row .items-subtable td {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
}

.list-tab > .table-wrapper > .data-table .inst-row > .expand-cell,
.list-tab > .table-wrapper > .data-table .inst-row > .actions-cell {
  overflow: visible;
}

.list-tab > .table-wrapper > .data-table .positions-count-cell {
  text-align: center;
}

.list-tab > .table-wrapper > .data-table .departure-date-cell {
  text-align: center;
}

.list-tab .list-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.list-tab > .table-wrapper > .data-table .list-row-actions button,
.list-tab > .table-wrapper > .data-table .items-subtable .item-action-btn {
  width: 26px;
  height: 26px;
  min-width: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.list-tab > .table-wrapper > .data-table .list-row-actions button {
  margin: 0;
  box-sizing: border-box;
}

.list-tab .inst-row input {
  width: 100% !important;
  min-width: 0;
  box-sizing: border-box;
}

.list-tab .list-actions,
.list-tab .list-filters {
  flex-wrap: wrap;
  min-width: 0;
}

.list-tab .status-filter-container {
  min-width: 0;
}

.list-toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.list-filters { display: flex; gap: 8px; flex: 1 1; }
.installation-list-search {
  position: relative;
  flex: 1 1;
  min-width: 0;
}
.list-calendar-schedule-menu {
  position: fixed;
  z-index: 70;
  width: min(360px, 90vw);
  padding: 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.22);
}
.list-calendar-schedule-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.list-calendar-schedule-header > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.list-calendar-schedule-header span {
  color: #64748b;
  font-size: 12px;
}
.list-calendar-schedule-header > button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #94a3b8;
  font-size: 17px;
  cursor: pointer;
}
.list-calendar-schedule-menu label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}
.list-calendar-schedule-menu input,
.list-calendar-schedule-menu select {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1.5px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #1e293b;
}
.list-calendar-schedule-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}
.list-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
}
.status-filter-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
}
.status-filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}
.status-filter-checkboxes {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.status-filter-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #334155;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 5px;
  transition: background 0.15s;
  white-space: nowrap;
}
.status-filter-checkbox:hover {
  background: #e2e8f0;
}
.status-filter-checkbox input[type="checkbox"] {
  cursor: pointer;
  width: 15px;
  height: 15px;
}
.list-actions .btn-primary,
.list-actions .btn-secondary {
  padding: 8px 18px;
  font-size: 14px;
  height: 38px;
  margin-top: 0;
  box-sizing: border-box;
}
.search-input {
  flex: 1 1;
  padding: 8px 12px;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  transition: border-color 0.15s;
}
.installation-list-search .search-input {
  width: 100%;
  box-sizing: border-box;
}
.search-input:focus { outline: none; border-color: #2563eb; }
.list-filters select {
  padding: 8px 12px;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
}
.import-result {
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
}
.import-result.success { background: #dcfce7; color: #166534; border: 1.5px solid #86efac; }
.import-result.error { background: #fee2e2; color: #991b1b; border: 1.5px solid #fca5a5; }
.import-summary-title { font-weight: 700; margin-bottom: 6px; }
.import-summary-grid { display: flex; flex-wrap: wrap; gap: 6px 18px; }
.import-type-summary { display: flex; flex-wrap: wrap; align-items: center; gap: 5px; margin-top: 8px; }
.import-type-pill { padding: 2px 7px; border-radius: 999px; background: rgba(255, 255, 255, 0.65); }
.import-warnings { margin-top: 4px; font-size: 12px; opacity: 0.8; }

.planner-import-modal {
  width: 760px;
}

.planner-import-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.planner-file-drop {
  min-height: 160px;
  padding: 18px;
  border: 2px dashed #94a3b8;
  border-radius: 8px;
  background: #f8fafc;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  transition: border-color 0.15s, background 0.15s;
}

.planner-file-drop:hover {
  border-color: #2563eb;
  background: #eff6ff;
}

.planner-file-drop.has-file {
  border-color: #16a34a;
  background: #f0fdf4;
}

.planner-file-drop input {
  display: none;
}

.planner-file-title {
  font-size: 13px;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: 0.04em;
}

.planner-file-name {
  font-size: 13px;
  color: #64748b;
  overflow-wrap: anywhere;
  line-height: 1.35;
}

.planner-file-drop.has-file .planner-file-name {
  color: #166534;
  font-weight: 600;
}

/* ─── Data table ───────────────────────────────────────────── */
.table-wrapper {
  overflow-x: auto;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.07);
  border: 1.5px solid #e2e8f0;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: #fff;
}
.data-table th {
  background: #f1f5f9;
  padding: 11px 14px;
  text-align: left;
  font-weight: 700;
  color: #374151;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.data-table td {
  padding: 9px 14px;
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
}
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #f8fafc; }
.data-table tbody tr.editing { background: #eff6ff; }
.inst-row { transition: background 0.1s; }
.inst-row--expanded > td { background: #eff6ff; }
.inst-row--context-target > td {
  background: #dbeafe;
}
.expand-cell { text-align: center; width: 28px; padding: 0 4px !important; }
.expand-icon { font-size: 12px; color: #64748b; -webkit-user-select: none; user-select: none; }
.inst-items-row > td { padding: 0 !important; border-bottom: 2px solid #bfdbfe !important; }
.inst-items-cell { padding: 0 !important; max-width: 0; }

/* Items subtable */
.items-subtable {
  width: 100%; border-collapse: collapse; table-layout: fixed;
  background: #f0f7ff; font-size: 12px;
}
.items-subtable th {
  padding: 6px 10px; background: #dbeafe; color: #1e40af;
  font-weight: 700; border-bottom: 1px solid #bfdbfe; text-align: center;
  white-space: nowrap;
}
.items-subtable th.sortable-header {
  transition: background 0.15s;
}
.items-subtable th.sortable-header:hover {
  background: #bfdbfe;
}
.items-subtable td {
  padding: 5px 10px; border-bottom: 1px solid #e0ecff; color: #334155;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center;
}
.items-subtable .center-cell { text-align: center; }
.items-subtable th:last-child,
.items-subtable td:last-child { width: 52px; min-width: 52px; overflow: visible; padding: 3px 4px; }
.items-subtable tbody tr:last-child td { border-bottom: none; }
.items-subtable tbody tr:hover { background: #e0ecff; }
.items-subtable-summary td { background: #dbeafe; border-top: 2px solid #93c5fd; }
.item-action-btn { padding: 1px 5px; font-size: 10px; line-height: 1.4; border-radius: 3px; cursor: pointer; border: 1px solid transparent; }
.item-action-btn.edit { background: #e2e8f0; border-color: #94a3b8; color: #334155; }
.item-action-btn.edit:hover { background: #cbd5e1; }
.item-action-btn.delete { background: #fee2e2; border-color: #fca5a5; color: #dc2626; margin-left: 2px; }
.item-action-btn.delete:hover { background: #fecaca; }
.item-action-btn.confirm { background: #dcfce7; border-color: #86efac; color: #16a34a; }
.item-action-btn.confirm:hover { background: #bbf7d0; }
.item-action-btn.cancel { background: #e2e8f0; border-color: #94a3b8; color: #334155; margin-left: 2px; }
.item-action-btn.cancel:hover { background: #cbd5e1; }

.items-subtable-add-row td { background: #f0fdf4; }
.item-input { width: 100%; min-width: 40px; max-width: 100%; padding: 2px 4px; font-size: 12px; border: 1px solid #93c5fd; border-radius: 3px; box-sizing: border-box; }
.item-input.numeric-input { text-align: right; }
/* Hide number input spinners */
.item-input::-webkit-inner-spin-button,
.item-input::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
.item-input[type=number] { -moz-appearance: textfield; }
.no-data-cell { text-align: center; color: #94a3b8; padding: 32px; font-style: italic; }
.no-data-text { color: #94a3b8; font-style: italic; font-size: 13px; }
.order-cell { font-weight: 700; font-family: monospace; font-size: 13px; }
.address-cell { max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.numeric-cell { text-align: right; }
.actions-cell { white-space: nowrap; }
.actions-cell button { margin-left: 4px; }
.state-badge {
  display: inline-block;
  padding: 2px 9px; background: #f1f5f9;
  border-radius: 4px; font-size: 12px; font-weight: 700; color: #374151;
}
.status-pill {
  display: inline-block;
  padding: 3px 9px; border-radius: 5px;
  border: 1.5px solid; font-size: 11px; font-weight: 600;
}

/* ─── Workers tab ──────────────────────────────────────────── */
.workers-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
@media (max-width: 900px) { .workers-layout { grid-template-columns: 1fr; } }
.workers-panel {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 22px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.05);
}
.workers-panel h3 { margin: 0 0 18px; font-size: 16px; color: #1e293b; }
.add-form {
  display: flex; gap: 8px; flex-wrap: wrap;
  margin-bottom: 18px; padding: 12px;
  background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 8px;
}
.add-form input {
  flex: 1 1; min-width: 90px;
  padding: 7px 10px; border: 1.5px solid #cbd5e1; border-radius: 6px; font-size: 13px;
}
.installer-list, .team-list { display: flex; flex-direction: column; gap: 8px; }
.installer-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px; border: 1.5px solid #e2e8f0; border-radius: 8px; background: #fff;
  transition: box-shadow 0.1s;
}
.installer-item:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
.installer-item.inactive { opacity: 0.55; }
.installer-info { display: flex; flex-direction: column; gap: 2px; }
.installer-name { font-weight: 600; font-size: 14px; color: #1e293b; }
.installer-position { font-size: 12px; color: #64748b; }
.inactive-tag { font-size: 10px; background: #fee2e2; color: #991b1b; padding: 1px 6px; border-radius: 4px; width: fit-content; }
.team-tag { font-size: 11px; color: #2563eb; background: #eff6ff; padding: 2px 6px; border-radius: 4px; width: fit-content; }
.installer-actions { display: flex; gap: 4px; }
.edit-form-inline { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; width: 100%; }
.edit-form-inline input { flex: 1 1; min-width: 80px; padding: 5px 8px; border: 1.5px solid #94a3b8; border-radius: 6px; font-size: 13px; }
.team-card {
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  padding: 14px; background: #fff; transition: box-shadow 0.1s;
}
.team-card:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
.team-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; }
.team-desc { font-size: 12px; color: #64748b; }
.team-actions { display: flex; gap: 4px; }
.team-members { display: flex; flex-direction: column; gap: 4px; margin-bottom: 8px; padding-left: 6px; }
.member-item {
  display: flex; justify-content: space-between; align-items: center;
  font-size: 13px; color: #374151; padding: 4px 8px; border-radius: 6px; background: #f8fafc;
}
.add-member-row select {
  width: 100%; padding: 7px 10px;
  border: 1.5px dashed #94a3b8; border-radius: 6px;
  font-size: 13px; color: #2563eb; background: #f8fafc; cursor: pointer;
}

/* ─── Modal ────────────────────────────────────────────────── */
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.55);
  z-index: 1000;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(2px);
}
.modal-box {
  background: #fff; border-radius: 14px;
  width: 620px; max-width: 95vw; max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 24px 64px rgba(0,0,0,0.28);
}

.calendar-note-details-modal .modal-header h3 {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.installation-details-actions.calendar-note-details-actions {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.calendar-note-details-grid .calendar-note-days-picker {
  grid-column: 1 / -1;
}

.calendar-note-details-grid .calendar-note-details-wide {
  grid-column: 1 / -1;
}

.calendar-note-assignment-or {
  margin: 0 8px;
  color: #64748b;
}

.calendar-note-settlement-mode {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
  font-size: 13px;
}

.calendar-note-settlement-mode > span {
  font-weight: 600;
}

.calendar-note-settlement-mode label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.calendar-note-settlement-day {
  margin-bottom: 16px;
}

.calendar-note-settlement-day:last-child {
  margin-bottom: 0;
}

.calendar-note-settlement-day-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
  color: #334155;
  font-size: 13px;
}

.calendar-note-settlement-day-heading > span {
  color: #64748b;
  font-size: 12px;
}

@media (max-width: 600px) {
  .calendar-note-details-modal .settlement-workers {
    overflow-x: auto;
  }

  .installation-details-actions.calendar-note-details-actions {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.quick-add-popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 100;
  width: min(420px, calc(100vw - 32px));
  max-width: none;
  max-height: calc(100vh - 100px);
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.22);
}

/* Non-blocking order details shown next to the planning calendar. */
.planning-tab {
  --installation-details-drawer-width: min(620px, 46vw);
}

.planning-tab--details-open {
  box-sizing: border-box;
  padding-right: calc(var(--installation-details-drawer-width) + 16px);
  transition: padding-right 0.2s ease;
}

.installation-details-drawer {
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
  z-index: 900;
  width: var(--installation-details-drawer-width);
  max-width: none;
  max-height: none;
  border-radius: 14px 0 0 0;
  border-left: 1px solid #cbd5e1;
  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.2);
  overflow-x: hidden;
  overflow-y: scroll;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: auto;
  scrollbar-color: #64748b #f1f5f9;
}

.installation-details-drawer::-webkit-scrollbar {
  width: 12px;
}

.installation-details-drawer::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.installation-details-drawer::-webkit-scrollbar-thumb {
  min-height: 40px;
  border: 3px solid #f1f5f9;
  border-radius: 999px;
  background: #64748b;
}

.installation-details-drawer::-webkit-scrollbar-thumb:hover {
  background: #475569;
}

.installation-details-drawer > .modal-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}

.installation-details-drawer > .modal-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
}

.installation-details-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: stretch;
  gap: 6px;
  padding: 12px 16px;
}

.installation-details-actions > button {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  min-width: 0;
  margin: 0;
  padding: 4px 6px;
  border-width: 1.5px;
  border-style: solid;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.15;
  text-align: center;
  white-space: nowrap;
}

.installation-details-actions > .btn-primary,
.installation-details-actions > .btn-warning {
  border-color: transparent;
}

@media (max-width: 900px) {
  .planning-tab--details-open {
    padding-right: 0;
  }

  .installation-details-drawer {
    width: min(620px, calc(100vw - 24px));
  }
}

@media (max-width: 600px) {
  .installation-details-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.modal-header {
  padding: 22px 26px 18px; border-bottom: 1.5px solid #e2e8f0;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-header h3 { margin: 0; font-size: 19px; color: #1e293b; font-weight: 700; }
.modal-close { background: none; border: none; font-size: 20px; cursor: pointer; color: #94a3b8; line-height: 1; }
.modal-close:hover { color: #1e293b; }

.quick-add-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin: 16px 26px 0;
  padding: 4px;
  border-radius: 9px;
  background: #f1f5f9;
}

.quick-add-tabs button {
  padding: 9px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
}

.quick-add-tabs button.active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);
}

.quick-add-tabs button:disabled {
  cursor: default;
  opacity: 0.6;
}
.modal-error {
  margin: 12px 26px 0;
  padding: 10px 14px; background: #fee2e2; color: #991b1b;
  border-radius: 8px; font-size: 13px; border: 1px solid #fca5a5;
}
.modal-warning-banner {
  margin: 12px 26px 0;
  padding: 12px 16px;
  background: #fef3c7;
  border: 1.5px solid #f59e0b;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.modal-warning-banner .warning-icon {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
}
.modal-warning-banner .warning-content {
  flex: 1 1;
}
.modal-warning-banner .warning-content strong {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #92400e;
  margin-bottom: 4px;
}
.modal-warning-banner .warning-content p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #78350f;
}
.modal-body { padding: 22px 26px; }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.form-grid label {
  display: flex; flex-direction: column; gap: 5px;
  font-size: 11px; color: #64748b; font-weight: 700;
  letter-spacing: 0.05em; text-transform: uppercase;
}
.form-grid input, .form-grid select {
  padding: 9px 11px; border: 1.5px solid #cbd5e1; border-radius: 7px;
  font-size: 14px; background: #fff; color: #1e293b; transition: border-color 0.15s;
}
.form-grid input:focus, .form-grid select:focus { outline: none; border-color: #2563eb; }
.modal-body textarea {
  width: 100%; box-sizing: border-box;
  padding: 9px 11px; border: 1.5px solid #cbd5e1; border-radius: 7px;
  font-size: 14px; font-family: inherit; resize: vertical; color: #1e293b;
}

.installation-general-section {
  border: 1px solid #dbe3ee;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.installation-general-toggle {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 34px;
  gap: 8px;
  padding: 7px 10px;
  border: 0;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}

.installation-general-toggle:hover {
  background: #f1f5f9;
}

.installation-general-summary {
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.installation-general-chevron {
  margin-left: auto;
  color: #64748b;
  font-size: 16px;
  line-height: 1;
}

.installation-general-content {
  padding: 10px;
  border-top: 1px solid #e2e8f0;
}

.form-grid.installation-general-grid {
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 0;
}

.installation-general-grid .general-field--order { grid-column: span 4; }
.installation-general-grid .general-field--contractor { grid-column: span 8; }
.installation-general-grid .general-field--address { grid-column: 1 / -1; }
.installation-general-grid .general-field--status { grid-column: span 6; }
.installation-general-grid .general-field--state { grid-column: span 6; }
.installation-general-grid .general-field--scope { grid-column: span 8; }
.installation-general-grid .general-field--perimeter-sum { grid-column: span 4; }
.installation-general-grid .general-field--date { grid-column: span 6; }

.installation-general-grid .installation-days-picker--expanded {
  box-sizing: border-box;
  width: 100%;
  margin: 4px 0 0;
  padding: 14px;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  background: #fff;
}

.installation-days-picker--expanded legend {
  padding: 0 5px;
  color: #1e293b;
  font-size: 12px;
  font-weight: 700;
}

.installation-days-picker-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.installation-days-picker .installation-days-picker-heading p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.installation-days-count {
  flex: none;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.installation-days-list {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.installation-days-list-label {
  display: block;
  margin-bottom: 8px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.installation-general-grid .installation-days-picker--expanded .installation-days-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  width: 100%;
  gap: 8px;
}

.installation-general-grid .installation-days-picker--expanded .installation-days-options label {
  box-sizing: border-box;
  width: 100%;
  min-height: 36px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.installation-days-calendar-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 14px;
}

.installation-days-calendar-toggle,
.installation-days-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 7px 11px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
}

.installation-days-calendar-toggle {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.installation-days-calendar-toggle:hover {
  background: #dbeafe;
}

.installation-days-clear {
  border: 1px solid transparent;
  background: transparent;
  color: #64748b;
}

.installation-days-clear:hover {
  background: #f1f5f9;
  color: #334155;
}

.installation-days-calendar-panel {
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
}

.installation-days-calendar-modes {
  display: inline-flex;
  gap: 3px;
  padding: 3px;
  border-radius: 8px;
  background: #e2e8f0;
}

.installation-days-calendar-modes button {
  min-height: 30px;
  padding: 5px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #475569;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.installation-days-calendar-modes button[aria-pressed="true"] {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.installation-days-picker .installation-days-calendar-hint {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.4;
}

.installation-days-calendar {
  max-width: 360px;
  margin: 12px 0 0;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.installation-days-calendar .split-calendar-header {
  margin-bottom: 8px;
  padding: 0;
}

.installation-days-calendar .vac-cal-day {
  border: 0;
  background: transparent;
  cursor: pointer;
  min-height: 32px;
}

.installation-days-calendar .vac-cal-day:hover {
  background: #e0e7ff;
}

.installation-days-calendar .vac-cal-day:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.installation-days-calendar-toggle:focus-visible,
.installation-days-clear:focus-visible,
.installation-days-calendar-modes button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

@media (max-width: 480px) {
  .installation-days-picker-heading {
    flex-wrap: wrap;
  }

  .installation-days-calendar-actions {
    justify-content: space-between;
  }

  .installation-days-calendar-toggle,
  .installation-days-clear {
    font-size: 11px;
  }

  .installation-days-calendar-panel {
    padding: 8px;
  }
}

.installation-general-grid input,
.installation-general-grid select {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 6px 8px;
  font-size: 12px;
}

.installation-general-grid input[readonly] {
  background: #f8fafc;
  color: #334155;
  cursor: default;
}

.installation-general-notes {
  display: block;
  margin-top: 8px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.installation-general-notes textarea {
  display: block;
  min-height: 58px;
  margin-top: 5px;
  padding: 7px 8px;
  font-size: 12px;
}

@media (max-width: 600px) {
  .installation-general-grid .general-field--date {
    grid-column: span 6;
  }

  .installation-general-grid .general-field--order { grid-column: span 5; }
  .installation-general-grid .general-field--contractor { grid-column: span 7; }
  .installation-general-grid .general-field--status,
  .installation-general-grid .general-field--state { grid-column: span 6; }
  .installation-general-grid .general-field--scope { grid-column: span 8; }
  .installation-general-grid .general-field--perimeter-sum { grid-column: span 4; }
}
.modal-footer {
  padding: 18px 26px; border-top: 1.5px solid #e2e8f0;
  display: flex; justify-content: flex-end; gap: 10px;
}
.assignments-section { margin-top: 22px; padding-top: 18px; border-top: 1.5px solid #e2e8f0; }
.assignments-section h4 { margin: 0 0 12px; font-size: 14px; color: #374151; font-weight: 700; }
.day-assignment-block { margin-bottom: 16px; padding: 10px; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0; }
.day-assignment-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.day-assignment-label { font-weight: 600; font-size: 13px; color: #1e293b; display: flex; align-items: center; gap: 6px; }
.day-assignment-empty { font-size: 12px; color: #94a3b8; font-style: italic; }
.kat-b-warning-badge { color: #f59e0b; font-size: 15px; }
.assignment-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 4px; }
.assignment-list li {
  display: flex; justify-content: space-between; align-items: center;
  padding: 7px 12px; background: #ffffff; border-radius: 6px; font-size: 13px;
}
/* Expanded team assignment */
.team-assignment-expanded {
  display: flex; flex-direction: column; gap: 0;
  background: #ffffff; border-radius: 6px; overflow: hidden;
  border: 1px solid #e2e8f0;
}
.team-assignment-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 7px 12px; font-size: 13px; background: #f1f5f9;
}
.team-members-list {
  list-style: none; padding: 0; margin: 0;
  display: flex; flex-direction: column;
}
.team-member-item {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 12px 5px 20px; font-size: 12px; color: #374151;
  border-top: 1px solid #f1f5f9;
}
.team-member-item:last-child { border-bottom: none; }
.member-name { flex: 1 1; }
.member-katb-badge {
  background: #2563eb; color: #fff; font-size: 10px; font-weight: 700;
  padding: 1px 5px; border-radius: 4px;
}
/* Inline add-person row in day block */
.day-add-member-inline {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 10px; border-top: 1px solid #e2e8f0; flex-wrap: wrap;
}
.day-add-member-inline .assign-select { flex: 1 1; min-width: 150px; }
.btn-add-member {
  display: block; width: 100%; text-align: left;
  background: none; border: 1px dashed #94a3b8; color: #64748b;
  font-size: 12px; padding: 5px 10px; border-radius: 6px;
  cursor: pointer; margin-top: 6px; transition: border-color 0.15s, color 0.15s;
}
.btn-add-member:hover { border-color: #2563eb; color: #2563eb; }
.assign-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
.assign-row select { flex: 1 1; padding: 7px 10px; border: 1.5px solid #cbd5e1; border-radius: 7px; font-size: 13px; }

/* Compact assignment cards in the installation details drawer. */
.assignments-section--compact {
  margin-top: 16px;
  padding-top: 14px;
}

.assignments-section--compact > h4 {
  margin-bottom: 8px;
}

.section-collapse-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 30px;
  margin: 0 0 7px;
  padding: 4px 7px;
  border: 0;
  border-radius: 6px;
  background: #f1f5f9;
  color: #374151;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}

.section-collapse-toggle:hover {
  background: #e2e8f0;
}

.section-collapse-toggle > span:last-child {
  color: #64748b;
  font-size: 16px;
  line-height: 1;
}

.assignments-section--compact .day-assignment-block {
  margin-bottom: 8px;
  padding: 5px 6px;
  border-radius: 7px;
}

.assignments-section--compact .day-assignment-header {
  min-height: 24px;
  margin-bottom: 4px;
}

.assignments-section--compact .day-assignment-label {
  font-size: 12px;
}

.assignments-section--compact .team-assignment-row {
  box-sizing: border-box;
  width: 100%;
  min-height: 24px;
  padding: 2px 5px;
}

.assignments-section--compact .assignment-list,
.assignments-section--compact .team-assignment-expanded {
  width: 100%;
}

.assignments-section--compact .team-assignment-expanded {
  align-items: stretch;
}

.team-assignment-name {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 7px;
  color: #1e293b;
  font-size: 12px;
}

.team-assignment-count {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #64748b;
  font-size: 9px;
  font-weight: 700;
}

.assignments-section--compact .team-members-list {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 3px;
  padding: 4px 5px 5px;
}

.assignments-section--compact .team-member-item {
  box-sizing: border-box;
  min-width: 0;
  min-height: 22px;
  padding: 2px 3px 2px 5px;
  border: 0;
  border-radius: 5px;
  background: #f8fafc;
}

.assignments-section--compact .member-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
}

.assignments-section--compact .member-katb-badge {
  padding: 1px 4px;
  font-size: 8px;
}

.assignments-section--compact .btn-icon-remove {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  padding: 0;
  line-height: 18px;
}

.assignments-section--compact .btn-add-member {
  width: auto;
  margin: 3px 0 0 auto;
  padding: 2px 7px;
  font-size: 10px;
}

.assignments-section--compact .day-add-member-inline {
  margin-top: 4px;
  padding: 5px 0 0;
}

.individual-assignment-row > span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.individual-assignment-actions {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 8px;
}

.individual-assignment-actions select {
  max-width: 150px;
  padding: 3px 5px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: #fff;
  color: #475569;
  font-size: 10px;
}

.settlement-parameters {
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.settlement-parameters h4 {
  margin: 0 0 10px;
  color: #475569;
  font-size: 14px;
}

.settlement-parameters-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.settlement-parameters-grid label {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 7px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.settlement-parameters-grid input {
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 6px 9px;
  border: 1.5px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
}

.settlement-parameters-grid input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.settlement-parameters-formula {
  margin: 9px 0 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.4;
}

.settlement-section .section-collapse-toggle--settlement {
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.75);
  color: #166534;
  font-size: 14px;
}

.settlement-section--collapsed {
  padding: 12px 16px;
}

.settlement-section--collapsed .section-collapse-toggle--settlement {
  margin-bottom: 0;
}

/* ─── Shared buttons ───────────────────────────────────────── */
.btn-primary {
  background: #2563eb; color: #fff; border: none;
  padding: 9px 18px; border-radius: 7px; cursor: pointer;
  font-size: 14px; font-weight: 600;
  transition: background 0.15s, box-shadow 0.15s;
  box-shadow: 0 1px 4px rgba(37,99,235,0.3);
}
.btn-primary:hover { background: #1d4ed8; box-shadow: 0 2px 8px rgba(37,99,235,0.4); }
.btn-primary:disabled { background: #93c5fd; cursor: not-allowed; box-shadow: none; }
.btn-secondary {
  background: #f8fafc; color: #374151;
  border: 1.5px solid #cbd5e1; padding: 9px 18px;
  border-radius: 7px; cursor: pointer; font-size: 14px; transition: background 0.15s;
}
.btn-secondary:hover { background: #e2e8f0; }
.btn-success { background: #16a34a; color: #fff; border: none; padding: 9px 18px; border-radius: 7px; cursor: pointer; font-size: 14px; }
.btn-success:hover { background: #15803d; }
.btn-danger { background: #ef4444; color: #fff; border: none; padding: 9px 18px; border-radius: 7px; cursor: pointer; font-size: 14px; }
.btn-danger:hover { background: #dc2626; }
.btn-warning { background: #f59e0b; color: #fff; border: none; padding: 9px 18px; border-radius: 7px; cursor: pointer; font-size: 14px; font-weight: 600; transition: background 0.15s; }
.btn-warning:hover { background: #d97706; }
.btn-warning:disabled { background: #fcd34d; cursor: not-allowed; }
.btn-sm { padding: 5px 11px !important; font-size: 12px !important; }
.btn-icon-remove { background: none; border: none; color: #ef4444; cursor: pointer; font-size: 13px; padding: 2px 6px; border-radius: 4px; }
.btn-icon-remove:hover { background: #fee2e2; }

/* ─── Misc ─────────────────────────────────────────────────── */
.error-banner {
  background: #fee2e2; color: #991b1b;
  padding: 10px 14px; border-radius: 8px; margin-bottom: 12px;
  font-size: 13px; cursor: pointer; border: 1.5px solid #fca5a5;
}
.loading-text { color: #94a3b8; padding: 36px; text-align: center; font-style: italic; font-size: 14px; }

/* ═══════════════════════════════════════════════════════════════
   Workers & Teams Tab  (complete redesign)
═══════════════════════════════════════════════════════════════ */

/* Root container */
.wt-root { padding: 20px 0; }

/* Sub-navigation */
.wt-nav {
  display: flex; gap: 4px; margin-bottom: 24px;
  border-bottom: 2px solid #e2e8f0; padding-bottom: 0;
}
.wt-nav-btn {
  background: none; border: none; padding: 10px 20px 12px;
  font-size: 14px; font-weight: 500; color: #64748b;
  cursor: pointer; border-radius: 8px 8px 0 0; position: relative;
  display: flex; align-items: center; gap: 8px;
  transition: color .15s, background .15s;
}
.wt-nav-btn:hover { background: #f8fafc; color: #1e293b; }
.wt-nav-btn.active {
  color: #3b82f6; background: #eff6ff;
  border-bottom: 2px solid #3b82f6; margin-bottom: -2px;
}
.wt-nav-count {
  background: #e2e8f0; color: #475569;
  font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 20px;
}
.wt-nav-btn.active .wt-nav-count { background: #bfdbfe; color: #1d4ed8; }

/* Section wrapper */
.wt-section { background: #fff; border-radius: 12px; border: 1px solid #e2e8f0; padding: 20px; }

/* Section header */
.wt-section-header {
  display: flex; align-items: center; gap: 10px; margin-bottom: 16px; flex-wrap: wrap;
}
.wt-section-title { font-size: 16px; font-weight: 700; color: #1e293b; margin: 0; }
.wt-badge {
  background: #e2e8f0; color: #475569;
  font-size: 12px; font-weight: 600; padding: 2px 8px; border-radius: 20px;
}
.wt-toolbar { display: flex; gap: 8px; align-items: center; margin-left: auto; flex-wrap: wrap; }
.wt-search {
  padding: 7px 12px; border: 1px solid #cbd5e1; border-radius: 8px;
  font-size: 13px; width: 200px;
}
.wt-search:focus { outline: none; border-color: #3b82f6; }
.wt-filter {
  padding: 7px 10px; border: 1px solid #cbd5e1; border-radius: 8px;
  font-size: 13px; background: #fff; cursor: pointer;
}

/* Tables (positions + employees) */
.wt-table {
  width: 100%; border-collapse: collapse; font-size: 13.5px;
}
.wt-table th {
  text-align: left; padding: 10px 12px;
  background: #f8fafc; color: #64748b;
  font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;
  border-bottom: 1.5px solid #e2e8f0;
}
.wt-table td {
  padding: 10px 12px; border-bottom: 1px solid #f1f5f9; vertical-align: middle;
}
.wt-table tr:last-child td { border-bottom: none; }
.wt-table tr:hover td { background: #f8fafc; }
.wt-empty { text-align: center; color: #94a3b8; padding: 28px !important; font-style: italic; }

/* Inline edit inputs */
.wt-inline-input {
  padding: 5px 8px; border: 1px solid #93c5fd; border-radius: 6px;
  font-size: 13px; width: 100%;
}
.rank-input { width: 64px !important; text-align: center; }

/* Rank badge */
.rank-badge {
  display: inline-block; background: #eff6ff; color: #1d4ed8;
  border: 1px solid #bfdbfe; font-size: 12px; font-weight: 700;
  padding: 2px 9px; border-radius: 20px; min-width: 36px; text-align: center;
}
.count-chip {
  display: inline-block; background: #f0fdf4; color: #166534;
  border: 1px solid #bbf7d0; font-size: 12px; font-weight: 600;
  padding: 2px 9px; border-radius: 20px;
}

/* Add row */
.wt-add-row {
  display: flex; gap: 8px; align-items: center; margin-top: 14px;
  padding-top: 14px; border-top: 1px solid #f1f5f9;
}
.wt-add-input {
  flex: 1 1; padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px;
}
.wt-add-input:focus { outline: none; border-color: #3b82f6; }

/* Employee table specifics */
.wt-emp-table .col-num { width: 40px; color: #94a3b8; font-size: 12px; }
.wt-emp-table .col-bool { width: 90px; text-align: center; font-size: 13px; font-weight: 600; color: #475569; }
.bool-yes { color: #16a34a; font-weight: 700; font-size: 16px; }
.emp-name { font-weight: 600; color: #1e293b; }
.emp-teams-tiny { font-size: 11px; color: #94a3b8; margin-top: 2px; }
.pos-badge {
  display: inline-block; background: #eff6ff; color: #1d4ed8;
  border: 1px solid #bfdbfe; font-size: 12px; font-weight: 600;
  padding: 2px 10px; border-radius: 20px;
}
.pos-text { color: #475569; font-size: 13px; }
.status-active  { color: #16a34a; font-size: 12px; font-weight: 600; }
.status-inactive{ color: #ef4444; font-size: 12px; font-weight: 600; }
.row-inactive td { opacity: .55; }
.position-actions { display: flex; gap: 6px; align-items: center; }
.emp-actions { display: flex; gap: 6px; flex-wrap: wrap; justify-content: flex-end; }

/* Icon buttons */
.btn-icon-edit  { background: #eff6ff; border: 1px solid #bfdbfe; color: #3b82f6; border-radius: 6px; padding: 4px 8px; cursor: pointer; font-size: 14px; }
.btn-icon-remove{ background: #fff1f2; border: 1px solid #fecdd3; color: #e11d48; border-radius: 6px; padding: 4px 8px; cursor: pointer; font-size: 14px; }
.btn-icon-cal   { background: #f0fdf4; border: 1px solid #bbf7d0; color: #16a34a; border-radius: 6px; padding: 4px 8px; cursor: pointer; font-size: 14px; }
.btn-icon-edit:hover   { background: #dbeafe; }
.btn-icon-remove:hover { background: #ffe4e6; }
.btn-icon-cal:hover    { background: #dcfce7; }

/* Text buttons for positions */
.btn-text-edit  { background: #eff6ff; border: 1px solid #bfdbfe; color: #3b82f6; border-radius: 6px; padding: 5px 12px; cursor: pointer; font-size: 13px; font-weight: 500; margin-right: 6px; }
.btn-text-remove{ background: #fff1f2; border: 1px solid #fecdd3; color: #e11d48; border-radius: 6px; padding: 5px 12px; cursor: pointer; font-size: 13px; font-weight: 500; }
.btn-text-calendar{ background: #f0fdf4; border: 1px solid #bbf7d0; color: #16a34a; border-radius: 6px; padding: 5px 12px; cursor: pointer; font-size: 13px; font-weight: 500; margin-right: 6px; }
.btn-text-edit:hover   { background: #dbeafe; }
.btn-text-remove:hover { background: #ffe4e6; }
.btn-text-calendar:hover { background: #dcfce7; }

.btn-xs { padding: 3px 7px !important; font-size: 12px !important; }
.btn-success { background: #22c55e; color: #fff; border: none; border-radius: 6px; padding: 6px 12px; cursor: pointer; font-size: 13px; }
.btn-success:hover { background: #16a34a; }
.btn-nav { background: none; border: 1px solid #e2e8f0; color: #475569; border-radius: 6px; padding: 3px 10px; cursor: pointer; font-size: 16px; line-height: 1; }
.btn-nav:hover { background: #f1f5f9; }

/* ─── Team cards ─────────────────────────────────────────────── */
.team-cards-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 16px;
  margin-top: 16px;
}
.team-card-v2 {
  background: #fff; border: 1.5px solid #e2e8f0; border-radius: 12px; overflow: hidden;
  display: flex; flex-direction: column;
}
.team-card-header {
  display: flex; align-items: flex-start; padding: 14px 16px; background: #f8fafc;
  border-bottom: 1px solid #e2e8f0; gap: 8px;
}
.team-name-block { display: flex; flex-direction: column; gap: 2px; flex: 1 1; min-width: 0; }
.team-name-v2 { font-size: 15px; font-weight: 700; color: #1e293b; }
.team-desc-v2 { font-size: 12px; color: #64748b; }
.team-card-actions { display: flex; gap: 4px; }
.team-member-count {
  padding: 4px 16px; font-size: 11px; color: #94a3b8; font-weight: 600;
  background: #f8fafc; border-bottom: 1px solid #f1f5f9;
  text-transform: uppercase; letter-spacing: .04em;
}
.team-members-v2 { padding: 8px 12px; flex: 1 1; display: flex; flex-direction: column; gap: 6px; }
.member-row-v2 {
  display: flex; align-items: center; gap: 8px; padding: 7px 8px;
  background: #f8fafc; border-radius: 8px; border: 1px solid #f1f5f9;
}
.member-rank-num {
  width: 22px; height: 22px; border-radius: 50%; background: #e2e8f0;
  color: #64748b; font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.member-info-v2 { display: flex; flex-direction: column; gap: 1px; flex: 1 1; min-width: 0; }
.member-name-v2 { font-weight: 600; font-size: 13px; color: #1e293b; }
.member-pos-v2  { font-size: 11px; color: #64748b; }
.member-badges  { display: flex; gap: 4px; align-items: center; }
.badge { display: inline-flex; align-items: center; justify-content: center;
  padding: 2px 6px; border-radius: 10px; font-size: 11px; font-weight: 600; }
.badge--home { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; }
.badge--age  { background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; }
.badge--katb { background: #fefce8; color: #a16207; border: 1px solid #fde68a; }
.badge--off  { background: #f1f5f9; color: #94a3b8; border: 1px solid #e2e8f0; }
.team-add-member {
  padding: 8px 12px; border-top: 1px solid #f1f5f9;
}
.team-add-member select {
  width: 100%; padding: 7px 10px; border: 1px dashed #93c5fd;
  border-radius: 8px; font-size: 13px; color: #3b82f6; background: #f8fbff; cursor: pointer;
}
.edit-form-inline { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; width: 100%; }
.edit-form-inline input {
  padding: 5px 8px; border: 1px solid #93c5fd; border-radius: 6px; font-size: 13px; flex: 1 1; min-width: 80px;
}

/* ─── Vacation drawer ────────────────────────────────────────── */
.vac-drawer {
  background: #fff; border-radius: 14px; padding: 0;
  width: 420px; max-width: 96vw; max-height: 90vh;
  overflow-y: auto; display: flex; flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.18);
}
.vac-drawer-header {
  display: flex; justify-content: space-between; align-items: flex-start;
  padding: 18px 20px 14px; background: #1e293b; border-radius: 14px 14px 0 0;
  position: sticky; top: 0; z-index: 1;
}
.vac-drawer-title {
  display: block; font-size: 11px; font-weight: 700; color: #94a3b8;
  text-transform: uppercase; letter-spacing: .07em; margin-bottom: 2px;
}
.vac-drawer-name { font-size: 16px; font-weight: 700; color: #f1f5f9; }
.vac-drawer-header .modal-close {
  background: rgba(255,255,255,.1); color: #cbd5e1; border: none;
  border-radius: 6px; padding: 4px 9px; font-size: 15px; cursor: pointer;
}

/* Calendar section */
.vac-cal-section { padding: 14px 16px; border-bottom: 1px solid #f1f5f9; }
.vac-cal-nav {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 8px;
}
.vac-cal-label { font-size: 13px; font-weight: 700; color: #1e293b; }
.vac-cal-legend { display: flex; align-items: center; font-size: 11px; color: #64748b; margin-bottom: 8px; gap: 4px; }
.vac-legend-dot {
  display: inline-block; width: 10px; height: 10px; border-radius: 50%;
}
.vac-legend-dot.vac-approved { background: #22c55e; }
.vac-legend-dot.vac-pending  { background: #f59e0b; }
.vac-cal-grid {
  display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px;
}
.vac-cal-head {
  text-align: center; font-size: 10px; font-weight: 700; color: #94a3b8;
  padding: 3px 0; text-transform: uppercase;
}
.vac-cal-day {
  text-align: center; padding: 5px 0; border-radius: 6px;
  font-size: 12px; font-weight: 500; color: #1e293b;
  transition: background .1s;
}
.vac-cal-day.out-month  { color: #cbd5e1; }
.vac-cal-day.vac-approved { background: #dcfce7; color: #166534; font-weight: 700; }
.vac-cal-day.vac-pending  { background: #fef9c3; color: #92400e; font-weight: 700; }
.vac-cal-day.vac-cal-clickable { cursor: pointer; }
.vac-cal-day.vac-cal-clickable:hover { background: #e0e7ff; color: #3730a3; }
.vac-cal-day.sel-start { background: #3b82f6; color: #fff; font-weight: 700; border-radius: 6px 0 0 6px; }
.vac-cal-day.sel-end   { background: #3b82f6; color: #fff; font-weight: 700; border-radius: 0 6px 6px 0; }
.vac-cal-day.sel-range { background: #bfdbfe; color: #1e3a8a; border-radius: 0; }
/* Hint & preview */
.vac-cal-hint {
  font-size: 12px; color: #64748b; text-align: center;
  padding: 4px 0 6px; min-height: 22px;
}
.vac-sel-preview { color: #1e40af; display: flex; align-items: center; gap: 6px; justify-content: center; }
.vac-btn-clear {
  background: none; border: none; cursor: pointer; color: #94a3b8;
  font-size: 13px; padding: 0 2px; line-height: 1;
}
.vac-btn-clear:hover { color: #ef4444; }

/* Vacation list */
.vac-list-section { padding: 14px 16px; border-bottom: 1px solid #f1f5f9; }
.vac-section-title { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: .07em; margin: 0 0 10px; }
.vac-group-label {
  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em;
  padding: 2px 8px; border-radius: 4px; display: inline-block; margin: 8px 0 4px;
}
.vac-group-label.approved { background: #dcfce7; color: #166534; }
.vac-group-label.pending  { background: #fef9c3; color: #92400e; }
.vac-item {
  display: flex; align-items: center; gap: 8px; padding: 7px 10px;
  border-radius: 8px; margin-bottom: 4px; border: 1px solid transparent;
}
.vac-item--approved { background: #f0fdf4; border-color: #bbf7d0; }
.vac-item--pending  { background: #fffbeb; border-color: #fde68a; }
.vac-item-dates { display: flex; align-items: center; gap: 4px; font-size: 13px; font-weight: 600; flex: 1 1; }
.vac-dash { color: #94a3b8; }
.vac-item-notes { font-size: 11px; color: #64748b; max-width: 100px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.vac-item-actions { display: flex; gap: 4px; margin-left: auto; }
.vac-btn-approve { background: #22c55e; color: #fff; border: none; border-radius: 6px; padding: 4px 9px; font-size: 13px; font-weight: 700; cursor: pointer; }
.vac-btn-approve:hover { background: #16a34a; }
.vac-btn-reject  { background: #f59e0b; color: #fff; border: none; border-radius: 6px; padding: 4px 9px; font-size: 13px; font-weight: 700; cursor: pointer; }
.vac-btn-reject:hover { background: #d97706; }
.no-data-text { color: #94a3b8; font-size: 13px; font-style: italic; }

/* Add vacation form */
.vac-add-section { padding: 14px 16px; }
.vac-add-form { display: flex; flex-direction: column; gap: 8px; }
.vac-add-form label {
  display: flex; flex-direction: column; gap: 4px;
  font-size: 12px; font-weight: 600; color: #64748b;
}
.vac-add-form input, .vac-add-form select {
  padding: 7px 10px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px;
  background: #fff;
}
.vac-add-form input:focus, .vac-add-form select:focus { outline: none; border-color: #3b82f6; }

.vac-type-badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 31px; padding: 2px 6px; border-radius: 5px;
  font-size: 10px; font-weight: 800; line-height: 1.4; white-space: nowrap;
  background: #dbeafe; color: #1e40af;
}
.vac-type-badge--NN { background: #fee2e2; color: #991b1b; }
.vac-type-badge--UNŻ { background: #f3e8ff; color: #6b21a8; }
.vac-type-badge--L4 { background: #fef3c7; color: #92400e; }
.vac-type-badge--SW { background: #cffafe; color: #155e75; }
.vac-type-badge--ST { background: #ffe4e6; color: #9f1239; }
.vac-type-badge--UB { background: #e2e8f0; color: #334155; }
.vac-type-label { font-size: 12px; color: #475569; white-space: nowrap; }

/* ─── Employee modal overrides ───────────────────────────────── */
.modal-box--sm { max-width: 500px; }
.modal-box--employee { max-width: 760px; }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 14px; }
.form-grid label {
  display: flex; flex-direction: column; gap: 4px;
  font-size: 12px; font-weight: 600; color: #64748b;
}
.form-grid input, .form-grid select {
  padding: 8px 10px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px; background: #fff;
}
.form-grid input:focus, .form-grid select:focus { outline: none; border-color: #3b82f6; }
.emp-toggle-row {
  display: flex; flex-wrap: wrap; gap: 14px;
  padding-top: 12px; border-top: 1px solid #f1f5f9;
}

.employee-vacation-rates {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.employee-vacation-rates-heading h4 {
  margin: 0 0 3px;
  color: #1e293b;
  font-size: 14px;
}

.employee-vacation-rates-heading p {
  margin: 0 0 12px;
  color: #64748b;
  font-size: 12px;
}

.employee-vacation-rates-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
}

.employee-vacation-rates-grid > label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
}

.employee-vacation-rate-input {
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
}

.employee-vacation-rate-input:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgb(59 130 246 / 12%);
}

.employee-vacation-rate-input input {
  min-width: 0;
  width: 100%;
  padding: 8px 9px;
  border: 0;
  outline: 0;
}

.employee-vacation-rate-input > span {
  flex: 0 0 auto;
  padding-right: 9px;
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.employee-vacation-rate-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 5px;
  color: #94a3b8;
  font-size: 11px;
}

.employee-vacation-rate-summary span {
  padding: 2px 6px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #047857;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .employee-vacation-rates-grid {
    grid-template-columns: 1fr;
  }
}
.toggle-label {
  display: flex; align-items: center; gap: 6px;
  font-size: 13px; color: #374151; cursor: pointer;
}
.toggle-label input[type="checkbox"] { width: 15px; height: 15px; cursor: pointer; }

/* ─── Vacation conflict warning banner (in assignment modal) ─ */
.vacation-conflict-banner {
  background: #fffbeb; border: 1.5px solid #f59e0b;
  border-radius: 10px; padding: 12px 14px; margin: 10px 0;
}
.vacation-conflict-title {
  font-size: 13px; font-weight: 700; color: #92400e; margin-bottom: 8px;
}
.vacation-conflict-list {
  margin: 0 0 10px 16px; padding: 0;
  font-size: 13px; color: #78350f; display: flex; flex-direction: column; gap: 4px;
}
.vacation-conflict-close {
  background: #f59e0b; color: #fff; border: none; border-radius: 6px;
  padding: 5px 14px; font-size: 12px; font-weight: 600; cursor: pointer;
}
.vacation-conflict-close:hover { background: #d97706; }

/* ─── Drag & drop styles (replaced with arrow buttons) ──────── */
.position-arrows {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
}
.btn-arrow {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 12px;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.btn-arrow:hover:not(:disabled) {
  background: #e2e8f0;
  border-color: #94a3b8;
  color: #1e293b;
}
.btn-arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* ─── Upcoming Vacations Section ─────────────────────────────── */
.vacations-list {
  border-top: 2px solid #e2e8f0;
  padding-top: 24px;
}
.vacations-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
}
.vacations-tabs {
  display: flex; gap: 6px; margin-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}
.vacations-tab {
  border: none; border-bottom: 2px solid transparent; background: transparent;
  color: #64748b; cursor: pointer; font-size: 15px; font-weight: 600;
  margin-bottom: -1px; padding: 8px 12px;
}
.vacations-tab:hover { color: #1e293b; }
.vacations-tab.active { border-bottom-color: #2563eb; color: #1d4ed8; }
.vacation-month-row td {
  padding: 9px 12px;
  border-top: 2px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
  background: #f1f5f9;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.03em;
}
.vacation-export-panel {
  display: inline-flex;
  align-items: flex-end;
  gap: 14px;
  width: fit-content;
  max-width: 100%;
  margin-bottom: 18px;
  padding: 10px 12px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
  flex-wrap: wrap;
}
.vacation-export-heading {
  display: flex;
  flex: 0 1 250px;
  flex-direction: column;
  gap: 3px;
}
.vacation-export-heading strong { color: #1e3a8a; font-size: 13px; }
.vacation-export-heading span { color: #64748b; font-size: 12px; }
.vacation-export-controls {
  display: grid;
  grid-template-columns: 142px repeat(2, 124px);
  align-items: flex-end;
  gap: 8px;
}
.vacation-export-controls label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}
.vacation-export-controls input {
  min-height: 34px;
  padding: 6px 9px;
  border: 1px solid #93c5fd;
  border-radius: 7px;
  background: #fff;
  color: #1e293b;
  font: inherit;
  font-size: 12px;
}
.vacation-export-controls input:focus {
  outline: 2px solid #60a5fa;
  outline-offset: 1px;
}
.vacation-export-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 124px;
  min-height: 34px;
  padding-right: 10px;
  padding-left: 10px;
  white-space: nowrap;
}
.vacation-export-error {
  flex-basis: 100%;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 600;
}
.vacations-empty {
  color: #94a3b8;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  padding: 24px;
}

@media (max-width: 900px) {
  .vacation-export-panel {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .vacation-export-heading {
    flex-basis: auto;
  }

  .vacation-export-controls {
    grid-template-columns: minmax(142px, 1fr) repeat(2, 124px);
    width: 100%;
  }
}

@media (max-width: 560px) {
  .vacation-export-controls {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .vacation-export-controls label {
    grid-column: 1 / -1;
  }

  .vacation-export-button {
    width: 100%;
  }
}

/* ─── Equipment / logistics flags (Planowanie modal) ─────────── */
.equipment-flags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  margin-top: 14px;
  padding: 10px 12px;
  background: #f0f7ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
}
.equipment-flags-label {
  font-size: 12px;
  font-weight: 600;
  color: #1e40af;
  width: 100%;
  margin-bottom: 2px;
}
.equipment-flag-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.equipment-flag-item input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: #3b82f6;
}

/* ─── Split Installation Modal (suma obwodów > 80) ─────────── */
.split-calendar {
  margin-top: 12px;
}

.split-calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 8px;
}

.split-calendar-month {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.selected-date {
  background: #3b82f6 !important;
  color: white !important;
  font-weight: 600;
}

.vac-cal-day.selected-date:hover {
  background: #2563eb !important;
}

/* ─── Team Rows View (Ekipy) ───────────────────────────────── */
.team-rows-view {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  border-radius: 12px;
  overflow: visible;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);
}

.hidden-teams-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  padding: 9px 12px;
  background: #f8fafc;
  border-bottom: 1px solid #d1d5db;
  border-radius: 10px 10px 0 0;
}

.hidden-teams-label {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.hidden-team-button,
.show-all-teams-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #ffffff;
  color: #334155;
  padding: 4px 9px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.hidden-team-button:hover,
.show-all-teams-button:hover {
  border-color: #2563eb;
  color: #1d4ed8;
  background: #eff6ff;
}

.hidden-team-button:disabled,
.show-all-teams-button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.show-all-teams-button {
  color: #1d4ed8;
  margin-left: auto;
}

.team-rows-header {
  display: grid;
  grid-template-columns: 150px repeat(7, 1fr);
  background: #f9fafb;
  border-bottom: 2px solid #d1d5db;
  border-radius: 10px 10px 0 0;
  position: sticky;
  top: 60px;
  z-index: 20;
  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.12);
}

.team-name-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  font-weight: 700;
  font-size: 13px;
  color: #374151;
  border-right: 1.5px solid #d1d5db;
  text-align: center;
  background: #f9fafb;
}

.team-day-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  border-right: 1.5px solid #d1d5db;
  transition: background 0.12s;
}

.team-day-header.today {
  background: #eff6ff;
}

.team-day-header:last-child {
  border-right: none;
}

.team-day-name {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 5px;
}

.team-day-header.today .team-day-name { color: #2563eb; }

.team-day-num {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.team-rows-body {
  display: flex;
  flex-direction: column;
}

.team-row {
  display: grid;
  grid-template-columns: 150px repeat(7, 1fr);
  border-bottom: 1.5px solid #d1d5db;
  transition: background 0.12s;
}

.team-row:hover {
  background: #f9fafb;
}

.team-row:last-child {
  border-bottom: none;
}

.team-row.unassigned-row {
  background: #fffbeb;
}

.team-row.unassigned-row:hover {
  background: #fef3c7;
}

.team-row .team-name-cell {
  background: #f3f4f6;
  font-weight: 700;
  font-size: 13px;
  color: #1f2937;
  border-right: 2px solid #d1d5db;
  position: relative;
}

.team-row.unassigned-row .team-name-cell {
  background: #fef3c7;
  color: #92400e;
}

.team-name-label {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding: 0 4px;
}

.hide-team-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  margin-left: 3px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.hide-team-button:hover {
  border-color: #cbd5e1;
  background: #ffffff;
  color: #1d4ed8;
}

.hide-team-button:disabled {
  cursor: wait;
  opacity: 0.45;
}

.team-day-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  min-height: 80px;
  border-right: 1.5px solid #d1d5db;
  overflow-y: auto;
  max-height: 200px;
  transition: background 0.12s;
}

.team-day-cell:hover {
  background: #f9fafb;
}

.team-row.unassigned-row .team-day-cell:hover {
  background: #fef9e7;
}

.team-day-cell:last-child {
  border-right: none;
}

.team-day-cell.drag-over {
  background: #dbeafe !important;
  outline: 2px dashed #3b82f6;
  outline-offset: -2px;
  box-shadow: inset 0 0 10px rgba(59, 130, 246, 0.15);
  transition: all 0.2s ease;
}

/* Make cards smaller in team view */
.team-rows-view .card {
  font-size: 11px;
  padding: 6px 8px;
  min-height: auto;
}

.team-rows-view .card-header {
  margin-bottom: 4px;
}

.team-rows-view .card-title {
  font-size: 11px;
}

.team-rows-view .card-badges {
  gap: 3px;
}

.team-rows-view .card-badge {
  padding: 1px 4px;
  font-size: 9px;
}

.team-rows-view .card-equipment {
  gap: 3px;
  margin-top: 4px;
}

.team-rows-view .card-equipment-badge {
  padding: 1px 3px;
  font-size: 8px;
}

/* ─── Settlement section ──────────────────────────────────── */
.settlement-section {
  margin-top: 24px;
  padding: 20px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border: 2px solid #86efac;
  border-radius: 12px;
}

.settlement-section h4 {
  margin: 0 0 16px;
  font-size: 16px;
  color: #166534;
  display: flex;
  align-items: center;
  gap: 8px;
}

.settlement-summary {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.saved-final-additions {
  margin-bottom: 16px;
  padding: 12px;
  background: linear-gradient(145deg, #ffffff 0%, #fffbeb 100%);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  container-name: saved-final-additions;
  container-type: inline-size;
}

.saved-final-additions-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.saved-final-additions-heading > div {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.saved-final-additions-heading > div > strong {
  color: #1f2937;
  font-size: 14px;
  font-weight: 750;
}

.saved-final-additions-heading > div > span {
  color: #64748b;
  font-size: 11px;
}

.saved-final-additions-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 23px;
  padding: 0 8px;
  color: #92400e;
  background: #fef3c7;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.saved-final-additions-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.saved-final-addition-row {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  color: #374151;
  font-size: 13px;
  overflow: hidden;
}

.saved-final-addition-context {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  padding: 8px 11px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.saved-final-addition-date {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
  color: #475569;
}

.saved-final-addition-date svg {
  flex: 0 0 auto;
  color: #64748b;
}

.saved-final-addition-date strong {
  color: #334155;
  font-size: 11px;
}

.saved-final-addition-date > span {
  padding: 1px 7px;
  color: #475569;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 650;
}

.saved-final-addition-session {
  color: #64748b;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.saved-final-addition-details {
  display: grid;
  grid-template-columns: minmax(140px, 1.25fr) minmax(95px, 0.75fr) 18px minmax(105px, 0.85fr);
  gap: 7px;
  align-items: stretch;
  padding: 9px 11px;
}

.saved-final-addition-person {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.saved-final-addition-person-icon {
  display: inline-flex;
  flex: 0 0 27px;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  color: #475569;
  background: #f1f5f9;
  border-radius: 50%;
}

.saved-final-addition-person > span:last-child,
.saved-final-addition-metric {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.saved-final-addition-person small,
.saved-final-addition-metric small {
  color: #64748b;
  font-size: 9px;
  font-weight: 650;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.saved-final-addition-person strong {
  color: #1f2937;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.saved-final-addition-metric {
  justify-content: center;
  padding: 5px 8px;
  border-radius: 7px;
}

.saved-final-addition-metric strong {
  font-size: 12px;
  white-space: nowrap;
}

.saved-final-addition-metric.is-addition {
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.saved-final-addition-metric.is-addition strong {
  color: #c2410c;
}

.saved-final-addition-metric.is-total {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.saved-final-addition-metric.is-total strong {
  color: #15803d;
}

.saved-final-addition-arrow {
  align-self: center;
  color: #94a3b8;
  font-size: 15px;
  text-align: center;
}

@container saved-final-additions (max-width: 600px) {
  .saved-final-addition-details {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .saved-final-addition-person {
    grid-column: 1 / -1;
    padding-bottom: 4px;
  }

  .saved-final-addition-arrow {
    display: none;
  }
}

@container saved-final-additions (max-width: 400px) {
  .saved-final-additions {
    padding: 13px;
  }

  .saved-final-addition-details {
    grid-template-columns: minmax(0, 1fr);
  }

  .saved-final-addition-person {
    grid-column: auto;
  }
}

.settlement-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.settlement-row:last-child {
  border-bottom: none;
  padding-top: 12px;
  margin-top: 4px;
  border-top: 2px solid #86efac;
}

.settlement-highlight {
  color: #16a34a;
  font-size: 16px;
  font-weight: 700;
}

.settlement-workers {
  min-width: 0;
  overflow: hidden;
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.settlement-workers h5 {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.settlement-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 13px;
}

.settlement-table th:nth-child(1) { width: 22%; }
.settlement-table th:nth-child(2) { width: 24%; }
.settlement-table th:nth-child(3) { width: 11%; }
.settlement-table th:nth-child(4) { width: 14%; }
.settlement-table th:nth-child(5) { width: 29%; }

.settlement-table th {
  background: #f8fafc;
  padding: 9px 8px;
  text-align: left;
  font-weight: 600;
  color: #475569;
  border-bottom: 2px solid #e2e8f0;
}

.settlement-table td {
  padding: 9px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
  overflow-wrap: anywhere;
}

.settlement-table tbody tr:hover {
  background: #f8fafc;
}

.settlement-table .numeric-cell {
  text-align: right;
}

.settlement-table .settlement-amount {
  font-weight: 700;
  color: #16a34a;
  font-size: 14px;
}

.settlement-amount-breakdown {
  display: inline-flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  max-width: 100%;
}

.settlement-amount-breakdown strong {
  color: #16a34a;
  font-size: 14px;
  white-space: nowrap;
}

.settlement-amount-breakdown small,
.settlement-manual-final-amount {
  color: #b45309;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.2;
  text-align: right;
  white-space: normal;
  overflow-wrap: anywhere;
}

.settlement-manual-final-amount {
  display: block;
  margin-top: 4px;
}

.settlement-loading {
  margin-top: 16px;
  padding: 16px;
  text-align: center;
  color: #64748b;
  font-style: italic;
  font-size: 14px;
}

/* Installation list pagination */
.list-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin: 8px 0;
  font-size: 13px;
}

.list-pagination-range {
  margin-right: auto;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/InstallationPlanning.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;;;;;;;;;;CAUC;;AAED;EACE,eAAe,UAAU,wBAAwB;AACnD;;AAEA,qDAAqD;AACrD;EACE,gDAAgD;AAClD;;AAEA,4CAA4C;AAC5C;EACE,2CAA2C;AAC7C;;AAEA,mCAAmC;AACnC;EACE,2CAA2C;AAC7C;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,6DAA6D;AAC/D;AACA,iBAAiB,cAAc,EAAE,mBAAmB,EAAE;AACtD,kBAAkB,cAAc,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAElF,iEAAiE;AACjE;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA,8BAA8B,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACjF,6BAA6B,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7G;EACE,oBAAoB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ;EACxE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe;AACxE;AACA;EACE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,SAAS,EAAE,UAAU,EAAE,qBAAqB;AACzF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA,uBAAuB,kBAAkB,EAAE;AAC3C,kBAAkB,mBAAmB,EAAE;AACvC,mBAAmB,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,2BAA2B;AAC7B;AACA,iBAAiB,mBAAmB,EAAE;AACtC;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC/E;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,MAAM;EACN,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;EACjC,kCAAkC;AACpC;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,6BAA6B,mBAAmB,EAAE;AAClD,8CAA8C,cAAc,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,mDAAmD;EACnD,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mEAAmE;EACnE,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA,qCAAqC,cAAc,EAAE;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA,iEAAiE;AACjE;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,YAAY,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC5E,aAAa,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAElE,iEAAiE;AACjE;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;EACtC,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;AACA,4BAA4B,gBAAgB,EAAE,sBAAsB,EAAE,aAAa,EAAE;;AAErF;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,qDAAqD;EACrD,0BAA0B;EAC1B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,6CAA6C,EAAE;AACvD;AACA;EACE,gBAAgB,EAAE,cAAc;EAChC,gBAAgB,EAAE,uBAAuB;EACzC,cAAc,EAAE,eAAe;AACjC;AACA;EACE,eAAe,EAAE,cAAc;EAC/B,cAAc,EAAE,gBAAgB,EAAE,uBAAuB;AAC3D;AACA;EACE,eAAe,EAAE,cAAc;EAC/B,cAAc,EAAE,gBAAgB,EAAE,uBAAuB;AAC3D;AACA;EACE,eAAe,EAAE,cAAc,EAAE,gBAAgB;EACjD,cAAc,EAAE,gBAAgB,EAAE,uBAAuB;AAC3D;AACA,aAAa,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;;AAE9D,iEAAiE;AACjE;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,QAAQ;EACR,qCAAqC;AACvC;AACA,uCAAuC,eAAe,EAAE;AACxD,4CAA4C,eAAe,EAAE;AAC7D,yCAAyC,eAAe,EAAE;AAC1D,sCAAsC,eAAe,EAAE;;AAEvD,iEAAiE;AACjE;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAE,YAAY;EAC7B,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;AACA,wCAAwC,WAAW,EAAE;AACrD,8CAA8C,uBAAuB,EAAE;AACvE,8CAA8C,mBAAmB,EAAE,kBAAkB,EAAE;;AAEvF,iEAAiE;AACjE;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA,gBAAgB,aAAa,EAAE,QAAQ,EAAE,SAAO,EAAE;AAClD;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA,sBAAsB,aAAa,EAAE,qBAAqB,EAAE;AAC5D;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AAC3F,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AACzF,wBAAwB,gBAAgB,EAAE,kBAAkB,EAAE;AAC9D,uBAAuB,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE;AACtE,uBAAuB,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACvG,oBAAoB,gBAAgB,EAAE,oBAAoB,EAAE,qCAAqC,EAAE;AACnG,mBAAmB,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE;;AAEnE;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,6BAA6B,mBAAmB,EAAE;AAClD,+BAA+B,mBAAmB,EAAE;AACpD,YAAY,2BAA2B,EAAE;AACzC,2BAA2B,mBAAmB,EAAE;AAChD;EACE,mBAAmB;AACrB;AACA,eAAe,kBAAkB,EAAE,WAAW,EAAE,yBAAyB,EAAE;AAC3E,eAAe,eAAe,EAAE,cAAc,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AACnE,uBAAuB,qBAAqB,EAAE,2CAA2C,EAAE;AAC3F,mBAAmB,qBAAqB,EAAE,YAAY,EAAE;;AAExD,mBAAmB;AACnB;EACE,WAAW,EAAE,yBAAyB,EAAE,mBAAmB;EAC3D,mBAAmB,EAAE,eAAe;AACtC;AACA;EACE,iBAAiB,EAAE,mBAAmB,EAAE,cAAc;EACtD,gBAAgB,EAAE,gCAAgC,EAAE,kBAAkB;EACtE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB,EAAE,gCAAgC,EAAE,cAAc;EACnE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,kBAAkB;AACpF;AACA,+BAA+B,kBAAkB,EAAE;AACnD;gCACgC,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACnG,yCAAyC,mBAAmB,EAAE;AAC9D,iCAAiC,mBAAmB,EAAE;AACtD,6BAA6B,mBAAmB,EAAE,6BAA6B,EAAE;AACjF,mBAAmB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,6BAA6B,EAAE;AAC5I,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACpF,8BAA8B,mBAAmB,EAAE;AACnD,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACxG,gCAAgC,mBAAmB,EAAE;AACrD,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACvF,iCAAiC,mBAAmB,EAAE;AACtD,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACxG,gCAAgC,mBAAmB,EAAE;;AAErD,6BAA6B,mBAAmB,EAAE;AAClD,cAAc,WAAW,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACvK,4BAA4B,iBAAiB,EAAE;AAC/C,+BAA+B;AAC/B;yCACyC,wBAAwB,EAAE,SAAS,EAAE;AAC9E,2BAA2B,0BAA0B,EAAE;AACvD,gBAAgB,kBAAkB,EAAE,cAAc,EAAE,aAAa,EAAE,kBAAkB,EAAE;AACvF,gBAAgB,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACrE,cAAc,gBAAgB,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACzE,gBAAgB,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAClG,gBAAgB,iBAAiB,EAAE;AACnC,gBAAgB,mBAAmB,EAAE;AACrC,uBAAuB,gBAAgB,EAAE;AACzC;EACE,qBAAqB;EACrB,gBAAgB,EAAE,mBAAmB;EACrC,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACvE;AACA;EACE,qBAAqB;EACrB,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;AACxD;;AAEA,iEAAiE;AACjE,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC5E,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;AAC5E;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;AACA,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACvE;EACE,aAAa,EAAE,QAAQ,EAAE,eAAe;EACxC,mBAAmB,EAAE,aAAa;EAClC,mBAAmB,EAAE,0BAA0B,EAAE,kBAAkB;AACrE;AACA;EACE,SAAO,EAAE,eAAe;EACxB,iBAAiB,EAAE,2BAA2B,EAAE,kBAAkB,EAAE,eAAe;AACrF;AACA,8BAA8B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/E;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB,EAAE,2BAA2B,EAAE,kBAAkB,EAAE,gBAAgB;EACrF,2BAA2B;AAC7B;AACA,wBAAwB,sCAAsC,EAAE;AAChE,2BAA2B,aAAa,EAAE;AAC1C,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACrE,sBAAsB,eAAe,EAAE,cAAc,EAAE;AACvD,gBAAgB,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAChI,YAAY,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC5H,qBAAqB,aAAa,EAAE,QAAQ,EAAE;AAC9C,oBAAoB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAChG,0BAA0B,SAAO,EAAE,eAAe,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACxI;EACE,2BAA2B,EAAE,mBAAmB;EAChD,aAAa,EAAE,gBAAgB,EAAE,2BAA2B;AAC9D;AACA,mBAAmB,sCAAsC,EAAE;AAC3D,eAAe,aAAa,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5G,aAAa,eAAe,EAAE,cAAc,EAAE;AAC9C,gBAAgB,aAAa,EAAE,QAAQ,EAAE;AACzC,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACxG;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB;AAC5F;AACA;EACE,WAAW,EAAE,iBAAiB;EAC9B,4BAA4B,EAAE,kBAAkB;EAChD,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,eAAe;AACvE;;AAEA,iEAAiE;AACjE;EACE,eAAe,EAAE,QAAQ;EACzB,+BAA+B;EAC/B,aAAa;EACb,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,0BAA0B;AAC5B;AACA;EACE,gBAAgB,EAAE,mBAAmB;EACrC,YAAY,EAAE,eAAe,EAAE,gBAAgB;EAC/C,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,oEAAoE;AACpE;EACE,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE,uBAAuB,EAAE,kCAAkC;EAC3D,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;AACpE;AACA,mBAAmB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjF,eAAe,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACjH,qBAAqB,cAAc,EAAE;;AAErC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB,EAAE,mBAAmB,EAAE,cAAc;EACvD,kBAAkB,EAAE,eAAe,EAAE,yBAAyB;AAChE;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,SAAO;AACT;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,cAAc,kBAAkB,EAAE;AAClC,aAAa,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACvE;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,eAAe,EAAE,cAAc,EAAE,gBAAgB;EACjD,sBAAsB,EAAE,yBAAyB;AACnD;AACA;EACE,iBAAiB,EAAE,2BAA2B,EAAE,kBAAkB;EAClE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,8BAA8B;AACnF;AACA,kDAAkD,aAAa,EAAE,qBAAqB,EAAE;AACxF;EACE,WAAW,EAAE,sBAAsB;EACnC,iBAAiB,EAAE,2BAA2B,EAAE,kBAAkB;EAClE,eAAe,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,cAAc;AACzE;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;EACjD,QAAQ;EACR,gBAAgB;AAClB;;AAEA,mDAAmD,mBAAmB,EAAE;AACxE,wDAAwD,mBAAmB,EAAE;AAC7E,qDAAqD,mBAAmB,EAAE;AAC1E,oDAAoD,mBAAmB,EAAE;AACzE,mDAAmD,mBAAmB,EAAE;AACxE,mDAAmD,mBAAmB,EAAE;AACxE,2DAA2D,mBAAmB,EAAE;AAChF,kDAAkD,mBAAmB,EAAE;;AAEvE;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA,mDAAmD,mBAAmB,EAAE;EACxE,wDAAwD,mBAAmB,EAAE;EAC7E;qDACmD,mBAAmB,EAAE;EACxE,mDAAmD,mBAAmB,EAAE;EACxE,2DAA2D,mBAAmB,EAAE;AAClF;AACA;EACE,kBAAkB,EAAE,+BAA+B;EACnD,aAAa,EAAE,yBAAyB,EAAE,SAAS;AACrD;AACA,uBAAuB,gBAAgB,EAAE,iBAAiB,EAAE,+BAA+B,EAAE;AAC7F,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC/F,wBAAwB,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AAChI,yBAAyB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACjH,wBAAwB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzH,wBAAwB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC7E,uBAAuB,cAAc,EAAE,eAAe,EAAE;AACxD,mBAAmB,gBAAgB,EAAE,UAAU,EAAE,SAAS,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7G;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe;AAC7E;AACA,6BAA6B;AAC7B;EACE,aAAa,EAAE,sBAAsB,EAAE,MAAM;EAC7C,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB;EACzD,yBAAyB;AAC3B;AACA;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB;AACzD;AACA;EACE,gBAAgB,EAAE,UAAU,EAAE,SAAS;EACvC,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,0BAA0B,EAAE,eAAe,EAAE,cAAc;EAC3D,6BAA6B;AAC/B;AACA,+BAA+B,mBAAmB,EAAE;AACpD,eAAe,SAAO,EAAE;AACxB;EACE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB;EACnE,gBAAgB,EAAE,kBAAkB;AACtC;AACA,uCAAuC;AACvC;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,6BAA6B,EAAE,eAAe;AACnE;AACA,wCAAwC,SAAO,EAAE,gBAAgB,EAAE;AACnE;EACE,cAAc,EAAE,WAAW,EAAE,gBAAgB;EAC7C,gBAAgB,EAAE,0BAA0B,EAAE,cAAc;EAC5D,eAAe,EAAE,iBAAiB,EAAE,kBAAkB;EACtD,eAAe,EAAE,eAAe,EAAE,2CAA2C;AAC/E;AACA,wBAAwB,qBAAqB,EAAE,cAAc,EAAE;AAC/D,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/F,qBAAqB,SAAO,EAAE,iBAAiB,EAAE,2BAA2B,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAEnH,iEAAiE;AACjE;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,mBAAmB,EAAE,WAAW,EAAE,YAAY;EAC9C,iBAAiB,EAAE,kBAAkB,EAAE,eAAe;EACtD,eAAe,EAAE,gBAAgB;EACjC,8CAA8C;EAC9C,yCAAyC;AAC3C;AACA,qBAAqB,mBAAmB,EAAE,yCAAyC,EAAE;AACrF,wBAAwB,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACpF;EACE,mBAAmB,EAAE,cAAc;EACnC,2BAA2B,EAAE,iBAAiB;EAC9C,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,4BAA4B;AACpF;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,eAAe,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AACxI,qBAAqB,mBAAmB,EAAE;AAC1C,cAAc,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AACvI,oBAAoB,mBAAmB,EAAE;AACzC,eAAe,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACxL,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,mBAAmB,EAAE,mBAAmB,EAAE;AAClE,UAAU,4BAA4B,EAAE,0BAA0B,EAAE;AACpE,mBAAmB,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3I,yBAAyB,mBAAmB,EAAE;;AAE9C,iEAAiE;AACjE;EACE,mBAAmB,EAAE,cAAc;EACnC,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB;EAC3D,eAAe,EAAE,eAAe,EAAE,2BAA2B;AAC/D;AACA,gBAAgB,cAAc,EAAE,aAAa,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAExG;;iEAEiE;;AAEjE,mBAAmB;AACnB,WAAW,eAAe,EAAE;;AAE5B,mBAAmB;AACnB;EACE,aAAa,EAAE,QAAQ,EAAE,mBAAmB;EAC5C,gCAAgC,EAAE,iBAAiB;AACrD;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,uBAAuB;EACvD,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,eAAe,EAAE,0BAA0B,EAAE,kBAAkB;EAC/D,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,uCAAuC;AACzC;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD;EACE,cAAc,EAAE,mBAAmB;EACnC,gCAAgC,EAAE,mBAAmB;AACvD;AACA;EACE,mBAAmB,EAAE,cAAc;EACnC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB;AAC1E;AACA,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;;AAExE,oBAAoB;AACpB,cAAc,gBAAgB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,aAAa,EAAE;;AAE/F,mBAAmB;AACnB;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE,eAAe;AACrF;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAClF;EACE,mBAAmB,EAAE,cAAc;EACnC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB;AAC1E;AACA,cAAc,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAChG;EACE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB;EAChE,eAAe,EAAE,YAAY;AAC/B;AACA,mBAAmB,aAAa,EAAE,qBAAqB,EAAE;AACzD;EACE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB;EAChE,eAAe,EAAE,gBAAgB,EAAE,eAAe;AACpD;;AAEA,mCAAmC;AACnC;EACE,WAAW,EAAE,yBAAyB,EAAE,iBAAiB;AAC3D;AACA;EACE,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB,EAAE,cAAc;EACnC,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB;EACnF,kCAAkC;AACpC;AACA;EACE,kBAAkB,EAAE,gCAAgC,EAAE,sBAAsB;AAC9E;AACA,6BAA6B,mBAAmB,EAAE;AAClD,wBAAwB,mBAAmB,EAAE;AAC7C,YAAY,kBAAkB,EAAE,cAAc,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;;AAE9F,uBAAuB;AACvB;EACE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;EAC/D,eAAe,EAAE,WAAW;AAC9B;AACA,cAAc,sBAAsB,EAAE,kBAAkB,EAAE;;AAE1D,eAAe;AACf;EACE,qBAAqB,EAAE,mBAAmB,EAAE,cAAc;EAC1D,yBAAyB,EAAE,eAAe,EAAE,gBAAgB;EAC5D,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE,kBAAkB;AAC5E;AACA;EACE,qBAAqB,EAAE,mBAAmB,EAAE,cAAc;EAC1D,yBAAyB,EAAE,eAAe,EAAE,gBAAgB;EAC5D,gBAAgB,EAAE,mBAAmB;AACvC;;AAEA,YAAY;AACZ;EACE,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,gBAAgB;EAC9D,iBAAiB,EAAE,6BAA6B;AAClD;AACA;EACE,SAAO,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe;AAC5F;AACA,sBAAsB,aAAa,EAAE,qBAAqB,EAAE;;AAE5D,6BAA6B;AAC7B,yBAAyB,WAAW,EAAE,cAAc,EAAE,eAAe,EAAE;AACvE,0BAA0B,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9G,YAAY,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/D,YAAY,gBAAgB,EAAE,cAAc,EAAE;AAC9C,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE;EACE,qBAAqB,EAAE,mBAAmB,EAAE,cAAc;EAC1D,yBAAyB,EAAE,eAAe,EAAE,gBAAgB;EAC5D,iBAAiB,EAAE,mBAAmB;AACxC;AACA,YAAY,cAAc,EAAE,eAAe,EAAE;AAC7C,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrE,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrE,mBAAmB,YAAY,EAAE;AACjC,oBAAoB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAClE,eAAe,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,yBAAyB,EAAE;;AAEpF,iBAAiB;AACjB,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC1J,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC1J,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC1J,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,mBAAmB,EAAE;;AAE9C,+BAA+B;AAC/B,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAChM,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7K,oBAAoB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAClM,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,mBAAmB,EAAE;AAC9C,2BAA2B,mBAAmB,EAAE;;AAEhD,UAAU,2BAA2B,EAAE,0BAA0B,EAAE;AACnE,eAAe,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AACxI,qBAAqB,mBAAmB,EAAE;AAC1C,WAAW,gBAAgB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;AACjK,iBAAiB,mBAAmB,EAAE;;AAEtC,mEAAmE;AACnE;EACE,aAAa,EAAE,4DAA4D,EAAE,SAAS;EACtF,gBAAgB;AAClB;AACA;EACE,gBAAgB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,gBAAgB;EACpF,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,mBAAmB;EAC/E,gCAAgC,EAAE,QAAQ;AAC5C;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO,EAAE,YAAY,EAAE;AAC3F,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnE,gBAAgB,eAAe,EAAE,cAAc,EAAE;AACjD,qBAAqB,aAAa,EAAE,QAAQ,EAAE;AAC9C;EACE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB;EACpE,mBAAmB,EAAE,gCAAgC;EACrD,yBAAyB,EAAE,qBAAqB;AAClD;AACA,mBAAmB,iBAAiB,EAAE,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChG;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB;EAC9D,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB;AACpE;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB;EAClE,cAAc,EAAE,eAAe,EAAE,gBAAgB;EACjD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc;AAC7E;AACA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO,EAAE,YAAY,EAAE;AAC1F,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACrE,kBAAkB,eAAe,EAAE,cAAc,EAAE;AACnD,kBAAkB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAChE,SAAS,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EACzE,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E;EACE,iBAAiB,EAAE,6BAA6B;AAClD;AACA;EACE,WAAW,EAAE,iBAAiB,EAAE,0BAA0B;EAC1D,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,eAAe;AAC3F;AACA,oBAAoB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAChG;EACE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,SAAO,EAAE,eAAe;AAC5G;;AAEA,mEAAmE;AACnE;EACE,gBAAgB,EAAE,mBAAmB,EAAE,UAAU;EACjD,YAAY,EAAE,eAAe,EAAE,gBAAgB;EAC/C,gBAAgB,EAAE,aAAa,EAAE,sBAAsB;EACvD,uCAAuC;AACzC;AACA;EACE,aAAa,EAAE,8BAA8B,EAAE,uBAAuB;EACtE,uBAAuB,EAAE,mBAAmB,EAAE,4BAA4B;EAC1E,gBAAgB,EAAE,MAAM,EAAE,UAAU;AACtC;AACA;EACE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjE,yBAAyB,EAAE,qBAAqB,EAAE,kBAAkB;AACtE;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE;EACE,gCAAgC,EAAE,cAAc,EAAE,YAAY;EAC9D,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe;AACxE;;AAEA,qBAAqB;AACrB,mBAAmB,kBAAkB,EAAE,gCAAgC,EAAE;AACzE;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB;AACpB;AACA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE,QAAQ,EAAE;AACrH;EACE,qBAAqB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;AACtE;AACA,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD;EACE,aAAa,EAAE,qCAAqC,EAAE,QAAQ;AAChE;AACA;EACE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACrE,cAAc,EAAE,yBAAyB;AAC3C;AACA;EACE,kBAAkB,EAAE,cAAc,EAAE,kBAAkB;EACtD,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,0BAA0B;AAC5B;AACA,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnF,4BAA4B,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnF,iCAAiC,eAAe,EAAE;AAClD,uCAAuC,mBAAmB,EAAE,cAAc,EAAE;AAC5E,yBAAyB,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACzG,yBAAyB,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACzG,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAChF,mBAAmB;AACnB;EACE,eAAe,EAAE,cAAc,EAAE,kBAAkB;EACnD,kBAAkB,EAAE,gBAAgB;AACtC;AACA,mBAAmB,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,uBAAuB,EAAE;AAC1G;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc;EAC/D,eAAe,EAAE,cAAc,EAAE,cAAc;AACjD;AACA,uBAAuB,cAAc,EAAE;;AAEvC,kBAAkB;AAClB,oBAAoB,kBAAkB,EAAE,gCAAgC,EAAE;AAC1E,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC5I;EACE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB;EACnF,gBAAgB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,iBAAiB;AAChF;AACA,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB;EAC/D,kBAAkB,EAAE,kBAAkB,EAAE,6BAA6B;AACvE;AACA,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE;AAClE,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE;AAClE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,SAAO,EAAE;AAC5G,YAAY,cAAc,EAAE;AAC5B,kBAAkB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACrI,oBAAoB,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AAChE,mBAAmB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7J,yBAAyB,mBAAmB,EAAE;AAC9C,mBAAmB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7J,wBAAwB,mBAAmB,EAAE;AAC7C,gBAAgB,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAErE,sBAAsB;AACtB,mBAAmB,kBAAkB,EAAE;AACvC,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACnD;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe;EACjF,gBAAgB;AAClB;AACA,wDAAwD,aAAa,EAAE,qBAAqB,EAAE;;AAE9F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB;EACrD,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB;EACxE,mBAAmB,EAAE,cAAc;AACrC;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,kBAAkB,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAExE,mEAAmE;AACnE,iBAAiB,gBAAgB,EAAE;AACnC,uBAAuB,gBAAgB,EAAE;AACzC,aAAa,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC5F;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACnD;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;AACrG;AACA,kDAAkD,aAAa,EAAE,qBAAqB,EAAE;AACxF;EACE,aAAa,EAAE,eAAe,EAAE,SAAS;EACzC,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe,EAAE,cAAc,EAAE,eAAe;AAClD;AACA,uCAAuC,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;;AAEnF,iEAAiE;AACjE;EACE,mBAAmB,EAAE,2BAA2B;EAChD,mBAAmB,EAAE,kBAAkB,EAAE,cAAc;AACzD;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB;AACvE;AACA;EACE,qBAAqB,EAAE,UAAU;EACjC,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AAClF;AACA;EACE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAClE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe;AACvE;AACA,iCAAiC,mBAAmB,EAAE;;AAEtD,kEAAkE;AAClE;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,QAAQ,EAAE,mBAAmB;EAC5C,gCAAgC;AAClC;AACA;EACE,YAAY,EAAE,oCAAoC,EAAE,uBAAuB;EAC3E,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB;EAClE,mBAAmB,EAAE,iBAAiB;AACxC;AACA,uBAAuB,cAAc,EAAE;AACvC,wBAAwB,4BAA4B,EAAE,cAAc,EAAE;AACtE;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,QAAQ;AACV;AACA,kCAAkC,cAAc,EAAE,eAAe,EAAE;AACnE,gCAAgC,cAAc,EAAE,eAAe,EAAE;AACjE;EACE,aAAa;EACb,6CAA6C;EAC7C,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0DAA0D;IAC1D,WAAW;EACb;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,wCAAwC,cAAc,EAAE;;AAExD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4FAA4F;EAC5F,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;;AAEhD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   InstallationPlanning.css  –  Professional calendar styles\n═══════════════════════════════════════════════════════════════ */\n\n/* ─── Breadcrumb Navigation ────────────────────────────────── */\n.installation-planning .breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.installation-planning .breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #3b82f6;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.installation-planning .breadcrumb-link:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.installation-planning .breadcrumb-separator {\n  color: #94a3b8;\n  user-select: none;\n}\n\n.installation-planning .breadcrumb-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #0f172a;\n  font-weight: 500;\n}\n\n.installation-planning .breadcrumb-icon {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  stroke-width: 1.9;\n}\n\n/* ─── Full-height page layout ──────────────────────────────── */\n/*\n  Overhead offsets:\n    60px  – top navbar\n    48px  – main-content padding (24px × 2)\n    58px  – .page-header (h2 + margin-bottom)\n    69px  – .tab-bar (height + margin-bottom)\n    66px  – .calendar-toolbar (height + margin-bottom)\n    44px  – .calendar-legend (height + margin)\n    40px  – .calendar-week-header (row with day names)\n  ≈ 385px total before calendar cells\n*/\n\n.installation-planning.page-container {\n  max-width: none;         /* use full page width */\n}\n\n/* Month view: cells fill available viewport height */\n.calendar-cell {\n  min-height: max(90px, calc((100vh - 385px) / 6));\n}\n\n/* Week view: columns fill viewport height */\n.week-day-col {\n  min-height: max(300px, calc(100vh - 310px));\n}\n\n/* Day view: fill viewport height */\n.calendar-day {\n  min-height: max(300px, calc(100vh - 310px));\n}\n\n/* ─── Tab bar ──────────────────────────────────────────────── */\n.tab-bar {\n  display: flex;\n  gap: 2px;\n  border-bottom: 2px solid #e2e8f0;\n  margin-bottom: 24px;\n}\n.tab-btn {\n  padding: 11px 22px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  border-radius: 6px 6px 0 0;\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\n}\n.tab-btn:hover { color: #2563eb; background: #f0f7ff; }\n.tab-btn.active { color: #2563eb; border-bottom-color: #2563eb; font-weight: 700; }\n\n/* ─── Calendar toolbar ─────────────────────────────────────── */\n.installation-days-picker {\n  grid-column: 1 / -1;\n  min-width: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 12px;\n}\n.installation-days-picker p { margin: 0 0 10px; font-size: 13px; color: #475569; }\n.installation-days-options { display: flex; gap: 10px; flex-wrap: wrap; max-height: 240px; overflow-y: auto; }\n.form-grid .installation-days-options label {\n  display: inline-flex; flex-direction: row; align-items: center; gap: 8px;\n  padding: 8px; background: #f8fafc; border-radius: 6px; cursor: pointer;\n}\n.form-grid .installation-days-options input[type=\"checkbox\"] {\n  width: 18px; height: 18px; flex: 0 0 18px; margin: 0; padding: 0; accent-color: #2563eb;\n}\n\n.calendar-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n.view-switcher {\n  display: flex;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n.btn-view {\n  padding: 7px 16px;\n  border: none;\n  border-right: 1.5px solid #cbd5e1;\n  background: #f8fafc;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  transition: all 0.15s;\n}\n.btn-view:last-child { border-right: none; }\n.btn-view:hover { background: #e2e8f0; }\n.btn-view.active { background: #2563eb; color: #fff; font-weight: 700; }\n\n.nav-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f8fafc;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 4px 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n.btn-nav {\n  background: none;\n  border: none;\n  border-radius: 6px;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  color: #475569;\n  display: flex; align-items: center; justify-content: center;\n  transition: background 0.1s;\n}\n.btn-nav:hover { background: #e2e8f0; }\n.current-label {\n  font-weight: 700;\n  font-size: 15px;\n  min-width: 220px;\n  text-align: center;\n  color: #1e293b;\n  letter-spacing: -0.01em;\n}\n\n.calendar-order-search {\n  position: relative;\n  min-width: 260px;\n}\n\n.calendar-order-search-controls {\n  display: flex;\n  gap: 6px;\n}\n\n.calendar-order-search-controls input {\n  width: 210px;\n  padding: 7px 10px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.calendar-order-search-controls input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.calendar-order-search-status {\n  position: absolute;\n  z-index: 45;\n  top: calc(100% + 5px);\n  left: 0;\n  width: max-content;\n  max-width: 360px;\n  padding: 7px 10px;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);\n  font-size: 12px;\n}\n\n.calendar-order-search-status.success {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.calendar-order-search-status.error {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.order-number-suggestions {\n  position: absolute;\n  z-index: 50;\n  top: calc(100% + 5px);\n  left: 0;\n  width: min(430px, 90vw);\n  max-height: 280px;\n  overflow-y: auto;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);\n}\n\n.calendar-order-search-status + .order-number-suggestions {\n  top: calc(100% + 36px);\n}\n\n.order-number-suggestion-row {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.order-number-suggestion-row:last-child {\n  border-bottom: 0;\n}\n\n.order-number-suggestion-main {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 3px;\n  flex: 1;\n  min-width: 0;\n  padding: 9px 12px;\n  border: 0;\n  background: #fff;\n  color: #1e293b;\n  text-align: left;\n  cursor: pointer;\n}\n\n.order-number-suggestion-main:hover {\n  background: #eff6ff;\n}\n\n.order-number-suggestions span {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.order-number-suggestions .order-number-suggestion-note {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  color: #475569;\n  font-style: italic;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.order-number-suggestion-add {\n  width: 42px;\n  border: 0;\n  border-left: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #2563eb;\n  font-size: 24px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.order-number-suggestion-add:hover {\n  background: #dbeafe;\n}\n\n.daily-print-menu {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.quick-add-menu {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.calendar-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n  flex-wrap: wrap;\n}\n\n.calendar-toolbar-actions > .btn-sm,\n.calendar-toolbar-actions > .daily-print-menu > .btn-sm,\n.calendar-toolbar-actions > .quick-add-menu > .btn-sm,\n.calendar-toolbar-checkbox {\n  min-height: 36px;\n  box-sizing: border-box;\n  font-size: 14px;\n}\n\n.calendar-toolbar-actions > .btn-sm,\n.calendar-toolbar-actions > .daily-print-menu > .btn-sm,\n.calendar-toolbar-actions > .quick-add-menu > .btn-sm {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 7px 12px;\n  white-space: nowrap;\n}\n\n.calendar-toolbar-actions .calendar-toolbar-action-button {\n  width: 160px;\n  height: 36px;\n  min-height: 36px;\n  padding: 7px 12px !important;\n  font-size: 14px !important;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.calendar-toolbar-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 4px;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.calendar-toolbar-checkbox input[type=\"checkbox\"] {\n  width: 19px;\n  height: 19px;\n  margin: 0;\n  flex: 0 0 19px;\n  cursor: pointer;\n  accent-color: #2563eb;\n}\n\n.daily-print-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 40;\n  min-width: 270px;\n  padding: 12px;\n  background: #fff;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n}\n\n.daily-print-dropdown label {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n}\n\n.daily-print-dropdown input[type=\"date\"] {\n  height: 32px;\n  width: 100%;\n  padding: 5px 8px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.daily-print-dropdown .btn-sm {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.daily-print-count {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.daily-print-dropdown .daily-print-options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.daily-print-dropdown .daily-print-options .btn-sm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 48px;\n  margin-top: 0;\n  gap: 2px;\n}\n\n.daily-print-options small {\n  font-size: 9px;\n  font-weight: 400;\n  opacity: 0.85;\n}\n\n.daily-print-dropdown .daily-print-options .daily-print-amounts {\n  grid-column: 1 / -1;\n  border-color: #86efac;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.daily-print-error {\n  margin-top: 9px;\n  color: #b91c1c;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n/* ─── Legend ───────────────────────────────────────────────── */\n.calendar-legend {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 14px;\n  font-size: 12px;\n  color: #475569;\n  flex-wrap: wrap;\n  align-items: center;\n}\n.legend-item { display: flex; align-items: center; gap: 7px; font-weight: 500; }\n.legend-dot {\n  width: 14px; height: 14px;\n  border-radius: 4px;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* ─── MONTH VIEW ───────────────────────────────────────────── */\n.calendar-month {\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1.5px solid #d1d5db;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);\n}\n.calendar-week-header {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  background: #f9fafb;\n  border-bottom: 2px solid #d1d5db;\n}\n.calendar-day-name {\n  text-align: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b7280;\n  padding: 12px 6px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  background: #ffffff;\n  gap: 0;\n  border-left: 1.5px solid #d1d5db;\n  border-top: 1.5px solid #d1d5db;\n}\n.calendar-cell {\n  background: #ffffff;\n  padding: 8px;\n  position: relative;\n  transition: background 0.12s;\n  cursor: default;\n  border-right: 1.5px solid #d1d5db;\n  border-bottom: 1.5px solid #d1d5db;\n}\n.calendar-cell:hover { background: #f3f4f6; }\n.calendar-cell.other-month { background: #fafafa; }\n.calendar-cell.other-month .cell-day-number { color: #d1d5db; }\n.calendar-cell.today { background: #eff6ff; }\n.calendar-cell.drag-over {\n  background: #dbeafe !important;\n  outline: 2px dashed #3b82f6;\n  outline-offset: -2px;\n  box-shadow: inset 0 0 12px rgba(59, 130, 246, 0.15);\n  transition: all 0.2s ease;\n}\n.cell-day-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  margin-bottom: 4px;\n}\n.calendar-cell.today .cell-day-number {\n  background: #2563eb;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: 0 2px 8px rgba(37,99,235,0.40);\n}\n.cell-installations { display: flex; flex-direction: column; gap: 3px; }\n.team-group-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 3px;\n  background: #f8fafc;\n  border-radius: 4px;\n  border-left: 3px solid #3b82f6;\n}\n.team-group-section.unassigned-section {\n  background: #fef3c7;\n  border-left-color: #f59e0b;\n}\n.team-group-label {\n  font-size: 9px;\n  font-weight: 700;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 2px;\n  padding: 0 2px;\n}\n.unassigned-section .team-group-label {\n  color: #92400e;\n}\n.more-badge {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n  padding: 1px 6px;\n  background: #f1f5f9;\n  border-radius: 4px;\n  width: fit-content;\n  margin-top: 1px;\n}\n\n/* ─── WEEK VIEW ────────────────────────────────────────────── */\n.calendar-week {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  border: 1.5px solid #d1d5db;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);\n  background: #d1d5db;\n  gap: 1px;\n}\n.week-day-col {\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n.week-day-col.today { background: #f0f7ff; }\n.week-day-col.drag-over {\n  background: #dbeafe !important;\n  outline: 2px dashed #3b82f6;\n  outline-offset: -2px;\n  transition: all 0.2s ease;\n}\n.week-day-header {\n  padding: 12px 8px 10px;\n  text-align: center;\n  border-bottom: 2px solid #d1d5db;\n  background: #f9fafb;\n}\n.week-day-col.today .week-day-header {\n  background: #eff6ff;\n  border-bottom-color: #bfdbfe;\n}\n.week-day-name {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b7280;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n.week-day-col.today .week-day-name { color: #2563eb; }\n.week-day-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n  width: 40px; height: 40px;\n  border-radius: 50%;\n}\n.week-day-num.today-num {\n  background: #2563eb;\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(37,99,235,0.40);\n}\n.week-day-body {\n  padding: 8px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n/* ─── DAY VIEW ─────────────────────────────────────────────── */\n.calendar-day {\n  border: 1.5px solid #d1d5db;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n}\n.calendar-day.drag-over {\n  background: #dbeafe;\n  outline: 2px dashed #3b82f6;\n  outline-offset: -2px;\n  transition: all 0.2s ease;\n}\n.day-header {\n  background: #f9fafb;\n  padding: 18px 24px;\n  border-bottom: 2px solid #d1d5db;\n}\n.day-date-label { font-size: 20px; font-weight: 700; color: #111827; }\n.day-body { padding: 16px; display: flex; flex-direction: column; gap: 8px; }\n.day-empty { color: #9ca3af; font-style: italic; padding: 20px 0; }\n\n/* ─── Installation card – compact (on calendar grid) ───────── */\n.installation-card {\n  padding: 3px 7px 4px 9px;\n  border-radius: 5px;\n  background: #fff;\n  border: 1.5px solid #94a3b8;\n  border-left: 6px solid #94a3b8;\n  cursor: grab;\n  overflow: visible;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: box-shadow 0.12s, transform 0.08s;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.09);\n  user-select: none;\n  position: relative;\n}\n.installation-card:hover {\n  box-shadow: 0 3px 10px rgba(0,0,0,0.16);\n  transform: translateY(-1px);\n}\n.installation-card:active { cursor: grabbing; transform: scale(0.97); opacity: 0.85; }\n\n.installation-card--note {\n  cursor: pointer;\n  white-space: normal;\n}\n\n.installation-card--note:active {\n  cursor: pointer;\n}\n\n.installation-card--note .card-order {\n  display: -webkit-box;\n  overflow: hidden;\n  white-space: normal;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 1.3;\n}\n\n.installation-card--note .card-note-description {\n  display: -webkit-box;\n  overflow: hidden;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  color: #475569;\n  font-size: 10px;\n  line-height: 1.3;\n}\n\n.calendar-note-icon {\n  margin-right: 4px;\n}\n\n.team-installation-order-item {\n  display: flex;\n  align-items: stretch;\n  gap: 3px;\n  min-width: 0;\n}\n\n.team-installation-order-item .installation-card {\n  flex: 1;\n  min-width: 0;\n}\n\n.team-installation-order-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 0 0 22px;\n}\n\n.team-installation-order-controls button {\n  flex: 1;\n  min-height: 18px;\n  padding: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.team-installation-order-controls button:hover:not(:disabled) {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.team-installation-order-controls button:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.team-order-error {\n  margin-bottom: 8px;\n  padding: 8px 10px;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 12px;\n}\n\n.team-day-comment {\n  display: -webkit-box;\n  margin-bottom: 3px;\n  padding: 4px 6px;\n  overflow: hidden;\n  border: 1px solid #fbbf24;\n  border-radius: 5px;\n  background: #fffbeb;\n  color: #78350f;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n}\n\n.team-day-comment span {\n  margin-right: 3px;\n}\n\n.team-vacation-comment {\n  margin-bottom: 3px;\n  padding: 4px 6px;\n  overflow-wrap: anywhere;\n  border: 1px solid;\n  border-radius: 5px;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.team-vacation-comment.planned {\n  border-color: #f59e0b;\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.team-vacation-comment.approved {\n  border-color: #ef4444;\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.team-comment-modal {\n  width: min(520px, 94vw);\n}\n\n.team-comment-label {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  color: #475569;\n  font-size: 13px;\n}\n\n.team-comment-label textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  resize: vertical;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 7px;\n  color: #1e293b;\n  font: inherit;\n  line-height: 1.45;\n}\n\n.team-comment-label textarea:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.team-comment-copy-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 14px;\n}\n\n.team-comment-copy-controls span {\n  color: #64748b;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.team-comment-calendar-toggle {\n  padding: 7px 10px;\n}\n\n.team-comment-date-picker {\n  margin-top: 10px;\n}\n\n.team-comment-date-picker .source-date {\n  box-shadow: inset 0 0 0 2px #1d4ed8;\n}\n\n.team-comment-team-picker {\n  margin: 14px 0 0;\n  padding: 10px 12px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n}\n\n.team-comment-team-picker legend {\n  padding: 0 5px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.team-comment-team-picker > div {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 12px;\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.team-comment-team-picker label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  color: #334155;\n  font-size: 13px;\n}\n\n.team-comment-team-picker label span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.team-comment-settlement-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 14px;\n  padding: 10px 12px;\n  border: 1px solid #bfdbfe;\n  border-radius: 7px;\n  background: #eff6ff;\n  color: #1e3a8a;\n  cursor: pointer;\n}\n\n.team-comment-settlement-option input {\n  margin-top: 3px;\n}\n\n.team-comment-settlement-option span {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.team-comment-settlement-option small {\n  color: #475569;\n  line-height: 1.35;\n}\n\n.team-comment-conversion-prompt {\n  margin-top: 12px;\n  padding: 16px;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  background: #f8fbff;\n  color: #1e3a8a;\n  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.08);\n}\n\n.team-comment-conversion-prompt__copy {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n}\n\n.team-comment-conversion-prompt__copy > div {\n  min-width: 0;\n}\n\n.team-comment-conversion-prompt__copy strong {\n  display: block;\n  color: #1e3a8a;\n  font-size: 15px;\n}\n\n.team-comment-conversion-prompt__icon {\n  display: grid;\n  flex: 0 0 24px;\n  width: 24px;\n  height: 24px;\n  place-items: center;\n  border-radius: 50%;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.team-comment-conversion-prompt p {\n  margin: 4px 0 0;\n  color: #475569;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.team-comment-conversion-prompt__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.team-comment-conversion-prompt__actions button {\n  width: auto;\n  min-width: 0;\n  margin-top: 0;\n  padding: 8px 13px;\n  line-height: 1.25;\n  white-space: nowrap;\n}\n\n.team-comment-conversion-prompt__cancel {\n  margin-right: auto !important;\n  border-color: transparent !important;\n  background: transparent !important;\n}\n\n.team-comment-conversion-prompt__single {\n  border-color: #93c5fd !important;\n  background: #fff !important;\n  color: #1d4ed8 !important;\n}\n\n.team-comment-conversion-prompt__all {\n  background: #2563eb !important;\n  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.25) !important;\n}\n\n.team-comment-deletion-prompt {\n  border-color: #fecaca;\n  background: #fffafa;\n  box-shadow: 0 4px 14px rgba(185, 28, 28, 0.08);\n}\n\n.team-comment-deletion-prompt .team-comment-conversion-prompt__copy strong {\n  color: #991b1b;\n}\n\n.team-comment-deletion-prompt .team-comment-conversion-prompt__icon {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.team-comment-deletion-prompt__all {\n  background: #dc2626 !important;\n  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.25) !important;\n}\n\n@media (max-width: 560px) {\n  .team-comment-team-picker > div {\n    grid-template-columns: 1fr;\n  }\n\n  .team-comment-conversion-prompt__actions {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n\n  .team-comment-conversion-prompt__actions button {\n    width: 100%;\n  }\n\n  .team-comment-conversion-prompt__cancel {\n    margin-right: 0 !important;\n  }\n}\n\n.installation-card.installation-search-highlight,\n.unscheduled-row.installation-search-highlight {\n  animation: installation-search-pulse 1s ease-in-out 3;\n  outline: 3px solid #2563eb;\n  outline-offset: 2px;\n  background: #dbeafe !important;\n}\n\n@keyframes installation-search-pulse {\n  0%, 100% { box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25); }\n  50% { box-shadow: 0 0 0 8px rgba(37, 99, 235, 0.08); }\n}\n.card-order {\n  font-weight: 700; display: block;\n  overflow: hidden; text-overflow: ellipsis;\n  color: #1e293b; font-size: 11px;\n}\n.card-contractor {\n  font-size: 10px; color: #475569;\n  display: block; overflow: hidden; text-overflow: ellipsis;\n}\n.card-address {\n  font-size: 10px; color: #64748b;\n  display: block; overflow: hidden; text-overflow: ellipsis;\n}\n.card-wh {\n  font-size: 10px; color: #334155; font-weight: 600;\n  display: block; overflow: hidden; text-overflow: ellipsis;\n}\n.card-date { font-size: 10px; color: #94a3b8; display: block; }\n\n/* ─── Installation card – full (unscheduled panel) ─────────── */\n.installation-card--full {\n  padding: 10px 14px 10px 13px;\n  border-left-width: 5px;\n  border-width: 1.5px;\n  border-left-width: 5px;\n  font-size: 13px;\n  white-space: normal;\n  min-width: 180px;\n  max-width: 220px;\n  flex-shrink: 0;\n  gap: 4px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n.installation-card--full .card-order { font-size: 13px; }\n.installation-card--full .card-contractor { font-size: 12px; }\n.installation-card--full .card-address { font-size: 11px; }\n.installation-card--full .card-date { font-size: 11px; }\n\n/* ─── High perimeter warning (suma obwodów > 80) ───────────── */\n.installation-card.high-perimeter {\n  border-top: 2px solid #f59e0b;\n  background: #fffbeb;\n}\n.card-perimeter-warning {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  color: #b45309;\n  background: #fef3c7;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-top: 2px;\n  border: 1px solid #fbbf24;\n}\n\n/* ─── Equipment badges on cards ────────────────────────────── */\n.card-equipment {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  margin-top: 3px;\n  font-size: 9px;\n}\n.card-equipment-badge {\n  display: inline-block;\n  background: #e0e7ff;\n  color: #3730a3;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-weight: 600;\n  border: 1px solid #c7d2fe;\n  white-space: nowrap;\n}\n\n/* ─── Note indicator on cards ─────────────────────────────── */\n.card-note-indicator {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 5;\n  pointer-events: none;\n}\n\n.note-icon {\n  font-size: 18px;\n  display: inline-block;\n  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));\n}\n\n/* ─── Unscheduled orders panel ──────────────────────────────── */\n.unscheduled-panel {\n  margin-top: 24px;\n  background: #fff;\n  border: 1.5px solid #fde68a;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.06);\n  overflow: visible;\n}\n.unscheduled-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 20px;\n  background: #fefce8;\n  border-bottom: 1.5px solid #fde68a;\n  border-radius: 10px 10px 0 0;\n}\n.unscheduled-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #78350f;\n}\n.unscheduled-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f59e0b;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  min-width: 22px; height: 22px;\n  border-radius: 11px;\n  padding: 0 6px;\n  flex-shrink: 0;\n}\n.unscheduled-hint {\n  font-size: 12px;\n  color: #92400e;\n  font-style: italic;\n  margin-left: auto;\n}\n\n.selected-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #3b82f6;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  min-width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  padding: 0 8px;\n  margin-left: 8px;\n}\n\n.btn-clear-selection {\n  padding: 6px 12px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #475569;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn-clear-selection:hover {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n}\n\n.unscheduled-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 14px;\n  border-top: 1px solid #fde68a;\n  border-bottom: 1px solid #fde68a;\n  background: #fff7ed;\n}\n\n.unscheduled-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n}\n\n.unscheduled-filter-chip input {\n  margin: 0;\n}\n\n.unscheduled-filter-chip.active {\n  border-color: #2563eb;\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.unscheduled-state-filter {\n  position: relative;\n}\n\n.unscheduled-state-filter-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 9px;\n  height: 32px;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.unscheduled-state-filter-trigger.active {\n  border-color: #2563eb;\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.unscheduled-state-filter-menu {\n  position: absolute;\n  z-index: 60;\n  top: calc(100% + 5px);\n  left: 0;\n  width: 230px;\n  padding: 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);\n}\n\n.unscheduled-state-filter-actions {\n  display: flex;\n  gap: 6px;\n  padding-bottom: 7px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.unscheduled-state-filter-actions button {\n  flex: 1;\n  padding: 5px 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 5px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.unscheduled-state-filter-actions button:hover {\n  border-color: #94a3b8;\n  background: #f1f5f9;\n}\n\n.unscheduled-state-filter-options {\n  display: flex;\n  flex-direction: column;\n  max-height: 260px;\n  overflow-y: auto;\n  padding-top: 6px;\n}\n\n.unscheduled-state-filter-options label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 5px;\n  border-radius: 5px;\n  color: #334155;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.unscheduled-state-filter-options label:hover {\n  background: #eff6ff;\n}\n\n.unscheduled-state-filter-options input {\n  margin: 0;\n}\n\n.unscheduled-filter-search {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.unscheduled-filter-search input {\n  width: 190px;\n  border: 0;\n  outline: none;\n  font: inherit;\n  color: #0f172a;\n}\n\n.unscheduled-filter-search .order-number-suggestions {\n  top: calc(100% + 5px);\n  width: min(430px, 85vw);\n}\n\n.unscheduled-filter-clear {\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.unscheduled-filter-clear:hover {\n  background: #f8fafc;\n  border-color: #94a3b8;\n}\n\n.order-checkbox {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n\n.selected-row {\n  background: #dbeafe !important;\n}\n\n.selected-row:hover {\n  background: #bfdbfe !important;\n}\n\n.unscheduled-table-wrapper {\n  overflow-x: auto;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.unscheduled-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.unscheduled-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: #fefce8;\n}\n\n.unscheduled-table th {\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 700;\n  color: #78350f;\n  border-bottom: 2px solid #fde68a;\n  white-space: nowrap;\n}\n\n.unscheduled-table tbody tr {\n  border-bottom: 1px solid #fef3c7;\n  transition: background 0.15s;\n}\n\n.unscheduled-row {\n  cursor: grab;\n}\n\n.unscheduled-row:hover {\n  background: #fef9e7;\n}\n\n.unscheduled-row:active {\n  cursor: grabbing;\n}\n\n.installation-context-menu {\n  position: fixed;\n  z-index: 10000;\n  width: 260px;\n  padding: 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);\n}\n\n.installation-context-menu-title {\n  padding: 6px 8px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.installation-context-menu .btn-secondary {\n  width: 100%;\n}\n\n.installation-context-menu .btn-secondary + .btn-secondary {\n  margin-top: 6px;\n}\n\n.assignment-context-menu {\n  position: fixed;\n  z-index: 10000;\n  width: 165px;\n  padding: 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);\n}\n\n.assignment-context-menu-title {\n  padding: 4px 6px 7px;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.35;\n  text-align: center;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.assignment-context-menu-actions,\n.assignment-status-submenu {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.assignment-context-menu .assignment-context-menu-button {\n  width: 100%;\n  height: 40px;\n  min-height: 40px;\n  margin: 0;\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.2;\n  font-size: 12px;\n  box-sizing: border-box;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.assignment-status-menu-trigger {\n  position: relative;\n}\n\n.assignment-status-menu-button {\n  position: relative;\n}\n\n.assignment-status-menu-button > span:first-child {\n  flex: 1;\n  text-align: center;\n  padding: 0 14px;\n}\n\n.assignment-status-menu-button > span:last-child {\n  position: absolute;\n  right: 10px;\n}\n\n.assignment-status-submenu {\n  position: absolute;\n  top: 0;\n  z-index: 10001;\n  width: 165px;\n  padding: 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);\n}\n\n.schedule-order-modal {\n  max-width: 460px;\n}\n\n.schedule-order-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.schedule-order-fields label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.schedule-order-fields input,\n.schedule-order-fields select {\n  width: 100%;\n  padding: 9px 10px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #0f172a;\n  font: inherit;\n}\n\n.schedule-order-fields input:focus,\n.schedule-order-fields select:focus {\n  border-color: #2563eb;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.schedule-order-hint {\n  padding: 9px 10px;\n  border-radius: 7px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n}\n\n.unscheduled-table td {\n  padding: 10px 12px;\n  color: #1e293b;\n  vertical-align: middle;\n}\n\n.drag-handle {\n  text-align: center;\n  cursor: grab;\n  color: #94a3b8;\n  user-select: none;\n}\n\n.drag-icon {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.note-cell {\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 4px;\n  min-height: 20px;\n  transition: background 0.15s;\n}\n\n.note-cell:hover {\n  background: #f1f5f9;\n}\n\n.note-empty {\n  color: #94a3b8;\n  font-style: italic;\n  font-size: 12px;\n}\n\n.note-input {\n  flex: 1;\n  padding: 6px 8px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.note-input:focus {\n  outline: none;\n  border-color: #2563eb;\n}\n\n.btn-save-note,\n.btn-cancel-note {\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn-save-note {\n  background: #dcfce7;\n  color: #16a34a;\n  border: 1px solid #86efac;\n}\n\n.btn-save-note:hover {\n  background: #bbf7d0;\n}\n\n.btn-save-note:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-cancel-note {\n  background: #fee2e2;\n  color: #dc2626;\n  border: 1px solid #fca5a5;\n}\n\n.btn-cancel-note:hover {\n  background: #fecaca;\n}\n\n.btn-cancel-note:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.unscheduled-cards {\n  display: flex;\n  gap: 10px;\n  padding: 16px 20px;\n  overflow-x: auto;\n  align-items: flex-start;\n  min-height: 90px;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n.unscheduled-cards::-webkit-scrollbar { height: 5px; }\n.unscheduled-cards::-webkit-scrollbar-track { background: transparent; }\n.unscheduled-cards::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }\n\n/* ─── List tab ─────────────────────────────────────────────── */\n.list-tab {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.list-tab > .table-wrapper {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.list-tab > .table-wrapper > .data-table {\n  table-layout: fixed;\n  min-width: 980px;\n}\n\n.list-tab > .table-wrapper > .data-table th {\n  padding: 8px 6px;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  line-height: 1.25;\n}\n\n.list-tab > .table-wrapper > .data-table .inst-row > td {\n  padding: 7px 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.list-tab > .table-wrapper > .data-table .inst-row > .order-cell {\n  overflow: visible;\n  text-overflow: clip;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.list-tab > .table-wrapper > .data-table .inst-row--expanded > td {\n  overflow: visible;\n  text-overflow: clip;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  vertical-align: top;\n}\n\n.list-tab > .table-wrapper > .data-table .inst-row--expanded > .address-cell {\n  max-width: none;\n}\n\n.list-tab > .table-wrapper > .data-table .inst-items-row .items-subtable th,\n.list-tab > .table-wrapper > .data-table .inst-items-row .items-subtable td {\n  overflow: visible;\n  text-overflow: clip;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.list-tab > .table-wrapper > .data-table .inst-row > .expand-cell,\n.list-tab > .table-wrapper > .data-table .inst-row > .actions-cell {\n  overflow: visible;\n}\n\n.list-tab > .table-wrapper > .data-table .positions-count-cell {\n  text-align: center;\n}\n\n.list-tab > .table-wrapper > .data-table .departure-date-cell {\n  text-align: center;\n}\n\n.list-tab .list-row-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.list-tab > .table-wrapper > .data-table .list-row-actions button,\n.list-tab > .table-wrapper > .data-table .items-subtable .item-action-btn {\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.list-tab > .table-wrapper > .data-table .list-row-actions button {\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.list-tab .inst-row input {\n  width: 100% !important;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.list-tab .list-actions,\n.list-tab .list-filters {\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.list-tab .status-filter-container {\n  min-width: 0;\n}\n\n.list-toolbar {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n.list-filters { display: flex; gap: 8px; flex: 1; }\n.installation-list-search {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n.list-calendar-schedule-menu {\n  position: fixed;\n  z-index: 70;\n  width: min(360px, 90vw);\n  padding: 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.22);\n}\n.list-calendar-schedule-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.list-calendar-schedule-header > div {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.list-calendar-schedule-header span {\n  color: #64748b;\n  font-size: 12px;\n}\n.list-calendar-schedule-header > button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 17px;\n  cursor: pointer;\n}\n.list-calendar-schedule-menu label {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: 10px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n}\n.list-calendar-schedule-menu input,\n.list-calendar-schedule-menu select {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #1e293b;\n}\n.list-calendar-schedule-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 14px;\n}\n.list-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.status-filter-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1.5px solid #cbd5e1;\n}\n.status-filter-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  white-space: nowrap;\n}\n.status-filter-checkboxes {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.status-filter-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #334155;\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 5px;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n.status-filter-checkbox:hover {\n  background: #e2e8f0;\n}\n.status-filter-checkbox input[type=\"checkbox\"] {\n  cursor: pointer;\n  width: 15px;\n  height: 15px;\n}\n.list-actions .btn-primary,\n.list-actions .btn-secondary {\n  padding: 8px 18px;\n  font-size: 14px;\n  height: 38px;\n  margin-top: 0;\n  box-sizing: border-box;\n}\n.search-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #fff;\n  transition: border-color 0.15s;\n}\n.installation-list-search .search-input {\n  width: 100%;\n  box-sizing: border-box;\n}\n.search-input:focus { outline: none; border-color: #2563eb; }\n.list-filters select {\n  padding: 8px 12px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 14px;\n}\n.import-result {\n  padding: 10px 14px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n.import-result.success { background: #dcfce7; color: #166534; border: 1.5px solid #86efac; }\n.import-result.error { background: #fee2e2; color: #991b1b; border: 1.5px solid #fca5a5; }\n.import-summary-title { font-weight: 700; margin-bottom: 6px; }\n.import-summary-grid { display: flex; flex-wrap: wrap; gap: 6px 18px; }\n.import-type-summary { display: flex; flex-wrap: wrap; align-items: center; gap: 5px; margin-top: 8px; }\n.import-type-pill { padding: 2px 7px; border-radius: 999px; background: rgba(255, 255, 255, 0.65); }\n.import-warnings { margin-top: 4px; font-size: 12px; opacity: 0.8; }\n\n.planner-import-modal {\n  width: 760px;\n}\n\n.planner-import-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.planner-file-drop {\n  min-height: 160px;\n  padding: 18px;\n  border: 2px dashed #94a3b8;\n  border-radius: 8px;\n  background: #f8fafc;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.planner-file-drop:hover {\n  border-color: #2563eb;\n  background: #eff6ff;\n}\n\n.planner-file-drop.has-file {\n  border-color: #16a34a;\n  background: #f0fdf4;\n}\n\n.planner-file-drop input {\n  display: none;\n}\n\n.planner-file-title {\n  font-size: 13px;\n  font-weight: 800;\n  color: #1e293b;\n  letter-spacing: 0.04em;\n}\n\n.planner-file-name {\n  font-size: 13px;\n  color: #64748b;\n  overflow-wrap: anywhere;\n  line-height: 1.35;\n}\n\n.planner-file-drop.has-file .planner-file-name {\n  color: #166534;\n  font-weight: 600;\n}\n\n/* ─── Data table ───────────────────────────────────────────── */\n.table-wrapper {\n  overflow-x: auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.07);\n  border: 1.5px solid #e2e8f0;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  background: #fff;\n}\n.data-table th {\n  background: #f1f5f9;\n  padding: 11px 14px;\n  text-align: left;\n  font-weight: 700;\n  color: #374151;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.data-table td {\n  padding: 9px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #374151;\n}\n.data-table tbody tr:last-child td { border-bottom: none; }\n.data-table tbody tr:hover { background: #f8fafc; }\n.data-table tbody tr.editing { background: #eff6ff; }\n.inst-row { transition: background 0.1s; }\n.inst-row--expanded > td { background: #eff6ff; }\n.inst-row--context-target > td {\n  background: #dbeafe;\n}\n.expand-cell { text-align: center; width: 28px; padding: 0 4px !important; }\n.expand-icon { font-size: 12px; color: #64748b; user-select: none; }\n.inst-items-row > td { padding: 0 !important; border-bottom: 2px solid #bfdbfe !important; }\n.inst-items-cell { padding: 0 !important; max-width: 0; }\n\n/* Items subtable */\n.items-subtable {\n  width: 100%; border-collapse: collapse; table-layout: fixed;\n  background: #f0f7ff; font-size: 12px;\n}\n.items-subtable th {\n  padding: 6px 10px; background: #dbeafe; color: #1e40af;\n  font-weight: 700; border-bottom: 1px solid #bfdbfe; text-align: center;\n  white-space: nowrap;\n}\n.items-subtable th.sortable-header {\n  transition: background 0.15s;\n}\n.items-subtable th.sortable-header:hover {\n  background: #bfdbfe;\n}\n.items-subtable td {\n  padding: 5px 10px; border-bottom: 1px solid #e0ecff; color: #334155;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center;\n}\n.items-subtable .center-cell { text-align: center; }\n.items-subtable th:last-child,\n.items-subtable td:last-child { width: 52px; min-width: 52px; overflow: visible; padding: 3px 4px; }\n.items-subtable tbody tr:last-child td { border-bottom: none; }\n.items-subtable tbody tr:hover { background: #e0ecff; }\n.items-subtable-summary td { background: #dbeafe; border-top: 2px solid #93c5fd; }\n.item-action-btn { padding: 1px 5px; font-size: 10px; line-height: 1.4; border-radius: 3px; cursor: pointer; border: 1px solid transparent; }\n.item-action-btn.edit { background: #e2e8f0; border-color: #94a3b8; color: #334155; }\n.item-action-btn.edit:hover { background: #cbd5e1; }\n.item-action-btn.delete { background: #fee2e2; border-color: #fca5a5; color: #dc2626; margin-left: 2px; }\n.item-action-btn.delete:hover { background: #fecaca; }\n.item-action-btn.confirm { background: #dcfce7; border-color: #86efac; color: #16a34a; }\n.item-action-btn.confirm:hover { background: #bbf7d0; }\n.item-action-btn.cancel { background: #e2e8f0; border-color: #94a3b8; color: #334155; margin-left: 2px; }\n.item-action-btn.cancel:hover { background: #cbd5e1; }\n\n.items-subtable-add-row td { background: #f0fdf4; }\n.item-input { width: 100%; min-width: 40px; max-width: 100%; padding: 2px 4px; font-size: 12px; border: 1px solid #93c5fd; border-radius: 3px; box-sizing: border-box; }\n.item-input.numeric-input { text-align: right; }\n/* Hide number input spinners */\n.item-input::-webkit-inner-spin-button,\n.item-input::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }\n.item-input[type=number] { -moz-appearance: textfield; }\n.no-data-cell { text-align: center; color: #94a3b8; padding: 32px; font-style: italic; }\n.no-data-text { color: #94a3b8; font-style: italic; font-size: 13px; }\n.order-cell { font-weight: 700; font-family: monospace; font-size: 13px; }\n.address-cell { max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.numeric-cell { text-align: right; }\n.actions-cell { white-space: nowrap; }\n.actions-cell button { margin-left: 4px; }\n.state-badge {\n  display: inline-block;\n  padding: 2px 9px; background: #f1f5f9;\n  border-radius: 4px; font-size: 12px; font-weight: 700; color: #374151;\n}\n.status-pill {\n  display: inline-block;\n  padding: 3px 9px; border-radius: 5px;\n  border: 1.5px solid; font-size: 11px; font-weight: 600;\n}\n\n/* ─── Workers tab ──────────────────────────────────────────── */\n.workers-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }\n@media (max-width: 900px) { .workers-layout { grid-template-columns: 1fr; } }\n.workers-panel {\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 22px;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.05);\n}\n.workers-panel h3 { margin: 0 0 18px; font-size: 16px; color: #1e293b; }\n.add-form {\n  display: flex; gap: 8px; flex-wrap: wrap;\n  margin-bottom: 18px; padding: 12px;\n  background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 8px;\n}\n.add-form input {\n  flex: 1; min-width: 90px;\n  padding: 7px 10px; border: 1.5px solid #cbd5e1; border-radius: 6px; font-size: 13px;\n}\n.installer-list, .team-list { display: flex; flex-direction: column; gap: 8px; }\n.installer-item {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 10px 14px; border: 1.5px solid #e2e8f0; border-radius: 8px; background: #fff;\n  transition: box-shadow 0.1s;\n}\n.installer-item:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.08); }\n.installer-item.inactive { opacity: 0.55; }\n.installer-info { display: flex; flex-direction: column; gap: 2px; }\n.installer-name { font-weight: 600; font-size: 14px; color: #1e293b; }\n.installer-position { font-size: 12px; color: #64748b; }\n.inactive-tag { font-size: 10px; background: #fee2e2; color: #991b1b; padding: 1px 6px; border-radius: 4px; width: fit-content; }\n.team-tag { font-size: 11px; color: #2563eb; background: #eff6ff; padding: 2px 6px; border-radius: 4px; width: fit-content; }\n.installer-actions { display: flex; gap: 4px; }\n.edit-form-inline { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; width: 100%; }\n.edit-form-inline input { flex: 1; min-width: 80px; padding: 5px 8px; border: 1.5px solid #94a3b8; border-radius: 6px; font-size: 13px; }\n.team-card {\n  border: 1.5px solid #e2e8f0; border-radius: 10px;\n  padding: 14px; background: #fff; transition: box-shadow 0.1s;\n}\n.team-card:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.08); }\n.team-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; }\n.team-desc { font-size: 12px; color: #64748b; }\n.team-actions { display: flex; gap: 4px; }\n.team-members { display: flex; flex-direction: column; gap: 4px; margin-bottom: 8px; padding-left: 6px; }\n.member-item {\n  display: flex; justify-content: space-between; align-items: center;\n  font-size: 13px; color: #374151; padding: 4px 8px; border-radius: 6px; background: #f8fafc;\n}\n.add-member-row select {\n  width: 100%; padding: 7px 10px;\n  border: 1.5px dashed #94a3b8; border-radius: 6px;\n  font-size: 13px; color: #2563eb; background: #f8fafc; cursor: pointer;\n}\n\n/* ─── Modal ────────────────────────────────────────────────── */\n.modal-overlay {\n  position: fixed; inset: 0;\n  background: rgba(15,23,42,0.55);\n  z-index: 1000;\n  display: flex; align-items: center; justify-content: center;\n  backdrop-filter: blur(2px);\n}\n.modal-box {\n  background: #fff; border-radius: 14px;\n  width: 620px; max-width: 95vw; max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 24px 64px rgba(0,0,0,0.28);\n}\n\n.calendar-note-details-modal .modal-header h3 {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.installation-details-actions.calendar-note-details-actions {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.calendar-note-details-grid .calendar-note-days-picker {\n  grid-column: 1 / -1;\n}\n\n.calendar-note-details-grid .calendar-note-details-wide {\n  grid-column: 1 / -1;\n}\n\n.calendar-note-assignment-or {\n  margin: 0 8px;\n  color: #64748b;\n}\n\n.calendar-note-settlement-mode {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 12px 0;\n  font-size: 13px;\n}\n\n.calendar-note-settlement-mode > span {\n  font-weight: 600;\n}\n\n.calendar-note-settlement-mode label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.calendar-note-settlement-day {\n  margin-bottom: 16px;\n}\n\n.calendar-note-settlement-day:last-child {\n  margin-bottom: 0;\n}\n\n.calendar-note-settlement-day-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 6px;\n  color: #334155;\n  font-size: 13px;\n}\n\n.calendar-note-settlement-day-heading > span {\n  color: #64748b;\n  font-size: 12px;\n}\n\n@media (max-width: 600px) {\n  .calendar-note-details-modal .settlement-workers {\n    overflow-x: auto;\n  }\n\n  .installation-details-actions.calendar-note-details-actions {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.quick-add-popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 100;\n  width: min(420px, calc(100vw - 32px));\n  max-width: none;\n  max-height: calc(100vh - 100px);\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.22);\n}\n\n/* Non-blocking order details shown next to the planning calendar. */\n.planning-tab {\n  --installation-details-drawer-width: min(620px, 46vw);\n}\n\n.planning-tab--details-open {\n  box-sizing: border-box;\n  padding-right: calc(var(--installation-details-drawer-width) + 16px);\n  transition: padding-right 0.2s ease;\n}\n\n.installation-details-drawer {\n  position: fixed;\n  top: 60px;\n  right: 0;\n  bottom: 0;\n  z-index: 900;\n  width: var(--installation-details-drawer-width);\n  max-width: none;\n  max-height: none;\n  border-radius: 14px 0 0 0;\n  border-left: 1px solid #cbd5e1;\n  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.2);\n  overflow-x: hidden;\n  overflow-y: scroll;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  scrollbar-width: auto;\n  scrollbar-color: #64748b #f1f5f9;\n}\n\n.installation-details-drawer::-webkit-scrollbar {\n  width: 12px;\n}\n\n.installation-details-drawer::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n.installation-details-drawer::-webkit-scrollbar-thumb {\n  min-height: 40px;\n  border: 3px solid #f1f5f9;\n  border-radius: 999px;\n  background: #64748b;\n}\n\n.installation-details-drawer::-webkit-scrollbar-thumb:hover {\n  background: #475569;\n}\n\n.installation-details-drawer > .modal-header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #fff;\n}\n\n.installation-details-drawer > .modal-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  background: #fff;\n}\n\n.installation-details-actions {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 6px;\n  padding: 12px 16px;\n}\n\n.installation-details-actions > button {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 32px;\n  min-width: 0;\n  margin: 0;\n  padding: 4px 6px;\n  border-width: 1.5px;\n  border-style: solid;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.15;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.installation-details-actions > .btn-primary,\n.installation-details-actions > .btn-warning {\n  border-color: transparent;\n}\n\n@media (max-width: 900px) {\n  .planning-tab--details-open {\n    padding-right: 0;\n  }\n\n  .installation-details-drawer {\n    width: min(620px, calc(100vw - 24px));\n  }\n}\n\n@media (max-width: 600px) {\n  .installation-details-actions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n.modal-header {\n  padding: 22px 26px 18px; border-bottom: 1.5px solid #e2e8f0;\n  display: flex; justify-content: space-between; align-items: center;\n}\n.modal-header h3 { margin: 0; font-size: 19px; color: #1e293b; font-weight: 700; }\n.modal-close { background: none; border: none; font-size: 20px; cursor: pointer; color: #94a3b8; line-height: 1; }\n.modal-close:hover { color: #1e293b; }\n\n.quick-add-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px;\n  margin: 16px 26px 0;\n  padding: 4px;\n  border-radius: 9px;\n  background: #f1f5f9;\n}\n\n.quick-add-tabs button {\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.quick-add-tabs button.active {\n  background: #fff;\n  color: #1d4ed8;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);\n}\n\n.quick-add-tabs button:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n.modal-error {\n  margin: 12px 26px 0;\n  padding: 10px 14px; background: #fee2e2; color: #991b1b;\n  border-radius: 8px; font-size: 13px; border: 1px solid #fca5a5;\n}\n.modal-warning-banner {\n  margin: 12px 26px 0;\n  padding: 12px 16px;\n  background: #fef3c7;\n  border: 1.5px solid #f59e0b;\n  border-radius: 8px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.modal-warning-banner .warning-icon {\n  font-size: 20px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.modal-warning-banner .warning-content {\n  flex: 1;\n}\n.modal-warning-banner .warning-content strong {\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  color: #92400e;\n  margin-bottom: 4px;\n}\n.modal-warning-banner .warning-content p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #78350f;\n}\n.modal-body { padding: 22px 26px; }\n.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n.form-grid label {\n  display: flex; flex-direction: column; gap: 5px;\n  font-size: 11px; color: #64748b; font-weight: 700;\n  letter-spacing: 0.05em; text-transform: uppercase;\n}\n.form-grid input, .form-grid select {\n  padding: 9px 11px; border: 1.5px solid #cbd5e1; border-radius: 7px;\n  font-size: 14px; background: #fff; color: #1e293b; transition: border-color 0.15s;\n}\n.form-grid input:focus, .form-grid select:focus { outline: none; border-color: #2563eb; }\n.modal-body textarea {\n  width: 100%; box-sizing: border-box;\n  padding: 9px 11px; border: 1.5px solid #cbd5e1; border-radius: 7px;\n  font-size: 14px; font-family: inherit; resize: vertical; color: #1e293b;\n}\n\n.installation-general-section {\n  border: 1px solid #dbe3ee;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.installation-general-toggle {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 34px;\n  gap: 8px;\n  padding: 7px 10px;\n  border: 0;\n  background: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.installation-general-toggle:hover {\n  background: #f1f5f9;\n}\n\n.installation-general-summary {\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 400;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.installation-general-chevron {\n  margin-left: auto;\n  color: #64748b;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.installation-general-content {\n  padding: 10px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.form-grid.installation-general-grid {\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 0;\n}\n\n.installation-general-grid .general-field--order { grid-column: span 4; }\n.installation-general-grid .general-field--contractor { grid-column: span 8; }\n.installation-general-grid .general-field--address { grid-column: 1 / -1; }\n.installation-general-grid .general-field--status { grid-column: span 6; }\n.installation-general-grid .general-field--state { grid-column: span 6; }\n.installation-general-grid .general-field--scope { grid-column: span 8; }\n.installation-general-grid .general-field--perimeter-sum { grid-column: span 4; }\n.installation-general-grid .general-field--date { grid-column: span 6; }\n\n.installation-general-grid .installation-days-picker--expanded {\n  box-sizing: border-box;\n  width: 100%;\n  margin: 4px 0 0;\n  padding: 14px;\n  border: 1px solid #dbe3ee;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.installation-days-picker--expanded legend {\n  padding: 0 5px;\n  color: #1e293b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.installation-days-picker-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.installation-days-picker .installation-days-picker-heading p {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.installation-days-count {\n  flex: none;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.installation-days-list {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.installation-days-list-label {\n  display: block;\n  margin-bottom: 8px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.installation-general-grid .installation-days-picker--expanded .installation-days-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  width: 100%;\n  gap: 8px;\n}\n\n.installation-general-grid .installation-days-picker--expanded .installation-days-options label {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 36px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.installation-days-calendar-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 16px;\n  margin-top: 14px;\n}\n\n.installation-days-calendar-toggle,\n.installation-days-clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 7px 11px;\n  border-radius: 7px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.installation-days-calendar-toggle {\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.installation-days-calendar-toggle:hover {\n  background: #dbeafe;\n}\n\n.installation-days-clear {\n  border: 1px solid transparent;\n  background: transparent;\n  color: #64748b;\n}\n\n.installation-days-clear:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.installation-days-calendar-panel {\n  margin-top: 14px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  background: #f8fafc;\n}\n\n.installation-days-calendar-modes {\n  display: inline-flex;\n  gap: 3px;\n  padding: 3px;\n  border-radius: 8px;\n  background: #e2e8f0;\n}\n\n.installation-days-calendar-modes button {\n  min-height: 30px;\n  padding: 5px 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #475569;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.installation-days-calendar-modes button[aria-pressed=\"true\"] {\n  background: #fff;\n  color: #1d4ed8;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n}\n\n.installation-days-picker .installation-days-calendar-hint {\n  margin: 10px 0 0;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.installation-days-calendar {\n  max-width: 360px;\n  margin: 12px 0 0;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.installation-days-calendar .split-calendar-header {\n  margin-bottom: 8px;\n  padding: 0;\n}\n\n.installation-days-calendar .vac-cal-day {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  min-height: 32px;\n}\n\n.installation-days-calendar .vac-cal-day:hover {\n  background: #e0e7ff;\n}\n\n.installation-days-calendar .vac-cal-day:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.installation-days-calendar-toggle:focus-visible,\n.installation-days-clear:focus-visible,\n.installation-days-calendar-modes button:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n@media (max-width: 480px) {\n  .installation-days-picker-heading {\n    flex-wrap: wrap;\n  }\n\n  .installation-days-calendar-actions {\n    justify-content: space-between;\n  }\n\n  .installation-days-calendar-toggle,\n  .installation-days-clear {\n    font-size: 11px;\n  }\n\n  .installation-days-calendar-panel {\n    padding: 8px;\n  }\n}\n\n.installation-general-grid input,\n.installation-general-grid select {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 6px 8px;\n  font-size: 12px;\n}\n\n.installation-general-grid input[readonly] {\n  background: #f8fafc;\n  color: #334155;\n  cursor: default;\n}\n\n.installation-general-notes {\n  display: block;\n  margin-top: 8px;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.installation-general-notes textarea {\n  display: block;\n  min-height: 58px;\n  margin-top: 5px;\n  padding: 7px 8px;\n  font-size: 12px;\n}\n\n@media (max-width: 600px) {\n  .installation-general-grid .general-field--date {\n    grid-column: span 6;\n  }\n\n  .installation-general-grid .general-field--order { grid-column: span 5; }\n  .installation-general-grid .general-field--contractor { grid-column: span 7; }\n  .installation-general-grid .general-field--status,\n  .installation-general-grid .general-field--state { grid-column: span 6; }\n  .installation-general-grid .general-field--scope { grid-column: span 8; }\n  .installation-general-grid .general-field--perimeter-sum { grid-column: span 4; }\n}\n.modal-footer {\n  padding: 18px 26px; border-top: 1.5px solid #e2e8f0;\n  display: flex; justify-content: flex-end; gap: 10px;\n}\n.assignments-section { margin-top: 22px; padding-top: 18px; border-top: 1.5px solid #e2e8f0; }\n.assignments-section h4 { margin: 0 0 12px; font-size: 14px; color: #374151; font-weight: 700; }\n.day-assignment-block { margin-bottom: 16px; padding: 10px; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0; }\n.day-assignment-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }\n.day-assignment-label { font-weight: 600; font-size: 13px; color: #1e293b; display: flex; align-items: center; gap: 6px; }\n.day-assignment-empty { font-size: 12px; color: #94a3b8; font-style: italic; }\n.kat-b-warning-badge { color: #f59e0b; font-size: 15px; }\n.assignment-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 4px; }\n.assignment-list li {\n  display: flex; justify-content: space-between; align-items: center;\n  padding: 7px 12px; background: #ffffff; border-radius: 6px; font-size: 13px;\n}\n/* Expanded team assignment */\n.team-assignment-expanded {\n  display: flex; flex-direction: column; gap: 0;\n  background: #ffffff; border-radius: 6px; overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n.team-assignment-row {\n  display: flex; justify-content: space-between; align-items: center;\n  padding: 7px 12px; font-size: 13px; background: #f1f5f9;\n}\n.team-members-list {\n  list-style: none; padding: 0; margin: 0;\n  display: flex; flex-direction: column;\n}\n.team-member-item {\n  display: flex; align-items: center; gap: 6px;\n  padding: 5px 12px 5px 20px; font-size: 12px; color: #374151;\n  border-top: 1px solid #f1f5f9;\n}\n.team-member-item:last-child { border-bottom: none; }\n.member-name { flex: 1; }\n.member-katb-badge {\n  background: #2563eb; color: #fff; font-size: 10px; font-weight: 700;\n  padding: 1px 5px; border-radius: 4px;\n}\n/* Inline add-person row in day block */\n.day-add-member-inline {\n  display: flex; align-items: center; gap: 6px;\n  padding: 6px 10px; border-top: 1px solid #e2e8f0; flex-wrap: wrap;\n}\n.day-add-member-inline .assign-select { flex: 1; min-width: 150px; }\n.btn-add-member {\n  display: block; width: 100%; text-align: left;\n  background: none; border: 1px dashed #94a3b8; color: #64748b;\n  font-size: 12px; padding: 5px 10px; border-radius: 6px;\n  cursor: pointer; margin-top: 6px; transition: border-color 0.15s, color 0.15s;\n}\n.btn-add-member:hover { border-color: #2563eb; color: #2563eb; }\n.assign-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }\n.assign-row select { flex: 1; padding: 7px 10px; border: 1.5px solid #cbd5e1; border-radius: 7px; font-size: 13px; }\n\n/* Compact assignment cards in the installation details drawer. */\n.assignments-section--compact {\n  margin-top: 16px;\n  padding-top: 14px;\n}\n\n.assignments-section--compact > h4 {\n  margin-bottom: 8px;\n}\n\n.section-collapse-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 30px;\n  margin: 0 0 7px;\n  padding: 4px 7px;\n  border: 0;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #374151;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.section-collapse-toggle:hover {\n  background: #e2e8f0;\n}\n\n.section-collapse-toggle > span:last-child {\n  color: #64748b;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.assignments-section--compact .day-assignment-block {\n  margin-bottom: 8px;\n  padding: 5px 6px;\n  border-radius: 7px;\n}\n\n.assignments-section--compact .day-assignment-header {\n  min-height: 24px;\n  margin-bottom: 4px;\n}\n\n.assignments-section--compact .day-assignment-label {\n  font-size: 12px;\n}\n\n.assignments-section--compact .team-assignment-row {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 24px;\n  padding: 2px 5px;\n}\n\n.assignments-section--compact .assignment-list,\n.assignments-section--compact .team-assignment-expanded {\n  width: 100%;\n}\n\n.assignments-section--compact .team-assignment-expanded {\n  align-items: stretch;\n}\n\n.team-assignment-name {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  gap: 7px;\n  color: #1e293b;\n  font-size: 12px;\n}\n\n.team-assignment-count {\n  flex-shrink: 0;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  color: #64748b;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.assignments-section--compact .team-members-list {\n  box-sizing: border-box;\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 3px;\n  padding: 4px 5px 5px;\n}\n\n.assignments-section--compact .team-member-item {\n  box-sizing: border-box;\n  min-width: 0;\n  min-height: 22px;\n  padding: 2px 3px 2px 5px;\n  border: 0;\n  border-radius: 5px;\n  background: #f8fafc;\n}\n\n.assignments-section--compact .member-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n}\n\n.assignments-section--compact .member-katb-badge {\n  padding: 1px 4px;\n  font-size: 8px;\n}\n\n.assignments-section--compact .btn-icon-remove {\n  flex: 0 0 18px;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  line-height: 18px;\n}\n\n.assignments-section--compact .btn-add-member {\n  width: auto;\n  margin: 3px 0 0 auto;\n  padding: 2px 7px;\n  font-size: 10px;\n}\n\n.assignments-section--compact .day-add-member-inline {\n  margin-top: 4px;\n  padding: 5px 0 0;\n}\n\n.individual-assignment-row > span:first-child {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.individual-assignment-actions {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 8px;\n}\n\n.individual-assignment-actions select {\n  max-width: 150px;\n  padding: 3px 5px;\n  border: 1px solid #cbd5e1;\n  border-radius: 5px;\n  background: #fff;\n  color: #475569;\n  font-size: 10px;\n}\n\n.settlement-parameters {\n  margin-top: 16px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.settlement-parameters h4 {\n  margin: 0 0 10px;\n  color: #475569;\n  font-size: 14px;\n}\n\n.settlement-parameters-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.settlement-parameters-grid label {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 7px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.settlement-parameters-grid input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 34px;\n  padding: 6px 9px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.settlement-parameters-grid input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n.settlement-parameters-formula {\n  margin: 9px 0 0;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.settlement-section .section-collapse-toggle--settlement {\n  margin-bottom: 16px;\n  background: rgba(255, 255, 255, 0.75);\n  color: #166534;\n  font-size: 14px;\n}\n\n.settlement-section--collapsed {\n  padding: 12px 16px;\n}\n\n.settlement-section--collapsed .section-collapse-toggle--settlement {\n  margin-bottom: 0;\n}\n\n/* ─── Shared buttons ───────────────────────────────────────── */\n.btn-primary {\n  background: #2563eb; color: #fff; border: none;\n  padding: 9px 18px; border-radius: 7px; cursor: pointer;\n  font-size: 14px; font-weight: 600;\n  transition: background 0.15s, box-shadow 0.15s;\n  box-shadow: 0 1px 4px rgba(37,99,235,0.3);\n}\n.btn-primary:hover { background: #1d4ed8; box-shadow: 0 2px 8px rgba(37,99,235,0.4); }\n.btn-primary:disabled { background: #93c5fd; cursor: not-allowed; box-shadow: none; }\n.btn-secondary {\n  background: #f8fafc; color: #374151;\n  border: 1.5px solid #cbd5e1; padding: 9px 18px;\n  border-radius: 7px; cursor: pointer; font-size: 14px; transition: background 0.15s;\n}\n.btn-secondary:hover { background: #e2e8f0; }\n.btn-success { background: #16a34a; color: #fff; border: none; padding: 9px 18px; border-radius: 7px; cursor: pointer; font-size: 14px; }\n.btn-success:hover { background: #15803d; }\n.btn-danger { background: #ef4444; color: #fff; border: none; padding: 9px 18px; border-radius: 7px; cursor: pointer; font-size: 14px; }\n.btn-danger:hover { background: #dc2626; }\n.btn-warning { background: #f59e0b; color: #fff; border: none; padding: 9px 18px; border-radius: 7px; cursor: pointer; font-size: 14px; font-weight: 600; transition: background 0.15s; }\n.btn-warning:hover { background: #d97706; }\n.btn-warning:disabled { background: #fcd34d; cursor: not-allowed; }\n.btn-sm { padding: 5px 11px !important; font-size: 12px !important; }\n.btn-icon-remove { background: none; border: none; color: #ef4444; cursor: pointer; font-size: 13px; padding: 2px 6px; border-radius: 4px; }\n.btn-icon-remove:hover { background: #fee2e2; }\n\n/* ─── Misc ─────────────────────────────────────────────────── */\n.error-banner {\n  background: #fee2e2; color: #991b1b;\n  padding: 10px 14px; border-radius: 8px; margin-bottom: 12px;\n  font-size: 13px; cursor: pointer; border: 1.5px solid #fca5a5;\n}\n.loading-text { color: #94a3b8; padding: 36px; text-align: center; font-style: italic; font-size: 14px; }\n\n/* ═══════════════════════════════════════════════════════════════\n   Workers & Teams Tab  (complete redesign)\n═══════════════════════════════════════════════════════════════ */\n\n/* Root container */\n.wt-root { padding: 20px 0; }\n\n/* Sub-navigation */\n.wt-nav {\n  display: flex; gap: 4px; margin-bottom: 24px;\n  border-bottom: 2px solid #e2e8f0; padding-bottom: 0;\n}\n.wt-nav-btn {\n  background: none; border: none; padding: 10px 20px 12px;\n  font-size: 14px; font-weight: 500; color: #64748b;\n  cursor: pointer; border-radius: 8px 8px 0 0; position: relative;\n  display: flex; align-items: center; gap: 8px;\n  transition: color .15s, background .15s;\n}\n.wt-nav-btn:hover { background: #f8fafc; color: #1e293b; }\n.wt-nav-btn.active {\n  color: #3b82f6; background: #eff6ff;\n  border-bottom: 2px solid #3b82f6; margin-bottom: -2px;\n}\n.wt-nav-count {\n  background: #e2e8f0; color: #475569;\n  font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 20px;\n}\n.wt-nav-btn.active .wt-nav-count { background: #bfdbfe; color: #1d4ed8; }\n\n/* Section wrapper */\n.wt-section { background: #fff; border-radius: 12px; border: 1px solid #e2e8f0; padding: 20px; }\n\n/* Section header */\n.wt-section-header {\n  display: flex; align-items: center; gap: 10px; margin-bottom: 16px; flex-wrap: wrap;\n}\n.wt-section-title { font-size: 16px; font-weight: 700; color: #1e293b; margin: 0; }\n.wt-badge {\n  background: #e2e8f0; color: #475569;\n  font-size: 12px; font-weight: 600; padding: 2px 8px; border-radius: 20px;\n}\n.wt-toolbar { display: flex; gap: 8px; align-items: center; margin-left: auto; flex-wrap: wrap; }\n.wt-search {\n  padding: 7px 12px; border: 1px solid #cbd5e1; border-radius: 8px;\n  font-size: 13px; width: 200px;\n}\n.wt-search:focus { outline: none; border-color: #3b82f6; }\n.wt-filter {\n  padding: 7px 10px; border: 1px solid #cbd5e1; border-radius: 8px;\n  font-size: 13px; background: #fff; cursor: pointer;\n}\n\n/* Tables (positions + employees) */\n.wt-table {\n  width: 100%; border-collapse: collapse; font-size: 13.5px;\n}\n.wt-table th {\n  text-align: left; padding: 10px 12px;\n  background: #f8fafc; color: #64748b;\n  font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;\n  border-bottom: 1.5px solid #e2e8f0;\n}\n.wt-table td {\n  padding: 10px 12px; border-bottom: 1px solid #f1f5f9; vertical-align: middle;\n}\n.wt-table tr:last-child td { border-bottom: none; }\n.wt-table tr:hover td { background: #f8fafc; }\n.wt-empty { text-align: center; color: #94a3b8; padding: 28px !important; font-style: italic; }\n\n/* Inline edit inputs */\n.wt-inline-input {\n  padding: 5px 8px; border: 1px solid #93c5fd; border-radius: 6px;\n  font-size: 13px; width: 100%;\n}\n.rank-input { width: 64px !important; text-align: center; }\n\n/* Rank badge */\n.rank-badge {\n  display: inline-block; background: #eff6ff; color: #1d4ed8;\n  border: 1px solid #bfdbfe; font-size: 12px; font-weight: 700;\n  padding: 2px 9px; border-radius: 20px; min-width: 36px; text-align: center;\n}\n.count-chip {\n  display: inline-block; background: #f0fdf4; color: #166534;\n  border: 1px solid #bbf7d0; font-size: 12px; font-weight: 600;\n  padding: 2px 9px; border-radius: 20px;\n}\n\n/* Add row */\n.wt-add-row {\n  display: flex; gap: 8px; align-items: center; margin-top: 14px;\n  padding-top: 14px; border-top: 1px solid #f1f5f9;\n}\n.wt-add-input {\n  flex: 1; padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px;\n}\n.wt-add-input:focus { outline: none; border-color: #3b82f6; }\n\n/* Employee table specifics */\n.wt-emp-table .col-num { width: 40px; color: #94a3b8; font-size: 12px; }\n.wt-emp-table .col-bool { width: 90px; text-align: center; font-size: 13px; font-weight: 600; color: #475569; }\n.bool-yes { color: #16a34a; font-weight: 700; font-size: 16px; }\n.emp-name { font-weight: 600; color: #1e293b; }\n.emp-teams-tiny { font-size: 11px; color: #94a3b8; margin-top: 2px; }\n.pos-badge {\n  display: inline-block; background: #eff6ff; color: #1d4ed8;\n  border: 1px solid #bfdbfe; font-size: 12px; font-weight: 600;\n  padding: 2px 10px; border-radius: 20px;\n}\n.pos-text { color: #475569; font-size: 13px; }\n.status-active  { color: #16a34a; font-size: 12px; font-weight: 600; }\n.status-inactive{ color: #ef4444; font-size: 12px; font-weight: 600; }\n.row-inactive td { opacity: .55; }\n.position-actions { display: flex; gap: 6px; align-items: center; }\n.emp-actions { display: flex; gap: 6px; flex-wrap: wrap; justify-content: flex-end; }\n\n/* Icon buttons */\n.btn-icon-edit  { background: #eff6ff; border: 1px solid #bfdbfe; color: #3b82f6; border-radius: 6px; padding: 4px 8px; cursor: pointer; font-size: 14px; }\n.btn-icon-remove{ background: #fff1f2; border: 1px solid #fecdd3; color: #e11d48; border-radius: 6px; padding: 4px 8px; cursor: pointer; font-size: 14px; }\n.btn-icon-cal   { background: #f0fdf4; border: 1px solid #bbf7d0; color: #16a34a; border-radius: 6px; padding: 4px 8px; cursor: pointer; font-size: 14px; }\n.btn-icon-edit:hover   { background: #dbeafe; }\n.btn-icon-remove:hover { background: #ffe4e6; }\n.btn-icon-cal:hover    { background: #dcfce7; }\n\n/* Text buttons for positions */\n.btn-text-edit  { background: #eff6ff; border: 1px solid #bfdbfe; color: #3b82f6; border-radius: 6px; padding: 5px 12px; cursor: pointer; font-size: 13px; font-weight: 500; margin-right: 6px; }\n.btn-text-remove{ background: #fff1f2; border: 1px solid #fecdd3; color: #e11d48; border-radius: 6px; padding: 5px 12px; cursor: pointer; font-size: 13px; font-weight: 500; }\n.btn-text-calendar{ background: #f0fdf4; border: 1px solid #bbf7d0; color: #16a34a; border-radius: 6px; padding: 5px 12px; cursor: pointer; font-size: 13px; font-weight: 500; margin-right: 6px; }\n.btn-text-edit:hover   { background: #dbeafe; }\n.btn-text-remove:hover { background: #ffe4e6; }\n.btn-text-calendar:hover { background: #dcfce7; }\n\n.btn-xs { padding: 3px 7px !important; font-size: 12px !important; }\n.btn-success { background: #22c55e; color: #fff; border: none; border-radius: 6px; padding: 6px 12px; cursor: pointer; font-size: 13px; }\n.btn-success:hover { background: #16a34a; }\n.btn-nav { background: none; border: 1px solid #e2e8f0; color: #475569; border-radius: 6px; padding: 3px 10px; cursor: pointer; font-size: 16px; line-height: 1; }\n.btn-nav:hover { background: #f1f5f9; }\n\n/* ─── Team cards ─────────────────────────────────────────────── */\n.team-cards-grid {\n  display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 16px;\n  margin-top: 16px;\n}\n.team-card-v2 {\n  background: #fff; border: 1.5px solid #e2e8f0; border-radius: 12px; overflow: hidden;\n  display: flex; flex-direction: column;\n}\n.team-card-header {\n  display: flex; align-items: flex-start; padding: 14px 16px; background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0; gap: 8px;\n}\n.team-name-block { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 0; }\n.team-name-v2 { font-size: 15px; font-weight: 700; color: #1e293b; }\n.team-desc-v2 { font-size: 12px; color: #64748b; }\n.team-card-actions { display: flex; gap: 4px; }\n.team-member-count {\n  padding: 4px 16px; font-size: 11px; color: #94a3b8; font-weight: 600;\n  background: #f8fafc; border-bottom: 1px solid #f1f5f9;\n  text-transform: uppercase; letter-spacing: .04em;\n}\n.team-members-v2 { padding: 8px 12px; flex: 1; display: flex; flex-direction: column; gap: 6px; }\n.member-row-v2 {\n  display: flex; align-items: center; gap: 8px; padding: 7px 8px;\n  background: #f8fafc; border-radius: 8px; border: 1px solid #f1f5f9;\n}\n.member-rank-num {\n  width: 22px; height: 22px; border-radius: 50%; background: #e2e8f0;\n  color: #64748b; font-size: 11px; font-weight: 700;\n  display: flex; align-items: center; justify-content: center; flex-shrink: 0;\n}\n.member-info-v2 { display: flex; flex-direction: column; gap: 1px; flex: 1; min-width: 0; }\n.member-name-v2 { font-weight: 600; font-size: 13px; color: #1e293b; }\n.member-pos-v2  { font-size: 11px; color: #64748b; }\n.member-badges  { display: flex; gap: 4px; align-items: center; }\n.badge { display: inline-flex; align-items: center; justify-content: center;\n  padding: 2px 6px; border-radius: 10px; font-size: 11px; font-weight: 600; }\n.badge--home { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; }\n.badge--age  { background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; }\n.badge--katb { background: #fefce8; color: #a16207; border: 1px solid #fde68a; }\n.badge--off  { background: #f1f5f9; color: #94a3b8; border: 1px solid #e2e8f0; }\n.team-add-member {\n  padding: 8px 12px; border-top: 1px solid #f1f5f9;\n}\n.team-add-member select {\n  width: 100%; padding: 7px 10px; border: 1px dashed #93c5fd;\n  border-radius: 8px; font-size: 13px; color: #3b82f6; background: #f8fbff; cursor: pointer;\n}\n.edit-form-inline { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; width: 100%; }\n.edit-form-inline input {\n  padding: 5px 8px; border: 1px solid #93c5fd; border-radius: 6px; font-size: 13px; flex: 1; min-width: 80px;\n}\n\n/* ─── Vacation drawer ────────────────────────────────────────── */\n.vac-drawer {\n  background: #fff; border-radius: 14px; padding: 0;\n  width: 420px; max-width: 96vw; max-height: 90vh;\n  overflow-y: auto; display: flex; flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0,0,0,.18);\n}\n.vac-drawer-header {\n  display: flex; justify-content: space-between; align-items: flex-start;\n  padding: 18px 20px 14px; background: #1e293b; border-radius: 14px 14px 0 0;\n  position: sticky; top: 0; z-index: 1;\n}\n.vac-drawer-title {\n  display: block; font-size: 11px; font-weight: 700; color: #94a3b8;\n  text-transform: uppercase; letter-spacing: .07em; margin-bottom: 2px;\n}\n.vac-drawer-name { font-size: 16px; font-weight: 700; color: #f1f5f9; }\n.vac-drawer-header .modal-close {\n  background: rgba(255,255,255,.1); color: #cbd5e1; border: none;\n  border-radius: 6px; padding: 4px 9px; font-size: 15px; cursor: pointer;\n}\n\n/* Calendar section */\n.vac-cal-section { padding: 14px 16px; border-bottom: 1px solid #f1f5f9; }\n.vac-cal-nav {\n  display: flex; align-items: center; justify-content: space-between;\n  margin-bottom: 8px;\n}\n.vac-cal-label { font-size: 13px; font-weight: 700; color: #1e293b; }\n.vac-cal-legend { display: flex; align-items: center; font-size: 11px; color: #64748b; margin-bottom: 8px; gap: 4px; }\n.vac-legend-dot {\n  display: inline-block; width: 10px; height: 10px; border-radius: 50%;\n}\n.vac-legend-dot.vac-approved { background: #22c55e; }\n.vac-legend-dot.vac-pending  { background: #f59e0b; }\n.vac-cal-grid {\n  display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px;\n}\n.vac-cal-head {\n  text-align: center; font-size: 10px; font-weight: 700; color: #94a3b8;\n  padding: 3px 0; text-transform: uppercase;\n}\n.vac-cal-day {\n  text-align: center; padding: 5px 0; border-radius: 6px;\n  font-size: 12px; font-weight: 500; color: #1e293b;\n  transition: background .1s;\n}\n.vac-cal-day.out-month  { color: #cbd5e1; }\n.vac-cal-day.vac-approved { background: #dcfce7; color: #166534; font-weight: 700; }\n.vac-cal-day.vac-pending  { background: #fef9c3; color: #92400e; font-weight: 700; }\n.vac-cal-day.vac-cal-clickable { cursor: pointer; }\n.vac-cal-day.vac-cal-clickable:hover { background: #e0e7ff; color: #3730a3; }\n.vac-cal-day.sel-start { background: #3b82f6; color: #fff; font-weight: 700; border-radius: 6px 0 0 6px; }\n.vac-cal-day.sel-end   { background: #3b82f6; color: #fff; font-weight: 700; border-radius: 0 6px 6px 0; }\n.vac-cal-day.sel-range { background: #bfdbfe; color: #1e3a8a; border-radius: 0; }\n/* Hint & preview */\n.vac-cal-hint {\n  font-size: 12px; color: #64748b; text-align: center;\n  padding: 4px 0 6px; min-height: 22px;\n}\n.vac-sel-preview { color: #1e40af; display: flex; align-items: center; gap: 6px; justify-content: center; }\n.vac-btn-clear {\n  background: none; border: none; cursor: pointer; color: #94a3b8;\n  font-size: 13px; padding: 0 2px; line-height: 1;\n}\n.vac-btn-clear:hover { color: #ef4444; }\n\n/* Vacation list */\n.vac-list-section { padding: 14px 16px; border-bottom: 1px solid #f1f5f9; }\n.vac-section-title { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: .07em; margin: 0 0 10px; }\n.vac-group-label {\n  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em;\n  padding: 2px 8px; border-radius: 4px; display: inline-block; margin: 8px 0 4px;\n}\n.vac-group-label.approved { background: #dcfce7; color: #166534; }\n.vac-group-label.pending  { background: #fef9c3; color: #92400e; }\n.vac-item {\n  display: flex; align-items: center; gap: 8px; padding: 7px 10px;\n  border-radius: 8px; margin-bottom: 4px; border: 1px solid transparent;\n}\n.vac-item--approved { background: #f0fdf4; border-color: #bbf7d0; }\n.vac-item--pending  { background: #fffbeb; border-color: #fde68a; }\n.vac-item-dates { display: flex; align-items: center; gap: 4px; font-size: 13px; font-weight: 600; flex: 1; }\n.vac-dash { color: #94a3b8; }\n.vac-item-notes { font-size: 11px; color: #64748b; max-width: 100px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }\n.vac-item-actions { display: flex; gap: 4px; margin-left: auto; }\n.vac-btn-approve { background: #22c55e; color: #fff; border: none; border-radius: 6px; padding: 4px 9px; font-size: 13px; font-weight: 700; cursor: pointer; }\n.vac-btn-approve:hover { background: #16a34a; }\n.vac-btn-reject  { background: #f59e0b; color: #fff; border: none; border-radius: 6px; padding: 4px 9px; font-size: 13px; font-weight: 700; cursor: pointer; }\n.vac-btn-reject:hover { background: #d97706; }\n.no-data-text { color: #94a3b8; font-size: 13px; font-style: italic; }\n\n/* Add vacation form */\n.vac-add-section { padding: 14px 16px; }\n.vac-add-form { display: flex; flex-direction: column; gap: 8px; }\n.vac-add-form label {\n  display: flex; flex-direction: column; gap: 4px;\n  font-size: 12px; font-weight: 600; color: #64748b;\n}\n.vac-add-form input, .vac-add-form select {\n  padding: 7px 10px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px;\n  background: #fff;\n}\n.vac-add-form input:focus, .vac-add-form select:focus { outline: none; border-color: #3b82f6; }\n\n.vac-type-badge {\n  display: inline-flex; align-items: center; justify-content: center;\n  min-width: 31px; padding: 2px 6px; border-radius: 5px;\n  font-size: 10px; font-weight: 800; line-height: 1.4; white-space: nowrap;\n  background: #dbeafe; color: #1e40af;\n}\n.vac-type-badge--NN { background: #fee2e2; color: #991b1b; }\n.vac-type-badge--UNŻ { background: #f3e8ff; color: #6b21a8; }\n.vac-type-badge--L4 { background: #fef3c7; color: #92400e; }\n.vac-type-badge--SW { background: #cffafe; color: #155e75; }\n.vac-type-badge--ST { background: #ffe4e6; color: #9f1239; }\n.vac-type-badge--UB { background: #e2e8f0; color: #334155; }\n.vac-type-label { font-size: 12px; color: #475569; white-space: nowrap; }\n\n/* ─── Employee modal overrides ───────────────────────────────── */\n.modal-box--sm { max-width: 500px; }\n.modal-box--employee { max-width: 760px; }\n.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 14px; }\n.form-grid label {\n  display: flex; flex-direction: column; gap: 4px;\n  font-size: 12px; font-weight: 600; color: #64748b;\n}\n.form-grid input, .form-grid select {\n  padding: 8px 10px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px; background: #fff;\n}\n.form-grid input:focus, .form-grid select:focus { outline: none; border-color: #3b82f6; }\n.emp-toggle-row {\n  display: flex; flex-wrap: wrap; gap: 14px;\n  padding-top: 12px; border-top: 1px solid #f1f5f9;\n}\n\n.employee-vacation-rates {\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.employee-vacation-rates-heading h4 {\n  margin: 0 0 3px;\n  color: #1e293b;\n  font-size: 14px;\n}\n\n.employee-vacation-rates-heading p {\n  margin: 0 0 12px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.employee-vacation-rates-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 14px;\n}\n\n.employee-vacation-rates-grid > label {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  color: #334155;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.employee-vacation-rate-input {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n}\n\n.employee-vacation-rate-input:focus-within {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgb(59 130 246 / 12%);\n}\n\n.employee-vacation-rate-input input {\n  min-width: 0;\n  width: 100%;\n  padding: 8px 9px;\n  border: 0;\n  outline: 0;\n}\n\n.employee-vacation-rate-input > span {\n  flex: 0 0 auto;\n  padding-right: 9px;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.employee-vacation-rate-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px 5px;\n  color: #94a3b8;\n  font-size: 11px;\n}\n\n.employee-vacation-rate-summary span {\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #ecfdf5;\n  color: #047857;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n@media (max-width: 640px) {\n  .employee-vacation-rates-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.toggle-label {\n  display: flex; align-items: center; gap: 6px;\n  font-size: 13px; color: #374151; cursor: pointer;\n}\n.toggle-label input[type=\"checkbox\"] { width: 15px; height: 15px; cursor: pointer; }\n\n/* ─── Vacation conflict warning banner (in assignment modal) ─ */\n.vacation-conflict-banner {\n  background: #fffbeb; border: 1.5px solid #f59e0b;\n  border-radius: 10px; padding: 12px 14px; margin: 10px 0;\n}\n.vacation-conflict-title {\n  font-size: 13px; font-weight: 700; color: #92400e; margin-bottom: 8px;\n}\n.vacation-conflict-list {\n  margin: 0 0 10px 16px; padding: 0;\n  font-size: 13px; color: #78350f; display: flex; flex-direction: column; gap: 4px;\n}\n.vacation-conflict-close {\n  background: #f59e0b; color: #fff; border: none; border-radius: 6px;\n  padding: 5px 14px; font-size: 12px; font-weight: 600; cursor: pointer;\n}\n.vacation-conflict-close:hover { background: #d97706; }\n\n/* ─── Drag & drop styles (replaced with arrow buttons) ──────── */\n.position-arrows {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n}\n.btn-arrow {\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n.btn-arrow:hover:not(:disabled) {\n  background: #e2e8f0;\n  border-color: #94a3b8;\n  color: #1e293b;\n}\n.btn-arrow:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n/* ─── Upcoming Vacations Section ─────────────────────────────── */\n.vacations-list {\n  border-top: 2px solid #e2e8f0;\n  padding-top: 24px;\n}\n.vacations-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 16px 0;\n}\n.vacations-tabs {\n  display: flex; gap: 6px; margin-bottom: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n.vacations-tab {\n  border: none; border-bottom: 2px solid transparent; background: transparent;\n  color: #64748b; cursor: pointer; font-size: 15px; font-weight: 600;\n  margin-bottom: -1px; padding: 8px 12px;\n}\n.vacations-tab:hover { color: #1e293b; }\n.vacations-tab.active { border-bottom-color: #2563eb; color: #1d4ed8; }\n.vacation-month-row td {\n  padding: 9px 12px;\n  border-top: 2px solid #cbd5e1;\n  border-bottom: 1px solid #cbd5e1;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n}\n.vacation-export-panel {\n  display: inline-flex;\n  align-items: flex-end;\n  gap: 14px;\n  width: fit-content;\n  max-width: 100%;\n  margin-bottom: 18px;\n  padding: 10px 12px;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  background: #eff6ff;\n  flex-wrap: wrap;\n}\n.vacation-export-heading {\n  display: flex;\n  flex: 0 1 250px;\n  flex-direction: column;\n  gap: 3px;\n}\n.vacation-export-heading strong { color: #1e3a8a; font-size: 13px; }\n.vacation-export-heading span { color: #64748b; font-size: 12px; }\n.vacation-export-controls {\n  display: grid;\n  grid-template-columns: 142px repeat(2, 124px);\n  align-items: flex-end;\n  gap: 8px;\n}\n.vacation-export-controls label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 700;\n}\n.vacation-export-controls input {\n  min-height: 34px;\n  padding: 6px 9px;\n  border: 1px solid #93c5fd;\n  border-radius: 7px;\n  background: #fff;\n  color: #1e293b;\n  font: inherit;\n  font-size: 12px;\n}\n.vacation-export-controls input:focus {\n  outline: 2px solid #60a5fa;\n  outline-offset: 1px;\n}\n.vacation-export-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 124px;\n  min-height: 34px;\n  padding-right: 10px;\n  padding-left: 10px;\n  white-space: nowrap;\n}\n.vacation-export-error {\n  flex-basis: 100%;\n  color: #b91c1c;\n  font-size: 12px;\n  font-weight: 600;\n}\n.vacations-empty {\n  color: #94a3b8;\n  font-size: 14px;\n  font-style: italic;\n  text-align: center;\n  padding: 24px;\n}\n\n@media (max-width: 900px) {\n  .vacation-export-panel {\n    align-items: stretch;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .vacation-export-heading {\n    flex-basis: auto;\n  }\n\n  .vacation-export-controls {\n    grid-template-columns: minmax(142px, 1fr) repeat(2, 124px);\n    width: 100%;\n  }\n}\n\n@media (max-width: 560px) {\n  .vacation-export-controls {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .vacation-export-controls label {\n    grid-column: 1 / -1;\n  }\n\n  .vacation-export-button {\n    width: 100%;\n  }\n}\n\n/* ─── Equipment / logistics flags (Planowanie modal) ─────────── */\n.equipment-flags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 16px;\n  margin-top: 14px;\n  padding: 10px 12px;\n  background: #f0f7ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n}\n.equipment-flags-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1e40af;\n  width: 100%;\n  margin-bottom: 2px;\n}\n.equipment-flag-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: #334155;\n  cursor: pointer;\n  user-select: none;\n}\n.equipment-flag-item input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  accent-color: #3b82f6;\n}\n\n/* ─── Split Installation Modal (suma obwodów > 80) ─────────── */\n.split-calendar {\n  margin-top: 12px;\n}\n\n.split-calendar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding: 0 8px;\n}\n\n.split-calendar-month {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.selected-date {\n  background: #3b82f6 !important;\n  color: white !important;\n  font-weight: 600;\n}\n\n.vac-cal-day.selected-date:hover {\n  background: #2563eb !important;\n}\n\n/* ─── Team Rows View (Ekipy) ───────────────────────────────── */\n.team-rows-view {\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1.5px solid #d1d5db;\n  border-radius: 12px;\n  overflow: visible;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.hidden-teams-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  padding: 9px 12px;\n  background: #f8fafc;\n  border-bottom: 1px solid #d1d5db;\n  border-radius: 10px 10px 0 0;\n}\n\n.hidden-teams-label {\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.hidden-team-button,\n.show-all-teams-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #334155;\n  padding: 4px 9px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.hidden-team-button:hover,\n.show-all-teams-button:hover {\n  border-color: #2563eb;\n  color: #1d4ed8;\n  background: #eff6ff;\n}\n\n.hidden-team-button:disabled,\n.show-all-teams-button:disabled {\n  cursor: wait;\n  opacity: 0.55;\n}\n\n.show-all-teams-button {\n  color: #1d4ed8;\n  margin-left: auto;\n}\n\n.team-rows-header {\n  display: grid;\n  grid-template-columns: 150px repeat(7, 1fr);\n  background: #f9fafb;\n  border-bottom: 2px solid #d1d5db;\n  border-radius: 10px 10px 0 0;\n  position: sticky;\n  top: 60px;\n  z-index: 20;\n  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.12);\n}\n\n.team-name-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 8px;\n  font-weight: 700;\n  font-size: 13px;\n  color: #374151;\n  border-right: 1.5px solid #d1d5db;\n  text-align: center;\n  background: #f9fafb;\n}\n\n.team-day-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 8px;\n  border-right: 1.5px solid #d1d5db;\n  transition: background 0.12s;\n}\n\n.team-day-header.today {\n  background: #eff6ff;\n}\n\n.team-day-header:last-child {\n  border-right: none;\n}\n\n.team-day-name {\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 5px;\n}\n\n.team-day-header.today .team-day-name { color: #2563eb; }\n\n.team-day-num {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.team-rows-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.team-row {\n  display: grid;\n  grid-template-columns: 150px repeat(7, 1fr);\n  border-bottom: 1.5px solid #d1d5db;\n  transition: background 0.12s;\n}\n\n.team-row:hover {\n  background: #f9fafb;\n}\n\n.team-row:last-child {\n  border-bottom: none;\n}\n\n.team-row.unassigned-row {\n  background: #fffbeb;\n}\n\n.team-row.unassigned-row:hover {\n  background: #fef3c7;\n}\n\n.team-row .team-name-cell {\n  background: #f3f4f6;\n  font-weight: 700;\n  font-size: 13px;\n  color: #1f2937;\n  border-right: 2px solid #d1d5db;\n  position: relative;\n}\n\n.team-row.unassigned-row .team-name-cell {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.team-name-label {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  padding: 0 4px;\n}\n\n.hide-team-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  margin-left: 3px;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.hide-team-button:hover {\n  border-color: #cbd5e1;\n  background: #ffffff;\n  color: #1d4ed8;\n}\n\n.hide-team-button:disabled {\n  cursor: wait;\n  opacity: 0.45;\n}\n\n.team-day-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px;\n  min-height: 80px;\n  border-right: 1.5px solid #d1d5db;\n  overflow-y: auto;\n  max-height: 200px;\n  transition: background 0.12s;\n}\n\n.team-day-cell:hover {\n  background: #f9fafb;\n}\n\n.team-row.unassigned-row .team-day-cell:hover {\n  background: #fef9e7;\n}\n\n.team-day-cell:last-child {\n  border-right: none;\n}\n\n.team-day-cell.drag-over {\n  background: #dbeafe !important;\n  outline: 2px dashed #3b82f6;\n  outline-offset: -2px;\n  box-shadow: inset 0 0 10px rgba(59, 130, 246, 0.15);\n  transition: all 0.2s ease;\n}\n\n/* Make cards smaller in team view */\n.team-rows-view .card {\n  font-size: 11px;\n  padding: 6px 8px;\n  min-height: auto;\n}\n\n.team-rows-view .card-header {\n  margin-bottom: 4px;\n}\n\n.team-rows-view .card-title {\n  font-size: 11px;\n}\n\n.team-rows-view .card-badges {\n  gap: 3px;\n}\n\n.team-rows-view .card-badge {\n  padding: 1px 4px;\n  font-size: 9px;\n}\n\n.team-rows-view .card-equipment {\n  gap: 3px;\n  margin-top: 4px;\n}\n\n.team-rows-view .card-equipment-badge {\n  padding: 1px 3px;\n  font-size: 8px;\n}\n\n/* ─── Settlement section ──────────────────────────────────── */\n.settlement-section {\n  margin-top: 24px;\n  padding: 20px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border: 2px solid #86efac;\n  border-radius: 12px;\n}\n\n.settlement-section h4 {\n  margin: 0 0 16px;\n  font-size: 16px;\n  color: #166534;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.settlement-summary {\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.saved-final-additions {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: linear-gradient(145deg, #ffffff 0%, #fffbeb 100%);\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);\n  container-name: saved-final-additions;\n  container-type: inline-size;\n}\n\n.saved-final-additions-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.saved-final-additions-heading > div {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 0;\n  gap: 2px;\n}\n\n.saved-final-additions-heading > div > strong {\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.saved-final-additions-heading > div > span {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.saved-final-additions-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 25px;\n  height: 23px;\n  padding: 0 8px;\n  color: #92400e;\n  background: #fef3c7;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.saved-final-additions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.saved-final-addition-row {\n  width: 100%;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  color: #374151;\n  font-size: 13px;\n  overflow: hidden;\n}\n\n.saved-final-addition-context {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  padding: 8px 11px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.saved-final-addition-date {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 0;\n  color: #475569;\n}\n\n.saved-final-addition-date svg {\n  flex: 0 0 auto;\n  color: #64748b;\n}\n\n.saved-final-addition-date strong {\n  color: #334155;\n  font-size: 11px;\n}\n\n.saved-final-addition-date > span {\n  padding: 1px 7px;\n  color: #475569;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 650;\n}\n\n.saved-final-addition-session {\n  color: #64748b;\n  font-size: 10px;\n  overflow-wrap: anywhere;\n}\n\n.saved-final-addition-details {\n  display: grid;\n  grid-template-columns: minmax(140px, 1.25fr) minmax(95px, 0.75fr) 18px minmax(105px, 0.85fr);\n  gap: 7px;\n  align-items: stretch;\n  padding: 9px 11px;\n}\n\n.saved-final-addition-person {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n}\n\n.saved-final-addition-person-icon {\n  display: inline-flex;\n  flex: 0 0 27px;\n  align-items: center;\n  justify-content: center;\n  width: 27px;\n  height: 27px;\n  color: #475569;\n  background: #f1f5f9;\n  border-radius: 50%;\n}\n\n.saved-final-addition-person > span:last-child,\n.saved-final-addition-metric {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 2px;\n}\n\n.saved-final-addition-person small,\n.saved-final-addition-metric small {\n  color: #64748b;\n  font-size: 9px;\n  font-weight: 650;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.saved-final-addition-person strong {\n  color: #1f2937;\n  font-size: 12px;\n  overflow-wrap: anywhere;\n}\n\n.saved-final-addition-metric {\n  justify-content: center;\n  padding: 5px 8px;\n  border-radius: 7px;\n}\n\n.saved-final-addition-metric strong {\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.saved-final-addition-metric.is-addition {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n}\n\n.saved-final-addition-metric.is-addition strong {\n  color: #c2410c;\n}\n\n.saved-final-addition-metric.is-total {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n}\n\n.saved-final-addition-metric.is-total strong {\n  color: #15803d;\n}\n\n.saved-final-addition-arrow {\n  align-self: center;\n  color: #94a3b8;\n  font-size: 15px;\n  text-align: center;\n}\n\n@container saved-final-additions (max-width: 600px) {\n  .saved-final-addition-details {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .saved-final-addition-person {\n    grid-column: 1 / -1;\n    padding-bottom: 4px;\n  }\n\n  .saved-final-addition-arrow {\n    display: none;\n  }\n}\n\n@container saved-final-additions (max-width: 400px) {\n  .saved-final-additions {\n    padding: 13px;\n  }\n\n  .saved-final-addition-details {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .saved-final-addition-person {\n    grid-column: auto;\n  }\n}\n\n.settlement-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.settlement-row:last-child {\n  border-bottom: none;\n  padding-top: 12px;\n  margin-top: 4px;\n  border-top: 2px solid #86efac;\n}\n\n.settlement-highlight {\n  color: #16a34a;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.settlement-workers {\n  min-width: 0;\n  overflow: hidden;\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.settlement-workers h5 {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.settlement-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.settlement-table th:nth-child(1) { width: 22%; }\n.settlement-table th:nth-child(2) { width: 24%; }\n.settlement-table th:nth-child(3) { width: 11%; }\n.settlement-table th:nth-child(4) { width: 14%; }\n.settlement-table th:nth-child(5) { width: 29%; }\n\n.settlement-table th {\n  background: #f8fafc;\n  padding: 9px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #475569;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.settlement-table td {\n  padding: 9px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #374151;\n  overflow-wrap: anywhere;\n}\n\n.settlement-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.settlement-table .numeric-cell {\n  text-align: right;\n}\n\n.settlement-table .settlement-amount {\n  font-weight: 700;\n  color: #16a34a;\n  font-size: 14px;\n}\n\n.settlement-amount-breakdown {\n  display: inline-flex;\n  align-items: flex-end;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.settlement-amount-breakdown strong {\n  color: #16a34a;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.settlement-amount-breakdown small,\n.settlement-manual-final-amount {\n  color: #b45309;\n  font-size: 10px;\n  font-weight: 650;\n  line-height: 1.2;\n  text-align: right;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.settlement-manual-final-amount {\n  display: block;\n  margin-top: 4px;\n}\n\n.settlement-loading {\n  margin-top: 16px;\n  padding: 16px;\n  text-align: center;\n  color: #64748b;\n  font-style: italic;\n  font-size: 14px;\n}\n\n/* Installation list pagination */\n.list-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 8px 0;\n  font-size: 13px;\n}\n\n.list-pagination-range {\n  margin-right: auto;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
